webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "globalStore", function() { return globalStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_strap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_strap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_scroll__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_application_insights__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_application_insights___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_application_insights__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resources_translations_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_assignPolyfill_js__ = __webpack_require__(61);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared_assignPolyfill_js__["a" /* default */])();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_application_insights___default.a, {
    id: "d03809e5-2ce3-492d-aa9b-d67151d7cd1e",
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_6_vue_select___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].appInsights.queue.push(function () {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].appInsights.context.addTelemetryInitializer(function (envelope) {
        if (envelope.data != null && envelope.data.baseData != null && envelope.data.baseData.url != null && envelope.data.baseData.url.indexOf("createPassword") != -1) {
            envelope.data.baseData.url = "/createPassword";
            envelope.data.baseData.name = "(Application Root)/createPassword";
        }
    });
});

var globalStore = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    data: {
        host: "https://id.mayr-melnhof.com/MMID.API/",
        digiUrl: "https://digi.mm-karton.com/",
        mmpUrl: "https://digi.mm-packaging.com/",
        envName: "",
        isInfoShown: false,
        message: '',
        type: '',
        culture: {
            locale: "EN",
            strings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__resources_translations_js__["a" /* default */])("EN"),
            languages: [{ code: "BG", countryCode: "BG", title: "Български" }, { code: "DE", countryCode: "DE", title: "Deutsch" }, { code: "EN", countryCode: "EN", title: "English" }, { code: "ES", countryCode: "ES", title: "Español" }, { code: "FR", countryCode: "FR", title: "Français" }, { code: "IT", countryCode: "IT", title: "Italiano" }, { code: "NL", countryCode: "NL", title: "Nederlands" }, { code: "RU", countryCode: "RU", title: "Русский" }, { code: "SL", countryCode: "SL", title: "Slovenščina" }, { code: "PL", countryCode: "PL", title: "Polski" }, { code: "CS", countryCode: "CZ", title: "Čeština" }],
            getCountryCode: function getCountryCode(code) {
                for (var k = 0; k < globalStore.culture.languages.length; k++) {
                    if (globalStore.culture.languages[k].code === code) {
                        return globalStore.culture.languages[k].countryCode;
                    }
                }
            }
        },
        openedPoint: '',
        openedSubPoint: '',
        dashBoardDigiLinks: [{ Group: "MM_Digi", Url: "https://digi.mm-karton.com", Title: "Prod" }, { Group: "MM_Digi_Demo", Url: "https://digi-demo.mm-karton.com", Title: "Demo" }, { Group: "MM_Digi_Test", Url: "https://digi-test.mm-karton.com", Title: "Test" }, { Group: "MM_Digi_Dev", Url: "http://srv-dev-digid01.mmk.mmdom.net:8080/mmkdigi", Title: "Dev" }],
        dashBoardMMPLinks: [{ Group: "MMP_Digi", Url: "https://digi.mm-packaging.com", Title: "Prod" }, { Group: "MMP_Digi_Demo", Url: "https://digi-demo.mm-packaging.com", Title: "Demo" }, { Group: "MMP_Digi_Test", Url: "https://digi-test.mm-packaging.com", Title: "Test" }, { Group: "MMP_Digi_Dev", Url: "https://digi-dev.mm-packaging.com", Title: "Dev" }],
        userExtranetGroup: 'MM_SP_external',
        userListGroups: [],
        currentUserRoles: [],
        showInfo: function showInfo(event, message, type, timeout) {
            if (event) {
                event.preventDefault();
            }
            globalStore.type = 'alert alert-' + type;
            globalStore.message = message;
            globalStore.isInfoShown = true;
            var infoTimeOut = 2500;
            if (!!timeout) {
                infoTimeOut = timeout;
            }
            setTimeout(function () {
                return globalStore.isInfoShown = false;
            }, infoTimeOut);
        },
        showChangePassword: function showChangePassword(event, text, subText, router) {
            if (this.openedSubPoint != subText) {
                router.push('/dashboard/changePassword');
            }
            globalStore.openedPoint = text;
            globalStore.openedSubPoint = subText;
        },
        showUsersList: function showUsersList(event, text, subText, router) {
            //if (this.openedSubPoint != subText){
            router.push('/dashboard/userslist');
            //}
            globalStore.openedPoint = text;
            globalStore.openedSubPoint = subText;
        },
        isCurrentUserAdmin: false,
        isCurrentUserMMPWM: false,
        isCurrentUserMMPWM_Admin: false,
        currentUserDisplayName: '',
        checkRoles: function checkRoles() {
            this.currentUserRoles = [];
            this.currentUserDisplayName = '';
            if (this.$session.exists()) {
                var user = this.$session.get('user');
                if (user) {
                    globalStore.isCurrentUserAdmin = false;
                    globalStore.isCurrentUserMMPWM = false;
                    globalStore.isCurrentUserMMPWM_Admin = false;
                    if (user.Roles.indexOf('Administrator') > -1) {
                        globalStore.isCurrentUserAdmin = true;
                    }
                    if (user.Roles.indexOf('MMPWM_Admin') > -1 || user.Roles.indexOf('MMPWM_HR') > -1 || user.Roles.indexOf('MMPWM_Servicecenter') > -1) {
                        globalStore.isCurrentUserMMPWM = true;
                        globalStore.isCurrentUserMMPWM_Admin = user.Roles.indexOf('MMPWM_Admin') > -1;
                    }
                    this.currentUserRoles = user.Roles;
                    this.currentUserDisplayName = user.Name;
                }
            }
        },
        currentUserAvatar: null,
        checkCurrentUserAvatar: function checkCurrentUserAvatar() {
            if (this.$session.exists()) {
                var user = this.$session.get('user');
                if (user) {
                    if (user.Photo) {
                        globalStore.currentUserAvatar = 'data:image/jpeg;base64,' + user.Photo;
                    } else {
                        globalStore.currentUserAvatar = null;
                    }
                }
            }
        },
        useCurrentUserLocale: function useCurrentUserLocale() {
            var lang = null;
            if (this.$session.exists()) {
                var user = this.$session.get('user');
                if (user) {
                    lang = user.PreferredLanguage;
                }
            } else {
                var nav = window.navigator;
                if (nav.userLanguage) {
                    lang = nav.userLanguage;
                } else if (nav.language) {
                    lang = nav.language;
                } else if (nav.systemLanguage) {
                    lang = nav.systemLanguage;
                }
            }
            if (lang == null) {
                lang = "EN";
            } else {
                try {
                    lang = lang.substring(0, 2).toUpperCase();
                } catch (exc) {
                    lang = "EN";
                }
            }

            globalStore.culture.locale = lang;
            globalStore.culture.strings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__resources_translations_js__["a" /* default */])(lang);
        },
        isFiltersActive: false,
        strongRegex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{10,})"),
        mediumRegex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])"),
        weakRegex: new RegExp("^(?=.*[a-z])(?=.*[A-Z])"),
        domainsBlackList: ['@cartprint.ch', '@firgos.com.my', '@free-com.at', '@keminer-remmers.de', '@mayr-melnhof.co.at', '@mayr-melnhof.com', '@mayrmelnhof.onmicrosoft.com', '@mm-ekbal.com', '@mm-graphia.com', '@mm-karton.com', '@mm.group', '@tanngroup.com', '@kotkamills.com', '@kwidzyn.com', '@mm-marinetti.com', '@mm-packaging.com', '@mmp-malaysia.com', '@mm-pof.com', '@neupack.at', '@pacproject.com', '@ppc-trier.com', '@runds-stanzformen.de', '@ekman-irl.com'],
        emailInBlackList: function emailInBlackList(email) {
            var result = false;
            this.domainsBlackList.forEach(function (item) {
                if (email && email.toLowerCase().indexOf(item) > -1) {
                    result = true;
                }
            });
            return result;
        },
        defaultTitle: 'MM-ID',
        backLinkDomains: ['^(http(s)?\:\/\/)?(www\.)?mm\-karton\.com.*', '^(http(s)?\:\/\/)?(www\.)?mm\.group.*', '^(http(s)?\:\/\/)?(www\.)?mm\-boardpaper\.com.*', '^(http(s)?\:\/\/)?(www\.)?mayr\-melnhof\.com.*', '^(http(s)?\:\/\/)?(www\.)?mmdom\.net.*', '^(http(s)?\:\/\/)?(www\.)?srv\-dev\-digid01\.mmk\.mmdom\.net.*', '^(http(s)?\:\/\/)?(www\.)?srv\-dev\-digid02\.mmk\.mmdom\.net.*', '^(http(s)?\:\/\/)?(www\.)?extranet\.mayr\-melnhof\.com.*', '^(http(s)?\:\/\/)?(www\.)?digi\-test\.mm\-karton\.com.*', '^(http(s)?\:\/\/)?(www\.)?digi\-demo\.mm\-karton\.com.*', '^(http(s)?\:\/\/)?(www\.)?digi\-dev\.mm\-karton\.com.*', '^(http(s)?\:\/\/)?(www\.)?digi\.mm\-karton\.com.*', '^(http(s)?\:\/\/)?(www\.)?mm\-packaging\.com.*', '^(http(s)?\:\/\/)?(www\.)?digi\-dev\.mm\-packaging\.com.*', '^(http(s)?\:\/\/)?(www\.)?digi\-test\.mm\-packaging\.com.*', '^(http(s)?\:\/\/)?(www\.)?digi\-demo\.mm\-packaging\.com.*', '^(http(s)?\:\/\/)?(www\.)?digi\.mm\-packaging\.com.*', '^(http(s)?\:\/\/)?(www\.)?srv\-vie\-webappt\.vie\.mm\-karton\.com.*', '^(http(s)?\:\/\/)?(www\.)?localhost.*'],
        isBackLinkAllowed: function isBackLinkAllowed(lnk) {
            return this.backLinkDomains.some(function (itm) {
                var regEx = new RegExp(itm, "i");
                return regEx.test(lnk);
            });
        },
        isDigiUser: function isDigiUser(usr) {
            var user = usr;
            if (user == null) {
                user = this.$session.get('user');
            }
            var groups = user.Groups;
            if (groups) {
                var hasSomeDigiGroup = this.dashBoardDigiLinks.some(function (itm) {
                    return groups.indexOf(itm.Group) > -1;
                });
                return hasSomeDigiGroup;
            }
            return false;
        }
    }
});

__webpack_require__(62).polyfill();
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, '$axios', { value: __WEBPACK_IMPORTED_MODULE_8_axios___default.a });

window.user = { IsLoggedIn: false

    /* eslint-disable no-new */

};new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    session: __WEBPACK_IMPORTED_MODULE_3__session__["default"],
    axios: __WEBPACK_IMPORTED_MODULE_8_axios___default.a,
    template: '<App />',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a, alert: __WEBPACK_IMPORTED_MODULE_4_vue_strap__["alert"] }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#head',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    session: __WEBPACK_IMPORTED_MODULE_3__session__["default"],
    components: {
        alert: __WEBPACK_IMPORTED_MODULE_4_vue_strap__["alert"]
    },
    data: {
        user: window.user,
        envName: globalStore.envName,
        version: '',
        languages: globalStore.culture.languages
    },
    methods: {
        changeCulture: function changeCulture(lang) {
            globalStore.culture.locale = lang;
            globalStore.culture.strings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__resources_translations_js__["a" /* default */])(lang);
        },
        showChangePassword: function showChangePassword(event, text, subText) {
            event.preventDefault();
            globalStore.showChangePassword(event, text, subText, this.$router);
        },
        showUsersList: function showUsersList(event, text, subText) {
            event.preventDefault();
            globalStore.showUsersList(event, text, subText, this.$router);
        },
        createPassword: function createPassword(event) {
            event.preventDefault();
            this.$router.push('createPassword');
        },
        forgotPassword: function forgotPassword(event) {
            event.preventDefault();
            this.$router.push('forgotPassword');
        },
        logout: function logout() {
            this.$session.destroy();
            window.user.IsLoggedIn = false;
            this.$router.push('/login');
        },
        login: function login() {
            this.$router.push('/login');
        },
        hideInfo: function hideInfo(event) {
            event.preventDefault();
            globalStore.isInfoShown = false;
        },
        getCountryCode: function getCountryCode(code) {
            return globalStore.culture.getCountryCode(code);
        }
    },
    computed: {
        showInfo: function showInfo() {
            return globalStore.isInfoShown;
        },
        message: function message() {
            return globalStore.message;
        },
        type: function type() {
            return globalStore.type;
        },
        actionText: function actionText() {
            return this.labels.ACTION_TEXT;
        },
        changePasswordText: function changePasswordText() {
            return this.labels.CHANGE_PASSWORD_TEXT;
        },
        usersListText: function usersListText() {
            return this.labels.USERS_LIST_TEXT;
        },
        currentUserAvatar: function currentUserAvatar() {
            return globalStore.currentUserAvatar;
        },
        isCurrentUserAdmin: function isCurrentUserAdmin() {
            return globalStore.isCurrentUserAdmin;
        },
        isCurrentUserMMPWM: function isCurrentUserMMPWM() {
            return globalStore.isCurrentUserMMPWM;
        },
        isCurrentUserMMPWM_Admin: function isCurrentUserMMPWM_Admin() {
            return globalStore.isCurrentUserMMPWM_Admin;
        },
        labels: function labels() {
            return globalStore.culture.strings.Header;
        },
        culture: function culture() {
            return globalStore.culture.locale;
        },
        currentUserRoles: function currentUserRoles() {
            return globalStore.currentUserRoles;
        },
        currentUserDisplayName: function currentUserDisplayName() {
            return globalStore.currentUserDisplayName;
        }
    },
    beforeCreate: function beforeCreate() {
        /*Vue.appInsights.queue.push(function () {
            Vue.appInsights.context.addTelemetryInitializer(function (envelope) {
                console.log(envelope.name);
                console.log(envelope.data.baseData.url);
                if (envelope.data != null && envelope.data.baseData != null
                        && envelope.data.baseData.url != null 
                        && envelope.data.baseData.url.indexOf("createPassword") != -1) {
                    console.log("hide URL")
                    envelope.data.baseData.url = "/createPassword";
                    envelope.data.baseData.name = "(Application Root)/createPassword";
                }
            });
        });*/

        window.user.IsLoggedIn = this.$session.exists();
        globalStore.checkRoles();
        globalStore.checkCurrentUserAvatar();
        globalStore.useCurrentUserLocale();
        //
        var self = this;
        self.$axios.get(globalStore.host + "Version").then(function (response) {
            if (response.status === 200) {
                self.version = 'v.' + response.data;
            }
        }).catch(function (err) {
            // ignore
        });

        self.$axios.get(globalStore.host + "GetPossibleRoles").then(function (response) {
            if (response.status === 200) {
                globalStore.userListGroups = response.data;
            }
        }).catch(function (err) {
            // ignore
        });
    }
});

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(183),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_translations__ = __webpack_require__(33);




/* harmony default export */ __webpack_exports__["a"] = ({
    labels: function labels() {
        return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.strings.Shared;
    },
    unlockUser: function unlockUser(self, id, successCallback) {
        var _this = this;

        var apiUrl = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + "UnlockUserAccount";

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(apiUrl, { Email: id }, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        }).then(function (response) {
            if (response.status === 200) {
                successCallback();
                __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this.labels().USER_WAS_UNLOCKED, 'success');
            }
        }).catch(function (err) {
            console.log(err);
            if (err.response && err.response.status === 401) {
                self.$session.destroy();
                self.$router.push("/login");
            } else {
                __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this.labels().ERROR_UNLOCK_USER, 'danger');
            }
            return err;
        });
    },
    activateUser: function activateUser(self, id, successCallback) {
        var _this2 = this;

        var apiUrl = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + "EnableUserAccount";

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(apiUrl, { Email: id }, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        }).then(function (response) {
            if (response.status === 200) {
                successCallback();
                __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this2.labels().USER_WAS_ACTIVATED, 'success');
            }
        }).catch(function (err) {
            console.log(err);
            if (err.response && err.response.status === 401) {
                self.$session.destroy();
                self.$router.push("/login");
            } else {
                __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this2.labels().ERROR_USER_ACTIVATION, 'danger');
            }
            return err;
        });
    },
    deactivateUser: function deactivateUser(self, id, successCallback) {
        var _this3 = this;

        var apiUrl = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + "DisableUserAccount";

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(apiUrl, { Email: id }, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        }).then(function (response) {
            if (response.status === 200) {
                successCallback();
                __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this3.labels().USER_WAS_DEACTIVATED, 'success');
            }
        }).catch(function (err) {
            console.log(err);
            if (err.response && err.response.status === 401) {
                self.$session.destroy();
                self.$router.push("/login");
            } else {
                __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this3.labels().ERROR_USER_DEACTIVATION, 'danger');
            }
            return err;
        });
    },
    sendWelcomeEmail: function sendWelcomeEmail(self, id, culture, appType, noPasswd) {
        var _this4 = this;

        var apiUrl = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + "ResendConfirmationEmail";
        if (noPasswd) {
            apiUrl += '?withPasswordLink=false';
        }

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(apiUrl, { Email: id, PreferredLanguage: culture, UserType: appType }, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        }).then(function (response) {
            if (response.status === 200) {
                if (response.data == 'Email was resent successfully') {
                    __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this4.labels().EMAIL_WAS_SENT, 'success');
                } else if (response.data.indexOf('Email was not resent') > -1) {
                    __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this4.labels().EMAIL_NOT_SENT_USER_ACTIVE, 'success');
                } else {
                    __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this4.labels().ERROR_EMAIL_SEND, 'danger');
                    console.log(response.data);
                }
            }
            return response;
        }).catch(function (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status === 401) {
                    self.$session.destroy();
                    self.$router.push("/login");
                } else if (err.response.status === 403) {
                    __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this4.labels().PASSWORD_RESET_TOO_OFTEN, 'danger');
                } else {
                    __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this4.labels().ERROR_EMAIL_SEND, 'danger');
                }
            }
            return err;
        });
    },
    getWelcomeEmailPreview: function getWelcomeEmailPreview(self, id, appType, noPasswd) {
        var apiUrl = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + "GetWelcomeEmailPreview/" + appType + (noPasswd ? '/false' : '/true') + "?email=" + id;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(apiUrl, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        });
    },
    sendForgotPasswordEmail: function sendForgotPasswordEmail(self, id, culture, userType) {
        var _this5 = this;

        var apiUrl = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + "ForgotPassword?force=true";

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(apiUrl, { UserName: id, Culture: culture, UserType: userType }, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        }).then(function (response) {
            if (response.status === 200) {
                __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this5.labels().EMAIL_WAS_SENT, 'success');
            }
        }).catch(function (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status === 401) {
                    self.$session.destroy();
                    self.$router.push("/login");
                } else if (err.response.status === 403) {
                    __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this5.labels().PASSWORD_RESET_TOO_OFTEN, 'danger');
                } else {
                    __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this5.labels().ERROR_EMAIL_SEND, 'danger');
                }
            }
            return err;
        });
    },
    getForgotPasswordEmailPreview: function getForgotPasswordEmailPreview(self, id, appType) {
        var apiUrl = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + "GetForgotPasswordEmailPreview/" + appType + "?email=" + id;

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(apiUrl, {
            headers: { Authorization: "Bearer " + self.$session.get("jwt") }
        });
    }
});

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStringsForLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resources_en_js__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources_de_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_bg_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_nl_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resources_fr_js__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_it_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resources_ru_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resources_sl_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resources_es_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resources_cs_js__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__resources_pl_js__ = __webpack_require__(105);












function getStringsForLocale(loc) {
  switch (loc) {
    case "DE":
      return __WEBPACK_IMPORTED_MODULE_1__resources_de_js__["a" /* default */];
    case "EN":
      return __WEBPACK_IMPORTED_MODULE_0__resources_en_js__["a" /* default */];
    case "BG":
      return __WEBPACK_IMPORTED_MODULE_2__resources_bg_js__["a" /* default */];
    case "NL":
      return __WEBPACK_IMPORTED_MODULE_3__resources_nl_js__["a" /* default */];
    case "FR":
      return __WEBPACK_IMPORTED_MODULE_4__resources_fr_js__["a" /* default */];
    case "IT":
      return __WEBPACK_IMPORTED_MODULE_5__resources_it_js__["a" /* default */];
    case "RU":
      return __WEBPACK_IMPORTED_MODULE_6__resources_ru_js__["a" /* default */];
    case "SL":
      return __WEBPACK_IMPORTED_MODULE_7__resources_sl_js__["a" /* default */];
    case "ES":
      return __WEBPACK_IMPORTED_MODULE_8__resources_es_js__["a" /* default */];
    case "CS":
      return __WEBPACK_IMPORTED_MODULE_9__resources_cs_js__["a" /* default */];
    case "PL":
      return __WEBPACK_IMPORTED_MODULE_10__resources_pl_js__["a" /* default */];
  }
  return __WEBPACK_IMPORTED_MODULE_0__resources_en_js__["a" /* default */];
}

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_Login_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Credentials_Credentials_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Credentials_Credentials_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Credentials_Credentials_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CreatePassword_CreatePassword_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CreatePassword_CreatePassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_CreatePassword_CreatePassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ForgotPassword_ForgotPassword_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ForgotPassword_ForgotPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ForgotPassword_ForgotPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_Dashboard_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Dashboard_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DashboardHome_DashboardHome_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DashboardHome_DashboardHome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_DashboardHome_DashboardHome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UsersList_UsersList_vue__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UsersList_UsersList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_UsersList_UsersList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_EditUser_EditUser_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_EditUser_EditUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_EditUser_EditUser_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ChangePassword_ChangePassword_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ChangePassword_ChangePassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_ChangePassword_ChangePassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ResendWelcome_ResendWelcome_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ResendWelcome_ResendWelcome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_ResendWelcome_ResendWelcome_vue__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '*',
    redirect: 'login'
  }, {
    path: '/login/:token?',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login_Login_vue___default.a,
    props: true
  }, {
    path: '/createPassword/:token/:backurl?',
    name: 'createPassword',
    component: __WEBPACK_IMPORTED_MODULE_4__components_CreatePassword_CreatePassword_vue___default.a,
    props: true
  }, {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ForgotPassword_ForgotPassword_vue___default.a,
    props: true
  }, {
    path: '/linkExpired',
    name: 'linkExpired',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ForgotPassword_ForgotPassword_vue___default.a
  }, {
    path: '/changePassword',
    name: 'changePasswordNotLoggedIn',
    component: __WEBPACK_IMPORTED_MODULE_10__components_ChangePassword_ChangePassword_vue___default.a
  }, {
    path: '/resendWelcome/:email/:userType',
    name: 'resendWelcome',
    component: __WEBPACK_IMPORTED_MODULE_11__components_ResendWelcome_ResendWelcome_vue___default.a,
    props: true
  }, {
    path: '/dashboard',
    name: 'dashboard',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_Dashboard_vue___default.a,
    canReuse: false,
    children: [{
      path: 'changePassword',
      name: 'changePassword',
      component: __WEBPACK_IMPORTED_MODULE_3__components_Credentials_Credentials_vue___default.a
    }, {
      path: 'setPassword/:id',
      name: 'setPassword',
      component: __WEBPACK_IMPORTED_MODULE_3__components_Credentials_Credentials_vue___default.a,
      props: true
    }, {
      path: 'userslist',
      name: 'usersList',
      component: __WEBPACK_IMPORTED_MODULE_8__components_UsersList_UsersList_vue___default.a
    }, {
      path: 'userslist/:id',
      name: 'editUser',
      component: __WEBPACK_IMPORTED_MODULE_9__components_EditUser_EditUser_vue___default.a
    }, {
      path: '',
      name: '',
      component: __WEBPACK_IMPORTED_MODULE_7__components_DashboardHome_DashboardHome_vue___default.a
    }]
  }]
}));

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_session__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_session__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_session___default.a);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyAssignPolyfill;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);



function applyAssignPolyfill() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE");

    if (!__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a || msie) {
        Object.defineProperty(Object, 'assign', {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function value(target, firstSource) {
                'use strict';

                if (target === undefined || target === null) {
                    throw new TypeError('Cannot convert first argument to object');
                }

                var to = Object(target);
                for (var i = 1; i < arguments.length; i++) {
                    var nextSource = arguments[i];
                    if (nextSource === undefined || nextSource === null) {
                        continue;
                    }

                    var keysArray = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(Object(nextSource));
                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                        var nextKey = keysArray[nextIndex];
                        var desc = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(nextSource, nextKey);
                        if (desc !== undefined && desc.enumerable) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
                return to;
            }
        });
    }
}

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(178),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'changePassword',
  data: function data() {
    return {
      formSubmitted: false,
      success: false,
      PasswordConfirm: null,
      changePasswordError: false,
      startPasswordCheck: false,
      errorAfterRequest: null,
      credentials: {
        UserName: null,
        OldPassword: null,
        Password: null
      }
    };
  },

  created: function created() {
    this.credentials.UserName = this.$route.query.username;
    document.title = this.labels.MMID_CHANGE_PASSWORD;
  },
  beforeDestroy: function beforeDestroy() {
    document.title = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].defaultTitle;;
  },
  methods: {
    changePassword: function changePassword() {
      var _this = this;

      this.startPasswordCheck = true;
      this.formSubmitted = true;

      var model = {
        UserName: this.credentials.UserName,
        Password: this.credentials.OldPassword,
        NewPassword: this.credentials.Password
      };

      if (this.formValid) {
        this.$axios.post(__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + 'ChangeUserPassword', model).then(function (response) {
          if (response.status === 200) {

            if (response.data == 'Ok') {
              _this.success = true;
              _this.changePasswordError = false;
              _this.errorAfterRequest = null;

              var self = _this;
              setTimeout(function () {
                self.redirectToBack();
              }, 1000);
            } else if (response.data == 'InvalidPassword') {
              _this.changePasswordError = false;
              _this.errorAfterRequest = _this.labels.INVALID_OLD_PASSWORD;
            } else if (response.data == 'UserNotFoundOrInactive') {
              _this.changePasswordError = false;
              _this.errorAfterRequest = _this.labels.USER_NOT_FOUND_OR_INACTIVE;
            } else {
              _this.changePasswordError = true;
            }
          }
        }).catch(function (err) {
          console.log(err);
          _this.changePasswordError = true;
          if (err.response.status === 404) {
            _this.errorAfterRequest = _this.labels.USER_NOT_FOUND_OR_INACTIVE;
          }
          return err;
        });
      }
    },
    cancel: function cancel() {
      this.redirectToBack();
    },
    redirectToBack: function redirectToBack() {
      var backLink = this.$route.query.backurl;
      if (!!backLink && __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isBackLinkAllowed(backLink)) {
        backLink = backLink.indexOf('http') < 0 ? 'http://' + backLink : backLink;
      } else {
        backLink = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].digiUrl;
      }
      window.location.href = backLink;
    }
  },
  computed: {
    passwordConfirmValid: function passwordConfirmValid() {
      return this.credentials.Password === this.PasswordConfirm;
    },
    passwordFilled: function passwordFilled() {
      return !!this.credentials.Password;
    },
    oldPasswordFilled: function oldPasswordFilled() {
      return !!this.credentials.OldPassword;
    },
    passwordIsStrong: function passwordIsStrong() {
      return this.isLong && this.isLowercase && this.isUppercase && this.isNumber && this.isSpecial;
    },
    formValid: function formValid() {
      return this.formSubmitted && this.passwordFilled && this.oldPasswordFilled && this.passwordConfirmValid && this.passwordIsStrong;
    },
    isLong: function isLong() {
      return this.credentials.Password != null && this.credentials.Password.length >= 10;
    },
    isLowercase: function isLowercase() {
      return this.credentials.Password != null && new RegExp("^(?=.*[a-z])").test(this.credentials.Password);
    },
    isUppercase: function isUppercase() {
      return this.credentials.Password != null && new RegExp("^(?=.*[A-Z])").test(this.credentials.Password);
    },
    isNumber: function isNumber() {
      return this.credentials.Password != null && new RegExp("^(?=.*[0-9])").test(this.credentials.Password);
    },
    isSpecial: function isSpecial() {
      return this.credentials.Password != null && new RegExp("^(?=.*[!_@#\$%\^&*\'\"§%&/()=?`*+.:,;<>°^\-])").test(this.credentials.Password);
    },
    labels: function labels() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.strings.CreatePassword;
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'createPassword',
  props: ['token', 'backurl'],
  data: function data() {
    return {
      formSubmitted: false,
      success: false,
      key: this.$props.token,
      backUrl: this.$props.backurl,
      PasswordConfirm: null,
      isChangePasswordAllowed: true,
      changePasswordError: false,
      startPasswordCheck: false,
      linkExpired: false,
      credentials: {
        PasswordResetCode: null,
        Password: null
      }
    };
  },

  created: function created() {
    if (!this.key) {
      this.$router.push('/login');
    } else {
      this.credentials.PasswordResetCode = this.key;
      document.title = this.labels.HEADING;
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.title = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].defaultTitle;;
  },
  methods: {
    createPassword: function createPassword(event) {
      var _this = this;

      event.preventDefault();
      this.startPasswordCheck = true;
      this.formSubmitted = true;

      if (this.formValid) {
        this.$axios.post(__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + 'CreatePassword', this.credentials).then(function (response) {
          if (response.status === 200) {
            _this.success = true;
            var self = _this;
            setTimeout(function () {
              if (!!self.backUrl && __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isBackLinkAllowed(self.backUrl)) {
                window.location.href = self.backUrl.indexOf('http') < 0 ? 'http://' + self.backUrl : self.backUrl;
                return;
              }
              self.$router.push("/login");
            }, 1000);
          }
        }).catch(function (err) {
          console.log(err);
          if (err.response && err.response.status == 403) {
            _this.linkExpired = true;
          }
          _this.changePasswordError = true;
          return err;
        });
      }
    },
    cancel: function cancel(event) {
      event.preventDefault();
      this.$router.push("/login");
    },
    checkInput: function checkInput(password, userInputs) {
      if (password.length) {
        if (__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].strongRegex.test(password)) {
          this.score = 4;
        } else if (__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].mediumRegex.test(password)) {
          this.score = 3;
        } else if (__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].weakRegex.test(password)) {
          this.score = 2;
        } else {
          this.score = 1;
        }
      }
    }
  },
  computed: {
    passwordConfirmValid: function passwordConfirmValid() {
      return this.credentials.Password === this.PasswordConfirm;
    },
    passwordFilled: function passwordFilled() {
      return !!this.credentials.Password;
    },
    passwordIsStrong: function passwordIsStrong() {
      return this.isLong && this.isLowercase && this.isUppercase && this.isNumber && this.isSpecial;
    },
    formValid: function formValid() {
      return this.formSubmitted && this.passwordFilled && this.passwordConfirmValid && this.passwordIsStrong;
    },
    isLong: function isLong() {
      return this.credentials.Password != null && this.credentials.Password.length >= 10;
    },
    isLowercase: function isLowercase() {
      return this.credentials.Password != null && new RegExp("^(?=.*[a-z])").test(this.credentials.Password);
    },
    isUppercase: function isUppercase() {
      return this.credentials.Password != null && new RegExp("^(?=.*[A-Z])").test(this.credentials.Password);
    },
    isNumber: function isNumber() {
      return this.credentials.Password != null && new RegExp("^(?=.*[0-9])").test(this.credentials.Password);
    },
    isSpecial: function isSpecial() {
      return this.credentials.Password != null && new RegExp("^(?=.*[!_@#\$%\^&*\'\"�%&/()=?`*+.:,;<>�^\-])").test(this.credentials.Password);
    },
    labels: function labels() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.strings.CreatePassword;
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'credentials',
  props: ['id'],
  data: function data() {
    return {
      formSubmitted: false,
      PasswordConfirm: null,
      changePasswordError: null,
      startPasswordCheck: false,
      credentials: {
        UserName: null,
        Password: null,
        NewPassword: null
      }
    };
  },

  created: function created() {
    if (this.id == null) {
      __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedSubPoint = this.$parent.changePasswordText, __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedPoint = this.$parent.actionText;
    } else {
      this.credentials.UserName = this.id;
    }
  },
  beforeCreate: function beforeCreate() {
    /*if (!this.$session.exists()) {
      this.$router.push('login')
    }*/
  },
  methods: {
    proceed: function proceed(event) {
      var _this = this;

      event.preventDefault();
      this.formSubmitted = true;
      this.startPasswordCheck = true;

      if (this.formValid) {
        this.incorrectAccessCode = false;
        this.loginFailed = false;

        this.$axios.post(__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + 'Credentials', this.credentials, { headers: { 'Authorization': 'Bearer ' + this.$session.get('jwt') } }).then(function (response) {
          if (response.status === 200) {
            if (_this.id == null) {
              var backLink = _this.$route.query.backurl;
              if (!!backLink && __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isBackLinkAllowed(backLink)) {
                location.href = backLink.indexOf('http') < 0 ? 'http://' + backLink : backLink;
              }

              __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(event, _this.labels.SUCCESS_TEXT, 'success');
              _this.$parent.showDashboard(event);
              _this.$router.push('dashboard');
            } else {
              __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(event, _this.labels.SUCCESS_TEXT, 'success');
              _this.$router.go(-1);
            }
          }
        }).catch(function (err) {
          if (err.response && err.response.status == 401) {
            _this.$session.destroy();
            window.user.IsLoggedIn = false;
            _this.$router.push('login');
          } else {
            _this.changePasswordError = true;
          }
          return err;
        });
      }
    },
    cancel: function cancel(event) {
      event.preventDefault();
      if (this.id == null) {
        this.$parent.showDashboard(event);
        this.$router.push('dashboard');
      } else {
        this.$router.go(-1);
      }
    }
  },
  computed: {
    passwordConfirmValid: function passwordConfirmValid() {
      return this.credentials.NewPassword === this.PasswordConfirm;
    },
    newPasswordFilled: function newPasswordFilled() {
      return !!this.credentials.NewPassword;
    },
    passwordFilled: function passwordFilled() {
      return !!this.id || !!this.credentials.Password;
    },
    passwordIsStrong: function passwordIsStrong() {
      return this.isLong && this.isLowercase && this.isUppercase && this.isNumber && this.isSpecial;
    },
    formValid: function formValid() {
      return this.formSubmitted && this.passwordFilled && this.newPasswordFilled && this.passwordConfirmValid && this.changeAvailable && this.passwordIsStrong;
    },
    changeAvailable: function changeAvailable() {
      if (!!this.id) {
        return true;
      }
      var user = this.$session.get('user');
      return !__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].emailInBlackList(user.Email);
    },
    isRestricted: function isRestricted() {
      if (!!this.id) {
        return true;
      }
      var user = this.$session.get('user');
      return this.newPasswordFilled && this.credentials.NewPassword.indexOf(user.FirstName) <= 0 && this.credentials.NewPassword.indexOf(user.LastName) <= 0;
    },
    isLong: function isLong() {
      return this.credentials.NewPassword != null && this.credentials.NewPassword.length >= 10;
    },
    isLowercase: function isLowercase() {
      return this.credentials.NewPassword != null && new RegExp("^(?=.*[a-z])").test(this.credentials.NewPassword);
    },
    isUppercase: function isUppercase() {
      return this.credentials.NewPassword != null && new RegExp("^(?=.*[A-Z])").test(this.credentials.NewPassword);
    },
    isNumber: function isNumber() {
      return this.credentials.NewPassword != null && new RegExp("^(?=.*[0-9])").test(this.credentials.NewPassword);
    },
    isSpecial: function isSpecial() {
      return this.credentials.NewPassword != null && new RegExp("^(?=.*[!_@#\$%\^&*\'\"�%&/()=?`*+.:,;<>�^\-])").test(this.credentials.NewPassword);
    },
    openedSubPoint: function openedSubPoint() {
      return this.labels.CHANGE_PASSWORD_TEXT;
    },
    openedPoint: function openedPoint() {
      return this.labels.ACTION_TEXT;
    },
    labels: function labels() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.strings.Credentials;
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "dashboardHome",
  data: function data() {
    return {
      dashBoardDigiLinks: __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].dashBoardDigiLinks,
      dashBoardMMPLinks: __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].dashBoardMMPLinks
    };
  },

  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("login");
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedSubPoint = this.openedSubPoint, __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedPoint = this.openedPoint;
  },
  methods: {
    userInGroup: function userInGroup(groupName) {
      var user = this.$session.get('user');
      var groups = user.Groups;
      if (groups) {
        return user.Groups.indexOf(groupName) > -1;
      }
      return false;
    },
    userHasSharePoint: function userHasSharePoint() {
      var user = this.$session.get('user');
      return user != null && user.HasSharePointGroups;
    },
    userHasDigi: function userHasDigi() {
      var user = this.$session.get('user');
      return user != null && user.HasDigiGroups;
    },
    userHasMMPDigi: function userHasMMPDigi() {
      var user = this.$session.get('user');
      return user != null && user.HasMMPDigiGroups;
    }
  },
  computed: {
    openedSubPoint: function openedSubPoint() {
      return this.isCurrentUserAdmin || this.isCurrentUserMMPWM ? this.labels.APPLICATIONS_TEXT : this.labels.MY_APPLICATIONS_TEXT;
    },
    openedPoint: function openedPoint() {
      return this.labels.ACTION_TEXT;
    },
    digiLink: function digiLink() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].digiUrl + "login";
    },
    mmpLink: function mmpLink() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].mmpUrl + "login";
    },
    isCurrentUserAdmin: function isCurrentUserAdmin() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isCurrentUserAdmin;
    },
    isCurrentUserMMPWM: function isCurrentUserMMPWM() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isCurrentUserMMPWM;
    },
    labels: function labels() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.strings.DashboardHome;
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      isSideBarActive: true
    };
  },

  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push('login');
    }
  },
  methods: {
    showSideBar: function showSideBar() {
      this.isSideBarActive = !this.isSideBarActive;
    },
    collapseElement: function collapseElement(event, elName) {
      event.preventDefault();
      if (event.currentTarget.className.indexOf("collapsed")) {
        event.currentTarget.classList.remove("collapsed");
        event.currentTarget.classList.add("collapse");
        this.$refs[elName].classList.add("in");
      } else {
        event.currentTarget.classList.remove("collapse");
        event.currentTarget.classList.add("collapsed");
        this.$refs[elName].classList.remove("in");
      }
    },
    showChangePassword: function showChangePassword(event, text, subText) {
      __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showChangePassword(event, text, subText, this.$router);
    },
    showUsersList: function showUsersList(event, text, subText) {
      __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showUsersList(event, text, subText, this.$router);
    },
    showDashboard: function showDashboard(event) {
      __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedPoint = this.actionText;
      __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedSubPoint = this.homeText;
    }
  },
  computed: {
    isFiltersActive: function isFiltersActive() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isFiltersActive;
    },
    isCurrentUserAdmin: function isCurrentUserAdmin() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isCurrentUserAdmin;
    },
    isCurrentUserMMPWM: function isCurrentUserMMPWM() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isCurrentUserMMPWM;
    },
    activeClass: function activeClass() {
      return {
        'sidebar-active': this.isSideBarActive,
        'sidebar-deactive': !this.isSideBarActive,
        'filter-active': this.isFiltersActive,
        'filter-deactive': !this.isFiltersActive
      };
    },
    openedPoint: function openedPoint() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedPoint;
    },
    openedSubPoint: function openedSubPoint() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedSubPoint;
    },
    isChangePassword: function isChangePassword() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedSubPoint == this.changePasswordText;
    },
    isUsersList: function isUsersList() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedSubPoint == this.usersListText;
    },
    isDashboard: function isDashboard() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedSubPoint == this.homeText;
    },
    actionText: function actionText() {
      return this.labels.ACTION_TEXT;
    },
    changePasswordText: function changePasswordText() {
      return this.labels.CHANGE_PASSWORD_TEXT;
    },
    usersListText: function usersListText() {
      return this.labels.USERS_LIST_TEXT;
    },
    homeText: function homeText() {
      return this.isCurrentUserAdmin || this.isCurrentUserMMPWM ? this.labels.APPLICATIONS_TEXT : this.labels.MY_APPLICATIONS_TEXT;
    },
    labels: function labels() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.strings.Dashboard;
    }
  },
  watch: {
    homeText: function homeText() {
      __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedSubPoint = this.$children[0] ? this.$children[0].openedSubPoint : '';
    },
    changePasswordText: function changePasswordText() {
      __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedSubPoint = this.$children[0] ? this.$children[0].openedSubPoint : '';
    },
    actionText: function actionText() {
      __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedPoint = this.$children[0] ? this.$children[0].openedPoint : '';
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_PulseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_PulseLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18n_iso_countries__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18n_iso_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_i18n_iso_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_i18n_iso_countries_langs_en_json__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_i18n_iso_countries_langs_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_i18n_iso_countries_langs_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_i18n_iso_countries_langs_de_json__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_i18n_iso_countries_langs_de_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_i18n_iso_countries_langs_de_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_userMethods_js__ = __webpack_require__(22);









__WEBPACK_IMPORTED_MODULE_6_i18n_iso_countries___default.a.registerLocale(__WEBPACK_IMPORTED_MODULE_7_i18n_iso_countries_langs_en_json___default.a);
__WEBPACK_IMPORTED_MODULE_6_i18n_iso_countries___default.a.registerLocale(__WEBPACK_IMPORTED_MODULE_8_i18n_iso_countries_langs_de_json___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_js_modal___default.a, { dialog: true });

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'editUser',
    components: {
        PulseLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_PulseLoader_vue___default.a
    },
    data: function data() {
        return {
            data: null,
            userId: null,
            user: {
                FirstName: null,
                LastName: null,
                Email: null,
                PrincipalName: null,
                Domain: null,
                SAMAccountName: null,
                Language: null,
                OU: null,
                DisplayName: null,
                Phone: null,
                Website: null,
                CountryCode: null,
                State: null,
                Location: null,
                Street: null,
                PostalCode: null,
                PersonalTitle: null,
                Department: null,
                Company: null,
                Description: null,
                Info: null,
                Groups: [],
                IsActive: null,
                ThumbnailPhoto: null,
                ProxyAddresses: []
            },
            errors: {},
            summaryErrors: [],
            userClone: null,
            userLoadingError: false,
            userLoaded: false,
            showSpinner: false,
            editMode: false,
            isNew: false,
            isNewDigiUser: false,
            isNewSharePoint: false,
            isNewMMPDigiUser: false,
            isSharePointUser: false,
            countryCodes: [],
            country: null,
            allGroups: [],
            selectedGroup: null,
            selectedProxyAddressPrefix: null,
            proxyAddressValue: null,
            proxyAddressesPrefix: [],
            photoFileInput: null,
            hasDigiGroups: false,
            hasSharePointGroups: false,
            hasMMPDigiGroups: false,
            languages: __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].culture.languages,
            showEmailSpinner: false,
            sabaCostCenters: [],
            sabaJobTitles: [],
            sabaDepartments: [],
            isSabaUser: false
        };
    },

    methods: {
        onPhotoInputChange: function onPhotoInputChange(e) {
            if (e.target.files.length) {
                var file = e.target.files[0];
                if (file.type != 'image/jpeg') {
                    __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].showInfo(null, this.labels.ONLY_JPG, 'danger');
                    return;
                }
                if (file.size > 102400) {
                    __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].showInfo(null, this.labels.FILE_SIZE, 'danger');
                    return;
                }
                this.tryLoadPhoto(e.target.files[0]);
            }
        },
        browseImage: function browseImage() {
            this.$refs.fileInput.click();
        },
        removeImage: function removeImage() {
            this.user.ThumbnailPhoto = null;
        },
        tryLoadPhoto: function tryLoadPhoto(file) {
            var self = this;
            var reader = new FileReader();
            reader.onload = function () {
                var imageObject = new Image();
                imageObject.onload = function () {
                    if (imageObject.width > 96 || imageObject.heigth > 96) {
                        __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].showInfo(null, self.labels.DIMENSIONS, 'danger');
                        return;
                    }
                    self.user.ThumbnailPhoto = reader.result;
                };
                imageObject.src = reader.result;
            };
            reader.readAsDataURL(file);

            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        },
        isValid: function isValid(propertyName) {
            if (this.errors[propertyName] && this.errors[propertyName].length > 0) {
                return false;
            }
            return true;
        },
        propertyError: function propertyError(propertyName) {
            if (this.errors[propertyName] && this.errors[propertyName].length > 0) {
                return this.errors[propertyName][0];
            }
            return null;
        },
        saveUser: function saveUser() {
            var _this = this;

            var self = this;

            var thumbnailPhoto = this.user.ThumbnailPhoto ? this.user.ThumbnailPhoto.replace('data:image/jpeg;base64,', '') : null;

            var model = {
                AccountName: this.user.SAMAccountName,
                FirstName: this.user.FirstName,
                LastName: this.user.LastName,
                PreferredLanguage: this.user.Language,
                Phone: this.user.Phone,
                HomePage: this.user.Website,
                Country: this.user.CountryCode,
                Province: this.user.State,
                City: this.user.Location,
                StreetAddress: this.user.Street,
                Zip: this.user.PostalCode,
                PersonalTitle: this.user.PersonalTitle,
                Department: this.user.Department,
                Company: this.user.Company,
                Description: this.user.Description,
                Info: this.user.Info,
                Groups: this.user.Groups,
                Photo: thumbnailPhoto,
                ProxyAddresses: this.user.ProxyAddresses,
                DisplayName: this.user.DisplayName,
                Email: this.user.Email,
                UserType: this.user.UserType
            };
            if (this.isSabaUser) {
                model.CostCenter = this.user.CostCenter;
                model.JobTitle = this.user.JobTitle;
                model.ExtensionAttribute6 = this.user.ExtensionAttribute6;
                model.Gender = this.user.Gender;
                model.FirstNameUnicode = this.user.FirstNameUnicode;
                model.LastNameUnicode = this.user.LastNameUnicode;
            }

            var apiUrl = self.isNew ? __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].host + "CreateADUser" : __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].host + "EditUserSave";

            this.showSpinner = true;
            self.$axios.post(apiUrl, model, { headers: { Authorization: "Bearer " + self.$session.get("jwt"), "Language": self.cultureCode } }).then(function (response) {
                self.showSpinner = false;
                if (response.status === 200) {
                    if (response.data.Result == 'Errors') {
                        _this.errors = {};
                        _this.errors.FirstName = response.data.Errors.FirstName;
                        _this.errors.LastName = response.data.Errors.LastName;
                        _this.errors.Language = response.data.Errors.PreferredLanguage;
                        _this.errors.Email = response.data.Errors.Email;
                        _this.errors.Phone = response.data.Errors.Phone;
                        _this.errors.Website = response.data.Errors.HomePage;
                        _this.errors.CountryCode = response.data.Errors.Country;
                        _this.errors.State = response.data.Errors.Province;
                        _this.errors.Location = response.data.Errors.City;
                        _this.errors.Street = response.data.Errors.StreetAddress;
                        _this.errors.PostalCode = response.data.Errors.Zip;
                        _this.errors.PersonalTitle = response.data.Errors.PersonalTitle;
                        _this.errors.Department = response.data.Errors.Department;
                        _this.errors.Company = response.data.Errors.Company;
                        _this.errors.Description = response.data.Errors.Description;
                        _this.errors.Groups = response.data.Errors.Groups;
                        _this.errors.ProxyAddresses = response.data.Errors.ProxyAddresses;
                        _this.errors.DisplayName = response.data.Errors.DisplayName;
                        _this.errors.CostCenter = response.data.Errors.CostCenter;
                        _this.errors.JobTitle = response.data.Errors.JobTitle;
                        _this.errors.FirstNameUnicode = response.data.Errors.FirstNameUnicode;
                        _this.errors.LastNameUnicode = response.data.Errors.LastNameUnicode;
                        _this.errors.Gender = response.data.Errors.Gender;
                        _this.summaryErrors = response.data.SummaryErrors;
                    } else if (response.data.Result == 'Ok') {
                        _this.errors = {};
                        _this.editMode = false;

                        __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].showInfo(null, self.labels.USER_WAS_SAVED, 'success', 5000);
                        setTimeout(function () {
                            if (self.isNew) {
                                self.$router.push('/dashboard/userslist/' + response.data.user.AccountName);
                                self.userId = response.data.user.AccountName;
                            }
                            self.loadUser();
                        }, 1000);
                    }
                }
            }).catch(function (err) {
                self.showSpinner = false;
                var errHandled = false;
                if (err.response) {
                    if (err.response.status === 401) {
                        errHandled = true;
                        self.$session.destroy();
                        self.$router.push("/login");
                    } else if (err.response.status === 400) {
                        var errMsg = self.labels[err.response.data.Message];
                        if (!errMsg) {
                            errMsg = err.response.data.Message;
                        }
                        __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].showInfo(null, errMsg, 'danger', 4000);
                        errHandled = true;
                    } else if (err.response.status == 404) {
                        __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].showInfo(null, self.labels.USER_NOT_FOUND, 'danger');
                        errHandled = true;
                    }
                }
                if (!errHandled) {
                    __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].showInfo(null, self.labels.UNKNOWN_ERROR, 'danger');
                }
                return err;
            });
        },
        cancelEditMode: function cancelEditMode() {
            this.user = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.userClone));
            this.errors = {};
            this.summaryErrors = [];
            if (this.photoFileInput) {
                this.photoFileInput.value = '';
                this.photoFileInput.type = '';
                this.photoFileInput.type = 'file';
            }

            this.editMode = false;
            if (this.isNew) {
                this.$router.push('/dashboard/userslist');
            }
        },
        removeGroup: function removeGroup(group, index) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].delete(this.user.Groups, index);
        },
        setPassword: function setPassword() {
            this.$router.push('/dashboard/setPassword/' + this.userId);
        },
        addGroup: function addGroup() {
            if (this.selectedGroup) {
                if (!this.user.Groups) {
                    this.user.Groups = new Array();
                }
                this.user.Groups.push(this.selectedGroup);
                this.selectedGroup = null;
            }
        },
        isGroupEditable: function isGroupEditable(group) {
            return this.allGroups.indexOf(group) > -1;
        },
        addProxyAddress: function addProxyAddress() {
            if (this.selectedProxyAddressPrefix && this.selectedProxyAddressPrefix.length > 0 && this.proxyAddressValue && this.proxyAddressValue.length > 0) {
                this.user.ProxyAddresses.push(this.selectedProxyAddressPrefix + ':' + this.proxyAddressValue);
                this.proxyAddressValue = null;
            }
        },
        removeProxyAddress: function removeProxyAddress(proxyAddress, index) {
            __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].delete(this.user.ProxyAddresses, index);
        },
        isProxyAddressEditable: function isProxyAddressEditable(proxyAddress) {
            if (proxyAddress) {
                var splitted = proxyAddress.split(':');
                if (splitted.length > 0 && this.proxyAddressesPrefix.indexOf(splitted[0]) > -1) {
                    return true;
                }
            }
            return false;
        },
        toEditMode: function toEditMode() {
            this.userClone = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.user));
            this.editMode = true;
        },
        getUserDetails: function getUserDetails() {
            var self = this;
            //TODO: change new user definition
            this.isNewDigiUser = self.userId == "new", this.isNewSharePoint = self.userId == "newsharepoint";
            this.isNewMMPDigiUser = self.userId == "newmmpdigi";
            this.isNew = this.isNewDigiUser || this.isNewSharePoint || this.isNewMMPDigiUser;

            var apiUrl = __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].host + "UserDetails?userName=" + self.userId;

            var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                self.$axios.get(apiUrl, { headers: { Authorization: "Bearer " + self.$session.get("jwt") } }).then(function (response) {
                    if (response.status === 200) {
                        self.isSabaUser = response.data.ExtensionAttribute6 === "601";
                        if (self.isSabaUser) {
                            self.getSabaUserSettings(response.data.PhysicalDeliveryOfficeName);
                        }

                        resolve(response.data);
                        if (self.user != null) {
                            self.hasDigiGroups = response.data.HasDigiGroups;
                            self.hasSharePointGroups = response.data.HasSharePointGroups;
                            self.hasMMPDigiGroups = response.data.HasMMPDigiGroups;
                        }

                        if (self.isNew) {
                            self.toEditMode();
                        }
                    } else {
                        reject('');
                    }
                }).catch(function (err) {
                    console.log(err);
                    if (err.response) {
                        if (err.response.status === 401) {
                            self.$session.destroy();
                            self.$router.push("/login");
                        } else if (err.response.status === 404) {
                            __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].showInfo(null, self.labels().USER_NOT_FOUND, 'danger');
                        }
                    }
                    reject('');
                    return err;
                });
            });

            return promise;
        },
        getSettingsFromServer: function getSettingsFromServer() {
            var self = this;
            var apiUrl = __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].host + "EditUserSettings";

            var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                self.$axios.post(apiUrl, {}, { headers: { Authorization: "Bearer " + self.$session.get("jwt") } }).then(function (response) {
                    if (response.status === 200) {
                        resolve(response.data);
                    } else {
                        reject('');
                    }
                }).catch(function (err) {
                    console.log(err);
                    if (err.response && err.response.status === 401) {
                        self.$session.destroy();
                        self.$router.push("/login");
                    }
                    reject('');
                    return err;
                });
            });

            return promise;
        },
        getSabaUserSettings: function getSabaUserSettings(loc) {
            var self = this;
            var apiUrl = __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].host + "SabaUserSettings/" + loc;

            self.$axios.get(apiUrl, { headers: { Authorization: "Bearer " + self.$session.get("jwt") } }).then(function (response) {
                if (response.status === 200) {
                    self.sabaCostCenters = response.data.CostCenters;
                    self.sabaJobTitles = response.data.JobTitles;
                    self.sabaDepartments = response.data.Departments;
                }
            }).catch(function (err) {
                console.log(err);
                if (err.response && err.response.status === 401) {
                    self.$session.destroy();
                    self.$router.push("/login");
                }
                return err;
            });
        },
        unlockUser: function unlockUser() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_9__shared_userMethods_js__["a" /* default */].unlockUser(this, this.user.SAMAccountName, function () {
                _this2.user.Locked = false;
            });
        },
        activateUser: function activateUser(event) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_9__shared_userMethods_js__["a" /* default */].activateUser(this, this.user.SAMAccountName, function () {
                _this3.user.IsActive = true;
            });
        },
        deactivateUser: function deactivateUser(event) {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_9__shared_userMethods_js__["a" /* default */].deactivateUser(this, this.user.SAMAccountName, function () {
                _this4.user.IsActive = false;
            });
        },
        sendWelcomeEmail: function sendWelcomeEmail(appType, noPasswd) {
            __WEBPACK_IMPORTED_MODULE_9__shared_userMethods_js__["a" /* default */].sendWelcomeEmail(this, this.user.SAMAccountName, this.user.Language, appType, noPasswd);
        },
        getWelcomeEmailPreview: function getWelcomeEmailPreview(appType, noPasswd) {
            var _this5 = this;

            var self = this;
            self.showEmailSpinner = true;
            var html = __WEBPACK_IMPORTED_MODULE_9__shared_userMethods_js__["a" /* default */].getWelcomeEmailPreview(this, this.user.SAMAccountName, appType, noPasswd).then(function (response) {
                self.showEmailSpinner = false;
                self.$modal.show('dialog', {
                    text: response.data,
                    buttons: []
                });
            }).catch(function (err) {
                self.showEmailSpinner = false;
                console.log(err);
                __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].showInfo(null, _this5.labels().ERROR_EMAIL_GENERATE, 'danger');
            });
        },
        sendForgotPasswordEmail: function sendForgotPasswordEmail(appType) {
            __WEBPACK_IMPORTED_MODULE_9__shared_userMethods_js__["a" /* default */].sendForgotPasswordEmail(this, this.user.SAMAccountName, this.user.Language, appType);
        },
        getForgotPasswordEmailPreview: function getForgotPasswordEmailPreview(appType) {
            var _this6 = this;

            var self = this;
            self.showEmailSpinner = true;
            var html = __WEBPACK_IMPORTED_MODULE_9__shared_userMethods_js__["a" /* default */].getForgotPasswordEmailPreview(this, this.user.SAMAccountName, appType).then(function (response) {
                self.showEmailSpinner = false;
                self.$modal.show('dialog', {
                    text: response.data,
                    buttons: []
                });
            }).catch(function (err) {
                self.showEmailSpinner = false;
                console.log(err);
                __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].showInfo(null, _this6.labels().ERROR_EMAIL_GENERATE, 'danger');
            });
        },
        createUser: function createUser(data) {
            this.user.FirstName = data.FirstName;
            this.user.LastName = data.LastName;
            this.user.Email = data.Email;
            this.user.PrincipalName = data.PrincipalName;
            this.user.Domain = data.Domain;
            this.user.SAMAccountName = data.AccountName;
            this.user.Language = data.PreferredLanguage;
            this.user.OU = data.OrganizationUnit;
            this.user.DisplayName = data.DisplayName;
            this.user.Phone = data.Phone;
            this.user.Website = data.HomePage;
            this.user.CountryCode = data.Country;
            this.user.State = data.Province;
            this.user.Location = data.City;
            this.user.Street = data.StreetAddress;
            this.user.PostalCode = data.Zip;
            this.user.PersonalTitle = data.PersonalTitle;
            this.user.Company = data.Company;
            this.user.Description = data.Description;
            this.user.Info = data.Info;
            this.user.Groups = data.Groups;
            this.user.IsActive = data.Enabled;
            this.user.Locked = data.Locked;
            this.user.UserType = data.UserType, this.user.ThumbnailPhoto = data.Photo ? 'data:image/jpeg;base64,' + data.Photo : null;
            this.user.ProxyAddresses = data.ProxyAddresses ? data.ProxyAddresses : [];
            this.user.HasDigiGroups = data.HasDigiGroups;
            this.user.HasSharePointGroups = data.HasSharePointGroups;
            this.user.HasMMPDigiGroups = data.HasMMPDigiGroups;
            this.user.ExtensionAttribute6 = data.ExtensionAttribute6;
            this.user.CanonicalName = data.CanonicalName;
            if (!this.isSabaUser) {
                this.user.Department = data.Department;
            } else {
                // use the values, originally present in user object,
                // becuse AD is not immediately synchronized after
                // editing user and we are getting back old values
                if (this.user.Department == null || this.user.Department == '') {
                    this.user.Department = data.Department;
                }
                if (this.user.CostCenter == null || this.user.CostCenter == '') {
                    this.user.CostCenter = data.CostCenter;
                }
                if (this.user.JobTitle == null || this.user.JobTitle == '') {
                    this.user.JobTitle = data.JobTitle;
                }
                if (this.user.FirstNameUnicode == null || this.user.FirstNameUnicode == '') {
                    this.user.FirstNameUnicode = data.FirstNameUnicode;
                }
                if (this.user.LastNameUnicode == null || this.user.LastNameUnicode == '') {
                    this.user.LastNameUnicode = data.LastNameUnicode;
                }
                if (this.user.Gender == null || this.user.Gender == '') {
                    this.user.Gender = data.Gender;
                }
            }

            this.hasDigiGroups = data.HasDigiGroups;
            this.hasSharePointGroups = data.HasSharePointGroups;
            this.hasMMPDigiGroups = data.HasMMPDigiGroups;
        },
        loadUser: function loadUser() {
            var _this7 = this;

            __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].openedSubPoint = this.$parent.usersListText;
            __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].openedPoint = this.$parent.actionText;

            this.userId = this.$route.params.id;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.getUserDetails(), this.getSettingsFromServer()]).then(function (results) {
                var userDetails = results[0];
                var settings = results[1];

                _this7.countryCodes = settings.Countries.map(function (countryCode) {
                    return {
                        Text: __WEBPACK_IMPORTED_MODULE_6_i18n_iso_countries___default.a.getName(countryCode, _this7.cultureCode),
                        Value: countryCode
                    };
                }).sort(function (a, b) {
                    if (a.Text < b.Text) return -1;
                    if (a.Text > b.Text) return 1;
                    return 0;
                });

                _this7.allGroups = settings.EditableRoles;
                _this7.proxyAddressesPrefix = settings.ProxyAddressesValidPrefix ? settings.ProxyAddressesValidPrefix : [];

                _this7.createUser(userDetails);
                _this7.userLoaded = true;
            }, function (error) {
                _this7.userLoadingError = true;
            }).then(function () {
                _this7.showSpinner = false;
            });
        },
        getCountryCode: function getCountryCode(code) {
            return __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].culture.getCountryCode(code);
        }
    },

    computed: {
        photoSrc: function photoSrc() {
            return this.user.ThumbnailPhoto ? this.user.ThumbnailPhoto : 'static/img/no-avatar.jpg';
        },
        openedSubPoint: function openedSubPoint() {
            return this.labels.USERS_LIST_TEXT;
        },
        openedPoint: function openedPoint() {
            return this.labels.ACTION_TEXT;
        },
        cultureCode: function cultureCode() {
            return __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].culture.locale;
        },
        availableGroups: function availableGroups() {
            var self = this;
            return self.allGroups.filter(function (item) {
                var result = true;
                if (self.user.Groups != null) {
                    for (var i = 0; i < self.user.Groups.length; i++) {
                        if (self.user.Groups[i] === item) {
                            result = false;
                        }
                    }
                }
                return result;
            });
        },
        labels: function labels() {
            return __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].culture.strings.EditUser;
        },
        isCurrentUserAdmin: function isCurrentUserAdmin() {
            return __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].isCurrentUserAdmin;
        },
        isCurrentUserMMPWM: function isCurrentUserMMPWM() {
            return __WEBPACK_IMPORTED_MODULE_3__main_js__["globalStore"].isCurrentUserMMPWM;
        }
    },
    watch: {
        user: {
            handler: function handler(to, from) {
                this.country = __WEBPACK_IMPORTED_MODULE_6_i18n_iso_countries___default.a.getName(to.CountryCode, this.cultureCode);
                if (this.isNew) {
                    if (to.FirstName != null && to.LastName != null) {
                        this.user.DisplayName = to.LastName + ' ' + to.FirstName;
                    }
                    if (to.Email != null) {
                        this.user.PrincipalName = to.Email;
                    }
                }
            },
            deep: true
        },
        cultureCode: function cultureCode(to, from) {
            this.countryCodes = this.countryCodes.map(function (item) {
                item.Text = __WEBPACK_IMPORTED_MODULE_6_i18n_iso_countries___default.a.getName(item.Value, to);
                return item;
            }).sort(function (a, b) {
                if (a.Text < b.Text) return -1;
                if (a.Text > b.Text) return 1;
                return 0;
            });
        }
    },
    beforeCreate: function beforeCreate() {
        if (!this.$session.exists()) {
            this.$router.push("login");
            return;
        }
    },
    created: function created() {
        this.loadUser();
    }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'createPassword',
  data: function data() {
    return {
      formSubmitted: false,
      success: false,
      isExpired: false,
      forbidden: false,
      failed: false,
      redirectEmail: false,
      credentials: {
        UserName: null,
        culture: __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.locale,
        backUrl: ''
      }
    };
  },

  created: function created() {
    this.credentials.backUrl = this.$route.query.backurl;
    this.isExpired = this.$route.name == 'linkExpired';
    this.redirectEmail = Boolean(this.$route.query.redirectEmail) && /^true$/.test(this.$route.query.redirectEmail);
    document.title = this.isExpired ? this.labels.HEADING_EXPIRED : this.labels.HEADING;
  },
  beforeDestroy: function beforeDestroy() {
    document.title = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].defaultTitle;
  },
  methods: {
    proceed: function proceed(event) {
      var _this = this;

      event.preventDefault();
      this.formSubmitted = true;
      this.forbidden = false;
      this.failed = false;

      if (this.formValid) {
        this.$axios.post(__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + 'ForgotPassword?redirectEmail=' + this.redirectEmail, this.credentials).then(function (response) {
          _this.success = true;
        }).catch(function (err) {
          if (err.response && err.response.status === 403) {
            _this.forbidden = true;
          } else {
            _this.failed = true;
          }
        });
      }
    },
    cancel: function cancel(event) {
      event.preventDefault();
      this.$router.push('dashboard');
    }
  },
  computed: {
    loginFilled: function loginFilled() {
      return !!this.credentials.UserName;
    },
    loginValid: function loginValid() {
      return !__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].emailInBlackList(this.credentials.UserName);
    },
    isEmail: function isEmail() {
      if (!!this.credentials.UserName) {
        var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
        return reg.test(this.credentials.UserName);
      }
    },
    formValid: function formValid() {
      return this.formSubmitted && this.loginFilled && this.loginValid && this.isEmail;
    },
    labels: function labels() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.strings.ForgotPassword;
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  components: {
    PulseLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue___default.a
  },
  props: ['token'],
  data: function data() {
    return {
      showSpinner: false,
      key: this.$props.token,
      formSubmitted: false,
      loginFailed: false,
      credentials: {
        UserName: null,
        Password: null
      },
      user601: false
    };
  },

  mounted: function mounted() {
    this.$nextTick(function () {
      if (this.key) {
        this.$session.start();
        this.$session.set('jwt', this.key);
        this.getCurrentUser();
      }
    });
  },
  methods: {
    forgotPassword: function forgotPassword(event) {
      event.preventDefault();
      this.$router.push('forgotPassword');
    },
    proceed: function proceed(event) {
      var _this = this;

      event.preventDefault();
      this.formSubmitted = true;

      if (this.formValid) {
        this.showSpinner = true;
        this.user601 = false;
        var apiUrl = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + 'login';
        this.$axios.post(apiUrl, 'userName=' + encodeURIComponent(this.credentials.UserName) + '&password=' + encodeURIComponent(this.credentials.Password) + '&grant_type=password', {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          if (response.status === 200 && 'access_token' in response.data) {
            _this.$session.start();
            _this.$session.set('jwt', response.data.access_token);
            _this.getCurrentUser();
          }
        }).catch(function (err) {
          _this.showSpinner = false;
          if (err.response && err.response.data.error == 'not_allow_601') {
            _this.user601 = true;
          } else {
            _this.loginFailed = true;
          }
          return err;
        });
      }
    },
    getCurrentUser: function getCurrentUser() {
      var _this2 = this;

      var apiUrl = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + 'Current';
      this.$axios.get(apiUrl, { headers: { 'Authorization': 'Bearer ' + this.$session.get('jwt') } }).then(function (response) {
        _this2.showSpinner = false;
        if (response.status === 200) {
          var user = response.data;
          _this2.$session.set('user', user);
          window.user.IsLoggedIn = true;

          __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].checkRoles();
          __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].checkCurrentUserAvatar();
          __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].useCurrentUserLocale();

          if (__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isCurrentUserAdmin || __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isCurrentUserMMPWM) {
            _this2.$router.push('/dashboard/userslist');
            return;
          }

          if (_this2.key) {
            _this2.$router.push('/dashboard/changePassword');
            return;
          } else {
            _this2.$router.push('/dashboard');
            return;
          }
        }
      }).catch(function (err) {
        _this2.showSpinner = false;
        if (err.response.status === 401) {
          _this2.$session.destroy();
          _this2.$router.push('login');
        }
        _this2.loginFailed = true;
        return err;
      });
    },
    closeLoginFilled: function closeLoginFilled(event) {
      event.preventDefault();
      this.loginFilled = true;
    }
  },
  computed: {
    loginValid: function loginValid() {
      return !__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].emailInBlackList(this.credentials.UserName);
    },
    loginFilled: function loginFilled() {
      return !!this.credentials.UserName;
    },
    passwordFilled: function passwordFilled() {
      return !!this.credentials.Password;
    },
    requiredError: function requiredError() {
      return !this.formValid && this.formSubmited;
    },
    formValid: function formValid() {
      return this.formSubmitted && this.loginFilled && this.passwordFilled && this.loginValid;
    },
    labels: function labels() {
      return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.strings.Login;
    }
  },
  beforeCreate: function beforeCreate() {
    if (this.$session.exists()) {
      this.$router.push('/dashboard');
    };
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_userMethods_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: "resendWelcome",
    props: ['email', 'userType'],
    components: {
        PulseLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue___default.a
    },
    data: function data() {
        return {
            showEmailSpinner: false
        };
    },

    created: function created() {
        var self = this;
        this.showEmailSpinner = true;
        __WEBPACK_IMPORTED_MODULE_2__shared_userMethods_js__["a" /* default */].sendWelcomeEmail(this, this.email, null, this.userType).then(function (response) {
            self.showEmailSpinner = false;
            self.$router.push("/login");
        });
    },
    computed: {
        labels: function labels() {
            return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.strings.ResendWelcome;
        }
    }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_js_modal__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_userMethods_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(7);






__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_js_modal___default.a, { dialog: true });

/* harmony default export */ __webpack_exports__["default"] = ({
	name: "usersList",
	components: {
		PulseLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_PulseLoader_vue___default.a
	},
	data: function data() {
		return {
			fullView: false,
			users: [],
			totalUsersCount: 0,
			filteredUsersCount: 0,
			usersCount: 0,
			loadMoreBusy: true,
			loadingUsers: false,
			hasQuickSearch: false,
			quickSearchText: "",
			sortBy: 'LastName',
			sortOrder: true, //true = A-Z,
			languageOptions: __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.languages,
			languageFilterValue: [],
			userStatusValue: [],
			groupsFilterOptions: [],
			groupsFilterValue: [],
			userImplementationValue: [],
			userType: [],
			mmpwmLocations: [],
			physicalLocation: [],
			loadFlags: {
				settings: true,
				users: true
			},
			skipDataUpdate: false,
			searchUsed: false,
			showEmailSpinner: false,
			defaultUserTypes: ['0', '10', '50', '99', '601']
		};
	},

	created: function created() {
		__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedSubPoint = this.$parent.usersListText;
		__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].openedPoint = this.$parent.actionText;
		__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isFiltersActive = true;

		this.getFiltersSettings();

		if (this.isCurrentUserAdmin) {
			this.userImplementationValue = [this.userImplementOptions[0]];
		} else if (this.isCurrentUserMMPWM) {
			this.userImplementationValue = [this.userImplementOptions[2]];
		}

		this.userType = this.defaultUserTypes;
	},
	beforeCreate: function beforeCreate() {
		if (!this.$session.exists()) {
			this.$router.push("login");
		}
	},
	methods: {
		editUser: function editUser(user) {
			this.$router.push('/dashboard/userslist/' + user.Id);
		},
		createDigiUser: function createDigiUser() {
			this.$router.push('/dashboard/userslist/new');
		},
		createSharePointUser: function createSharePointUser() {
			this.$router.push('/dashboard/userslist/newsharepoint');
		},
		createMMPDigiUser: function createMMPDigiUser() {
			this.$router.push('/dashboard/userslist/newmmpdigi');
		},
		unlockUser: function unlockUser(user) {
			__WEBPACK_IMPORTED_MODULE_3__shared_userMethods_js__["a" /* default */].unlockUser(this, user.Id, function () {
				user.Locked = false;
			});
		},
		activateUser: function activateUser(user, event) {
			__WEBPACK_IMPORTED_MODULE_3__shared_userMethods_js__["a" /* default */].activateUser(this, user.Id, function () {
				user.IsActive = true;
			});
		},
		setPassword: function setPassword(user) {
			this.$router.push('/dashboard/setPassword/' + user.Id);
		},
		deactivateUser: function deactivateUser(user, event) {
			__WEBPACK_IMPORTED_MODULE_3__shared_userMethods_js__["a" /* default */].deactivateUser(this, user.Id, function () {
				user.IsActive = false;
			});
		},
		sendWelcomeEmail: function sendWelcomeEmail(user, appType, noPasswd) {
			__WEBPACK_IMPORTED_MODULE_3__shared_userMethods_js__["a" /* default */].sendWelcomeEmail(this, user.Id, user.PreferredLanguage, appType, noPasswd);
		},
		getWelcomeEmailPreview: function getWelcomeEmailPreview(user, appType, noPasswd) {
			var _this = this;

			var self = this;
			self.showEmailSpinner = true;
			var html = __WEBPACK_IMPORTED_MODULE_3__shared_userMethods_js__["a" /* default */].getWelcomeEmailPreview(this, user.Id, appType, noPasswd).then(function (response) {
				self.showEmailSpinner = false;
				self.$modal.show('dialog', {
					text: response.data,
					buttons: []
				});
			}).catch(function (err) {
				self.showEmailSpinner = false;
				console.log(err);
				__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this.labels().ERROR_EMAIL_GENERATE, 'danger');
			});
		},
		sendForgotPasswordEmail: function sendForgotPasswordEmail(user, appType) {
			__WEBPACK_IMPORTED_MODULE_3__shared_userMethods_js__["a" /* default */].sendForgotPasswordEmail(this, user.Id, user.PreferredLanguage, appType);
		},
		getForgotPasswordEmailPreview: function getForgotPasswordEmailPreview(user, appType) {
			var _this2 = this;

			var self = this;
			self.showEmailSpinner = true;
			var html = __WEBPACK_IMPORTED_MODULE_3__shared_userMethods_js__["a" /* default */].getForgotPasswordEmailPreview(this, user.Id, appType).then(function (response) {
				self.showEmailSpinner = false;
				self.$modal.show('dialog', {
					text: response.data,
					buttons: []
				});
			}).catch(function (err) {
				self.showEmailSpinner = false;
				console.log(err);
				__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].showInfo(null, _this2.labels().ERROR_EMAIL_GENERATE, 'danger');
			});
		},
		toogleSortOrder: function toogleSortOrder() {
			this.sortOrder = !this.sortOrder;
			this.resetUsersData();
			this.getUsers();
		},
		sortByChange: function sortByChange() {
			this.resetUsersData();
			this.getUsers();
		},
		resetUsersData: function resetUsersData() {
			this.users = [];
			this.usersCount = 0;
			this.totalUsersCount = 0;
			this.filteredUsersCount = 0;
			this.searchUsed = true;
		},
		makeSearch: function makeSearch() {
			if (this.userImplementationValue.length == 0) {
				return;
			}
			this.hasQuickSearch = this.quickSearchText.length > 0;
			this.resetUsersData();
			this.getUsers();
		},
		resetFilters: function resetFilters() {
			var self = this;

			this.skipDataUpdate = true;

			this.languageFilterValue = [];
			this.userStatusValue = [];
			this.groupsFilterValue = [];
			if (this.isCurrentUserAdmin) {
				this.userImplementationValue = [this.userImplementOptions[0]];
			} else if (this.isCurrentUserMMPWM) {
				this.userImplementationValue = [this.userImplementOptions[2]];
			} else {
				this.userImplementationValue = [];
			}
			this.physicalLocation = [];
			this.userType = this.defaultUserTypes;

			__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
				self.skipDataUpdate = false;
				self.resetQuickSearch();
			});
		},
		resetQuickSearch: function resetQuickSearch() {
			this.hasQuickSearch = false;
			this.quickSearchText = "";

			this.resetUsersData();
			this.getUsers();
		},
		getFiltersData: function getFiltersData() {
			var language = this.languageFilterValue.map(function (item) {
				return item.code;
			}).join(',');

			var userState = 0;
			if (this.userStatusValue.length === 1) {
				var usrStatus = this.userStatusValue[0].value;
				if (usrStatus === 'enabled') {
					userState = 1;
				} else if (usrStatus === 'disabled') {
					userState = 2;
				} else {
					userState = 3;
				}
			}
			var userImplement = 0;
			if (this.userImplementationValue.length === 1) {
				var implVal = this.userImplementationValue[0].value;
				if (implVal === 'mmid') {
					userImplement = 1;
				} else if (implVal === 'sharepoint') {
					userImplement = 2;
				} else if (implVal === 'mmpwm') {
					userImplement = 3;
				}
			}

			var memberOf = this.groupsFilterValue.map(function (item) {
				return item.value;
			});

			return {
				PageSize: 15,
				Skip: this.usersCount,
				SortBy: this.sortBy,
				SortOrder: this.sortOrder ? 'ASC' : 'DESC',
				Filter: {
					QuickSearch: this.quickSearchText,
					PreferredLanguage: language,
					UserState: userState,
					MemberOf: memberOf,
					UserImplement: userImplement,
					PhysicalLocation: this.physicalLocation.length == 1 ? this.physicalLocation[0] : '',
					UserTypes: this.userType
				}
			};
		},
		toogleFilters: function toogleFilters() {
			__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isFiltersActive = !__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isFiltersActive;
		},
		loadMore: function loadMore() {
			if (!this.loadMoreBusy) {
				console.log("loadMore");
				this.getUsers();
			}
		},
		getUsers: function getUsers() {
			this.loadMoreBusy = true;
			var self = this;
			var apiUrl = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + "UsersList";

			self.loadingUsers = true;
			self.$axios.post(apiUrl, self.getFiltersData(), {
				headers: { Authorization: "Bearer " + self.$session.get("jwt") }
			}).then(function (response) {
				if (response.status === 200) {
					response.data.Users.forEach(function (item, i) {
						self.users.push(self.enrichUserData(item));
						self.usersCount = self.usersCount + 1;
					});
					self.filteredUsersCount = response.data.FilteredCount;
					self.totalUsersCount = response.data.TotalCount;

					self.loadFlags.users = true;
				}

				if (self.usersCount < self.filteredUsersCount) {
					self.loadMoreBusy = false;
				}
			}).catch(function (err) {
				self.loadMoreBusy = false;
				console.log(err);
				if (err.response && err.response.status === 401) {
					self.$session.destroy();
					self.$router.push("/login");
				}
				return err;
			}).then(function () {
				self.loadingUsers = false;
			});
		},
		getFiltersSettings: function getFiltersSettings() {
			this.loadFlags.settings = true;
			this.groupsFilterOptions = __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].userListGroups.map(function (item) {
				return { label: item, value: item };
			});
			if (this.isCurrentUserMMPWM) {
				// get locations
				var self = this;
				self.$axios.get(__WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].host + "MMPWMLocations", {
					headers: { Authorization: "Bearer " + self.$session.get("jwt") }
				}).then(function (response) {
					if (response.status === 200) {
						self.mmpwmLocations = response.data;
					}
				}).catch(function (err) {
					console.log(err);
					if (err.response && err.response.status === 401) {
						self.$session.destroy();
						self.$router.push("/login");
					}
					return err;
				});
			}
		},
		toggleUserView: function toggleUserView() {
			var self = this;
			this.fullView = !this.fullView;
			this.users.forEach(function (item, i, arr) {
				item.viewModel.fullView = self.fullView;
			});
		},
		enrichUserData: function enrichUserData(user) {
			var userModel = {};

			userModel.Id = user.AccountName;
			userModel.PrincipalName = user.PrincipalName;
			userModel.AccountName = user.AccountName;
			userModel.Email = user.Email;
			userModel.OrganizationUnit = user.OrganizationUnit;
			userModel.FirstName = user.FirstName;
			userModel.LastName = user.LastName;
			userModel.PreferredLanguage = user.PreferredLanguage;
			userModel.IsActive = user.Enabled;
			userModel.Locked = user.Locked;
			userModel.IsSharePointUser = user.IsSharePointUser;
			userModel.Groups = user.Groups;
			userModel.Domain = user.Domain;
			userModel.Company = user.Company;
			userModel.HasDigiGroups = user.HasDigiGroups;
			userModel.HasSharePointGroups = user.HasSharePointGroups;
			userModel.HasMMPDigiGroups = user.HasMMPDigiGroups;
			userModel.ExtensionAttribute6 = user.ExtensionAttribute6;
			userModel.CanonicalName = user.CanonicalName;
			userModel.viewModel = {};
			userModel.viewModel.fullView = this.fullView;

			return userModel;
		}
	},
	computed: {
		openedSubPoint: function openedSubPoint() {
			return this.labels.USERS_LIST_TEXT;
		},
		openedPoint: function openedPoint() {
			return this.labels.ACTION_TEXT;
		},
		isFiltersActive: function isFiltersActive() {
			return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isFiltersActive;
		},
		userStatusOptions: function userStatusOptions() {
			return [{ value: "enabled", label: this.labels.ACTIVE }, { value: "disabled", label: this.labels.INACTIVE }, { value: "locked", label: this.labels.LOCKED }];
		},
		userImplementOptions: function userImplementOptions() {
			return [{ value: "mmid", label: this.labels.MMID }, { value: "sharepoint", label: this.labels.EXTRANET }, { value: "mmpwm", label: "MMPWM" }];
		},
		userTypes: function userTypes() {
			return ['0', '10', '50', '51', '99', '101', '102', '103', '104', '201', '202', '299', '301', '401', '402', '403', '411', '412', '505', '601', '1001', '1002', '1005', '1010', '1020'];
		},
		showSpinner: function showSpinner() {
			return this.loadingUsers || this.loadFlags.settings == false || this.loadFlags.users == false;
		},
		labels: function labels() {
			return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].culture.strings.UsersList;
		},
		isCurrentUserAdmin: function isCurrentUserAdmin() {
			return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isCurrentUserAdmin;
		},
		isCurrentUserMMPWM: function isCurrentUserMMPWM() {
			return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isCurrentUserMMPWM;
		},
		isCurrentUserMMPWM_Admin: function isCurrentUserMMPWM_Admin() {
			return __WEBPACK_IMPORTED_MODULE_0__main_js__["globalStore"].isCurrentUserMMPWM_Admin;
		}
	},
	watch: {
		userImplementationValue: function userImplementationValue(newVal) {
			if (newVal.length == 1 && newVal[0].value == 'mmpwm') {
				return;
			}
			this.physicalLocation = [];
		}
	}
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loc_bg_strings = {
    "Login": {
        "HEADING": "Влизане в платформата MM-ID",
        "LOGIN": "Влизане",
        "USER": "Потребител",
        "PASSWORD": "Парола",
        "LOGIN_FAIL": "Неуспешно влизане",
        "LOGIN_FIELD_REQUIRED": "Полето \"Потребителско име\" е задължително",
        "PASSWORD_FIELD_REQUIRED": "Полето \"Парола\" е задължително",
        "FORGOT_PASSWORD": "Забравена парола?",
        "DIFFERENT_ACCOUNT": "Влизане с различен акаунт",
        "NO_ACCOUNT": "Нямате акаунт?",
        "REGISTER": "Регистрация с ММК digital",
        "CHANGE_DENIED_TEXT": "Моля, използвайте напр. OWA, за да промените Вашата AD-парола, или се свържете с отдела по поддръжка."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Табло",
        "ACTION_TEXT": "Действия",
        "CHANGE_PASSWORD_TEXT": "Промяна на парола",
        "MY_APPLICATIONS_TEXT": "Моите ММ приложения",
        "APPLICATIONS_TEXT": "ММ приложения",
        "USERS_LIST_TEXT": "Управление на потребител"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Табло",
        "MY_APPLICATIONS_TEXT": "Моите ММ приложения",
        "APPLICATIONS_TEXT": "ММ приложения"
    },
    "Header": {
        "USER_MENU_TEXT": "Меню на потребителя",
        "ACTION_TEXT": "Действия",
        "CHANGE_PASSWORD_TEXT": "Промяна на парола",
        "USERS_LIST_TEXT": "Управление на потребител",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Предишна парола",
        "NEW_PASSWORD": "Нова парола",
        "CONFIRM_PASSWORD": "Потвърждаване на паролата",
        "PASS_DO_NOT_MATCH": "Паролите не съвпадат",
        "PASSWORD_FIELD_REQUIRED": "Полето \"Парола\" е задължително",
        "OLD_PASSWORD_FIELD_REQUIRED": "Полето \"Предишна парола\" е задължително",
        "SUCCESS_TEXT": "Паролата е променена успешно",
        "HEADING": "Промяна на идентификационни данни в ММ-ID",
        "HELP": "Нуждаете се от помощ?",
        "SAVE": "Промяна",
        "CANCEL": "Отказ",
        "PASSWORD_CHANGE_ERROR": "Данните не бяха записани. Моля, опитайте отново по-късно",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Паролата трябва да съдържа поне 10 символа, да съдържа малки и големи букви, специален знак, цифра",
        "PASSWORD_REQUIREMENTS_TEXT": "Паролата трябва да отговаря на следните изисквания:",
        "LOWERCASE_LETTER_TEXT": "Поне една буква",
        "UPPERCASE_LETTER_TEXT": "Поне една главна буква",
        "NUMBER_TEXT": "Поне едно число",
        "SPECIAL_SYMBOL_TEXT": "Поне един специален символ",
        "PASSWORD_LENGTH_TEXT": "Да съдържа най-малко 10 знака",
        "PASSWORD_RESTRICTION_TEXT": "Личното, фамилното и потребителското име не трябва да са част от паролата",
        "CHANGE_PASSWORD_TEXT": "Промяна на паролата",
        "ACTION_TEXT": "Действия",
        "CHANGE_DENIED_TEXT": "Моля, използвайте напр. OWA, за да промените Вашата AD-парола, или се свържете с отдела по поддръжка."
    },
    "CreatePassword": {
        "PASSWORD": "Създаване на парола",
        "CONFIRM_PASSWORD": "Потвърждаване на паролата",
        "PASS_DO_NOT_MATCH": "Паролите не съвпадат",
        "PASSWORD_FIELD_REQUIRED": "Полето \"Парола\" е задължително",
        "SUCCESS_TEXT": "Данните са записани успешно",
        "HEADING": "Създаване на парола",
        "HELP": "Нуждаете се от помощ?",
        "SAVE": "Промяна",
        "CANCEL": "Отказ",
        "PASSWORD_CHANGE_ERROR": "Данните не бяха записани. Моля, опитайте отново по-късно",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Паролата трябва да съдържа поне 10 символа, малки и главни букви, специален знак, цифра",
        "PASSWORD_REQUIREMENTS_TEXT": "Паролата трябва да отговаря на следните изисквания:",
        "LOWERCASE_LETTER_TEXT": "Поне една буква",
        "UPPERCASE_LETTER_TEXT": "Поне една главна буква",
        "NUMBER_TEXT": "Поне едно число",
        "SPECIAL_SYMBOL_TEXT": "Поне един специален символ",
        "PASSWORD_LENGTH_TEXT": "Да съдържа най-малко 10 знака",
        "PASSWORD_RESTRICTION_TEXT": "Личното, фамилното и потребителското име не трябва да са част от паролата",
        "PASSWORD_WAS_SET": "Линкът вече е използван за задаване на паролата, ако не помните паролата, моля, използвайте функцията за подновяване на парола.",
        "OLD_PASSWORD_REQUIRED": "Полето \"Предишна парола\" е задължително",
        "MMID_CHANGE_PASSWORD": "Промяна на парола",
        "OLD_PASSWORD": "Предишна парола",
        "INVALID_OLD_PASSWORD": "Невалидна предишна парола",
        "USER_NOT_FOUND_OR_INACTIVE": "Потребителят не е намерен или не е активен",
        "UNKNOWN_ERROR": "Възникна грешка при промяна на паролата"
    },
    "ForgotPassword": {
        "USER": "Имейл",
        "LOGIN_FAIL": "Моля, въведете правилен имейл адрес",
        "LOGIN_FIELD_REQUIRED": "Полето \"Имейл\" е задължително",
        "HEADING": "Забравена парола",
        "HELP": "Нуждаете се от помощ?",
        "SAVE": "Изпращане на имейл за подновяване на паролата",
        "CANCEL": "Отказ",
        "SUCCESS_TEXT": "Моля, проверете входящата си поща за получен имейл.",
        "CHANGE_DENIED_TEXT": "Моля, използвайте напр. OWA, за да промените Вашата AD-парола, или се свържете с отдела по поддръжка.",
        "PASSWORD_RESET_TOO_OFTEN": "Функцията за подновяване на паролата е използвана твърде често, моля, опитайте отново по-късно",
        "RESET_FAILED": "Неуспешно влизане",
        "LINK_EXPIRED": "Връзката за влизане е изтекла. Моля, въведете Вашия имейл адрес, за да заявите отново връзката за влизане.",
        "HEADING_EXPIRED": "Вашата връзка за влизане е изтекла",
        "SAVE_EXPIRED": "Заявка за връзка за влизане"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Управление на потребител",
        "ACTIVE": "Активен",
        "INACTIVE": "Неактивен",
        "MMID": "MMID",
        "EXTRANET": "Външни потребители",
        "OU": "Организационна единица",
        "ORGANIZATION_UNIT": "Организационна единица",
        "LANGUAGE": "Език",
        "OPEN_FILTER": "Отваряне на филтър",
        "CLOSE_FILTER": "Затваряне на филтър",
        "RESET": "подновяване",
        "RESET_ALL_FILTERS": "подновяване на всички филтри",
        "SEARCH": "Търсене",
        "STATUS": "Статус",
        "GROUPS": "Групи",
        "SHOW_ALL_DETAILS": "Показване на всички детайли",
        "SHOW_LESS": "Показване на по-малко",
        "ASCENDING": "Възходящ ред",
        "DESCENDING": "Низходящ ред",
        "LIST_END": "Край на списъка",
        "SORT_BY_LASTNAME": "Сортиране по фамилно име",
        "SORT_BY_FIRSTNAME": "Сортиране по лично име",
        "SORT_BY_EMAIL": "Сортиране по имейл",
        "SORT_BY_LANGUAGE": "Сортиране по предпочитан език",
        "SORT_BY_STATUS": "Сортиране по статус",
        "SORT_BY_OU": "Сортиране по OU",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Редактиране",
        "CREATE": "Нов потребител",
        "DIGICREATE": "Нов потребител на MM digital",
        "EXTRANETCREATE": "Нов потребител на MM SharePoint Extranet",
        "MMPCREATE": "Нов потребител на MMP digital",
        "ACTIVATE": "Активиране",
        "DEACTIVATE": "Деактивиране",
        "USER_WAS_ACTIVATED": "Потребителят е активиран",
        "USER_WAS_DEACTIVATED": "Потребителят е деактивиран",
        "ERROR_USER_ACTIVATION": "Грешка по време на активирането на потребителя",
        "ERROR_USER_DEACTIVATION": "Грешка по време на деактивирането на потребителя",
        "SEND_FORGOT_PW_EMAIL": "Изпращане на имейл за забравена парола",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Общ имейл за забравена парола",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Имейл от MM digital за забравена парола",
        "SEND_FORGOT_PW_EMAIL_MMP": "Имейл от MMP digital за забравена парола",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Имейл от SP за забравена парола",
        "COMPANY": "Компания",
        "SEND_WELCOME_EMAIL": "Изпращане на приветствен имейл",
        "SEND_WELCOME_EMAIL_DIGI": "Приветстващ имейл на MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Приветстващ имейл на MM digital без бутон за парола",
        "SEND_WELCOME_EMAIL_MMP": "Приветстващ имейл на MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Приветстващ имейл на MMP digital без бутон за парола",
        "SEND_WELCOME_EMAIL_EXTRANET": "Приветстващ имейл на SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Приветстващ имейл на SP без бутон за парола",
        "APPLY_FILTER_FOR_USERS": "Моля, използвайте филтрите или търсачката за показване на резултатите",
        "GENERATING_EMAIL": "Генериране на имейл ....",
        "ERROR_EMAIL_GENERATE": "Грешка при генериране на имейл ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Управление на потребител",
        "USER_WAS_ACTIVATED": "Потребителят е активиран",
        "USER_WAS_DEACTIVATED": "Потребителят е деактивиран",
        "ERROR_USER_ACTIVATION": "Грешка по време на активирането на потребител",
        "ERROR_USER_DEACTIVATION": "Грешка по време на деактивирането на потребител",
        "LOADING_USER_ERROR": "Грешка при зареждане на потребител",
        "FIRSTNAME": "Лично име",
        "LASTNAME": "Фамилно име",
        "EMAIL": "Имейл",
        "ACCOUNT_NAME": "Потребителско име за влизане (по-стари версии от Windows 2000)",
        "LANGUAGE": "Език",
        "PRINCIPAL_NAME": "Основно име на потребителя",
        "OU": "Организационна единица",
        "CLASS_DISPLAY_NAME": "Показване на името",
        "PHONE": "Телефон",
        "WEBSITE": "Уебсайт",
        "COUNTRY": "Държава",
        "STATE": "Щат",
        "LOCATION": "Град",
        "STREET": "Улица",
        "POSTAL_CODE": "Пощенски код",
        "COMPANY": "Компания",
        "DEPARTMENT": "Отдел",
        "PERSONAL_TITLE": "Лично обръщение",
        "MANAGER": "Ръководител",
        "DESCRIPTION": "Описание",
        "GROUPS": "Групи",
        "SAVE": "Записване",
        "CANCEL": "Отказ",
        "USER_STATUS": "Статус на потребителя",
        "ACTIVE": "Активен",
        "INACTIVE": "Неактивен",
        "ACTIVATE": "Активиране",
        "DEACTIVATE": "Деактивиране",
        "USER_WAS_SAVED": "Потребителят е записан",
        "UNKNOWN_ERROR": "Възникна неизвестна грешка при записване на потребителя",
        "PROXY_ADDRESSES": "Прокси адреси",
        "BROWSE": "Търсене",
        "REMOVE": "Премахване",
        "ONLY_JPG": "Позволени са само изображения jpg!",
        "FILE_SIZE": "Размерът на файла трябва да е по-малък от 100КВ!",
        "DIMENSIONS": "Максималните размери на изображенията са 96х96 пиксела!",
        "SEND_FORGOT_PW_EMAIL": "Изпращане на имейл за забравена парола",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Общ имейл за забравена парола",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Имейл от MM digital за забравена парола",
        "SEND_FORGOT_PW_EMAIL_MMP": "Имейл от MMP digital за забравена парола",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Имейл от SP за забравена парола",
        "VIRUS_FOUND": "Потребителят не бе записан. В приложението бе открит зловреден софтуер. Файлът няма да бъде качен. Моля, свържете се с Вашия системен администратор.",
        "VIRUS_SCANNER_NOT_AVL": "Сканирането на файла за зловреден софтуер бе неуспешно. Моля, опитайте отново по-късно. Ако проблемът продължи, свържете се с Вашия системен администратор.",
        "INFO": "Информация:",
        "SEND_WELCOME_EMAIL": "Изпращане на приветстващ имейл",
        "SEND_WELCOME_EMAIL_DIGI": "Приветстващ имейл на MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Приветстващ имейл на MM digital без бутон за парола",
        "SEND_WELCOME_EMAIL_MMP": "Приветстващ имейл на MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Приветстващ имейл на MMP digital без бутон за парола",
        "SEND_WELCOME_EMAIL_EXTRANET": "Приветстващ имейл на SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Приветстващ имейл на SP без бутон за парола",
        "SAVING_USER_SPINNER": "Записване на потребител... Моля, изчакайте",
        "DUPLICATE_USER": "Потребителят вече съществува",
        "GENERATING_EMAIL": "Генериране на имейл ....",
        "ERROR_EMAIL_GENERATE": "Грешка при генериране на имейл ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Потребителят не е намерен",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Потребителят е активиран",
        "USER_WAS_DEACTIVATED": "Потребителят е деактивиран",
        "ERROR_USER_ACTIVATION": "Грешка по време на активиране на потребител",
        "ERROR_USER_DEACTIVATION": "Грешка по време на деактивиране на потребител",
        "EMAIL_WAS_SENT": "Имейлът е изпратен успешно",
        "EMAIL_NOT_SENT_USER_ACTIVE": "Имейлът не бе изпратен. Потребителят вече е активен. Вместо това, използвайте функцията \"Изпращане на имейл за забравена парола\"",
        "ERROR_EMAIL_SEND": "Грешка при опита за изпращане на имейл",
        "EMAIL_NOT_SENT_USER_INACTIVE": "Имейлът не бе изпратен. Потребителят е неактивен. Използвайте функция \"Изпращане на имейл за регистрация в MM digital\".",
        "PASSWORD_RESET_TOO_OFTEN": "Функцията за подновяване на паролата е използвана твърде често, моля, опитайте отново по-късно",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Генериране на добре дошли електронна поща ...."
    }
};

/* harmony default export */ __webpack_exports__["a"] = (loc_bg_strings);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loc_cs_strings = {
    "Login": {
        "HEADING": "Přihlášení pomocí MM ID",
        "LOGIN": "Přihlášení",
        "USER": "Uživatel",
        "PASSWORD": "Heslo",
        "LOGIN_FAIL": "Přihlášení se nezdařilo",
        "LOGIN_FIELD_REQUIRED": "„Uživatelské jméno“ je povinné pole",
        "PASSWORD_FIELD_REQUIRED": "„Heslo“ je povinné pole",
        "FORGOT_PASSWORD": "Zapomenuté heslo?",
        "DIFFERENT_ACCOUNT": "Přihlásit se jiným účtem",
        "NO_ACCOUNT": "Nemáte účet? ",
        "REGISTER": "Registrovat se pomocí MM digital",
        "CHANGE_DENIED_TEXT": "Pro změnu AD hesla použijte např. Outlook Web Access nebo kontaktujte svou podporu."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Dashboard",
        "ACTION_TEXT": "Akce",
        "CHANGE_PASSWORD_TEXT": "Změnit heslo",
        "MY_APPLICATIONS_TEXT": "Mé aplikace MM",
        "APPLICATIONS_TEXT": "Aplikace MM",
        "USERS_LIST_TEXT": "Správa uživatelů"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Dashboard",
        "MY_APPLICATIONS_TEXT": "Mé aplikace MM",
        "APPLICATIONS_TEXT": "Aplikace MM"
    },
    "Header": {
        "USER_MENU_TEXT": "Uživatelské menu",
        "ACTION_TEXT": "Akce",
        "CHANGE_PASSWORD_TEXT": "Změna hesla",
        "USERS_LIST_TEXT": "Správa uživatelů",
        "USER_GROUPS": "Role"
    },
    "Credentials": {
        "OLD_PASSWORD": "Staré heslo",
        "NEW_PASSWORD": "Nové heslo",
        "CONFIRM_PASSWORD": "Potvrdit heslo",
        "PASS_DO_NOT_MATCH": " Hesla se neshodují",
        "PASSWORD_FIELD_REQUIRED": "„Heslo“ je povinné pole",
        "OLD_PASSWORD_FIELD_REQUIRED": "„Staré heslo“ je povinné pole",
        "SUCCESS_TEXT": "Heslo bylo úspěšně změněno",
        "HEADING": "Pověření ke změně MM-ID",
        "HELP": "Potřebujete pomoc?",
        "SAVE": "Změnit",
        "CANCEL": "Zrušit",
        "PASSWORD_CHANGE_ERROR": "Uložení dat se nezdařilo. Prosím, zkuste to znovu později",
        "PASSWORD_STREIGHT_ERROR": "Heslo musí mít nejméně 10 znaků a obsahovat malé a velké písmeno, speciální znak a číslici",
        "PASSWORD_REQUIREMENTS_TEXT": "Heslo musí splňovat následující požadavky:",
        "LOWERCASE_LETTER_TEXT": "Alespoň jedno písmeno ",
        "UPPERCASE_LETTER_TEXT": "Alespoň jedno velké písmeno",
        "NUMBER_TEXT": "Alespoň jedno číslo",
        "SPECIAL_SYMBOL_TEXT": "Alespoň jeden speciální znak",
        "PASSWORD_LENGTH_TEXT": "Mít délku alespoň 10 znaků",
        "PASSWORD_RESTRICTION_TEXT": "Heslo nesmí obsahovat jméno, příjmení ani uživatelské jméno",
        "CHANGE_PASSWORD_TEXT": "Změnit heslo",
        "ACTION_TEXT": "Akce",
        "CHANGE_DENIED_TEXT": "Pro změnu AD hesla použijte např. Outlook Web Access nebo kontaktujte svou podporu."
    },
    "CreatePassword": {
        "PASSWORD": "Vytvořit heslo",
        "CONFIRM_PASSWORD": "Potvrďte své heslo",
        "PASS_DO_NOT_MATCH": "Hesla se neshodují",
        "PASSWORD_FIELD_REQUIRED": "„Heslo“ je povinné pole",
        "SUCCESS_TEXT": "Data byla úspěšně uložena",
        "HEADING": "Vytvořit heslo",
        "HELP": "Potřebujete pomoc?",
        "SAVE": "Změnit",
        "CANCEL": "Zrušit",
        "PASSWORD_CHANGE_ERROR": "Uložení dat se nezdařilo Prosím, zkuste to znovu později",
        "PASSWORD_STREIGHT_ERROR": "Heslo musí mít nejméně 10 znaků a obsahovat malé a velké písmeno, speciální znak a číslici",
        "PASSWORD_REQUIREMENTS_TEXT": "Heslo musí splňovat následující požadavky:",
        "LOWERCASE_LETTER_TEXT": "Alespoň jedno písmeno",
        "UPPERCASE_LETTER_TEXT": "Alespoň jedno velké písmeno",
        "NUMBER_TEXT": "Alespoň jedno číslo",
        "SPECIAL_SYMBOL_TEXT": "Alespoň jeden speciální znak",
        "PASSWORD_LENGTH_TEXT": "Mít délku alespoň 10 znaků",
        "PASSWORD_RESTRICTION_TEXT": "Heslo nesmí obsahovat jméno, příjmení ani uživatelské jméno",
        "PASSWORD_WAS_SET": "Tento odkaz už byl pro nastavení hesla použit. Pokud si heslo nepamatujete, použijte prosím funkci resetovat heslo.",
        "OLD_PASSWORD_REQUIRED": "„Staré heslo“ je povinné pole",
        "MMID_CHANGE_PASSWORD": "Změnit heslo",
        "OLD_PASSWORD": "Staré heslo",
        "INVALID_OLD_PASSWORD": "Neplatné staré heslo",
        "USER_NOT_FOUND_OR_INACTIVE": "Uživatel nenalezen nebo je neaktivní",
        "UNKNOWN_ERROR": "Při změně hesla došlo k chybě"
    },
    "ForgotPassword": {
        "USER": "Email",
        "LOGIN_FAIL": "Prosím zadejte správnou emailovou adresu",
        "LOGIN_FIELD_REQUIRED": "„Email“ je povinné pole",
        "HEADING": "Zapomenuté heslo",
        "HELP": "Potřebujete pomoc?",
        "SAVE": "Zaslat email pro resetování hesla",
        "CANCEL": "Zrušit",
        "SUCCESS_TEXT": "Prosím zkontrolujte, zda máte v přijaté poště novou zprávu.",
        "CHANGE_DENIED_TEXT": "Pro změnu AD hesla použijte např. Outlook Web Access nebo kontaktujte podporu.",
        "PASSWORD_RESET_TOO_OFTEN": "Funkce resetovat heslo byla použita příliš mnohokrát, prosím zkuste to znovu později",
        "RESET_FAILED": "Přihlášení se nezdařilo",
        "LINK_EXPIRED": "Váš přihlašovací odkaz vypršel. Pro zaslání přihlašovacího odkazu zadejte znovu svou emailovou adresu.",
        "HEADING_EXPIRED": "Váš přihlašovací odkaz vypršel",
        "SAVE_EXPIRED": "Vyžádat přihlašovací odkaz"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Správa uživatelů",
        "ACTIVE": "Aktivní",
        "INACTIVE": "Neaktivní",
        "MMID": "MMID",
        "EXTRANET": "Externí uživatelé",
        "OU": "Organizační jednotka",
        "ORGANIZATION_UNIT": "Organizační jednotka",
        "LANGUAGE": "Jazyk",
        "OPEN_FILTER": "Otevřít filtr",
        "CLOSE_FILTER": "Zavřít filtr",
        "RESET": "resetovat",
        "RESET_ALL_FILTERS": "Resetovat všechny filtry",
        "SEARCH": "Hledat",
        "STATUS": "Stav",
        "GROUPS": "Skupiny",
        "SHOW_ALL_DETAILS": "Zobrazit všechny detaily",
        "SHOW_LESS": "Zobrazit méně",
        "ASCENDING": "Vzestupně",
        "DESCENDING": "Sestupně",
        "LIST_END": "Konec seznamu",
        "SORT_BY_LASTNAME": "Seřadit podle příjmení",
        "SORT_BY_FIRSTNAME": "Seřadit podle jména",
        "SORT_BY_EMAIL": "Seřadit podle emailu",
        "SORT_BY_LANGUAGE": "Seřadit podle preferovaného jazyka",
        "SORT_BY_STATUS": "Seřadit podle stavu",
        "SORT_BY_OU": "Seřadit podle OJ",
        "EDIT": "Editovat",
        "CREATE": "Nový uživatel",
        "DIGICREATE": "Nový uživatel MM digital",
        "EXTRANETCREATE": "Nový uživatel MM SharePoint z extranetu",
        "ACTIVATE": "Aktivovat",
        "DEACTIVATE": "Deaktivovat",
        "USER_WAS_ACTIVATED": "Uživatel byl aktivován",
        "USER_WAS_DEACTIVATED": "Uživatel byl deaktivován",
        "ERROR_USER_ACTIVATION": "Chyba při aktivaci uživatele",
        "ERROR_USER_DEACTIVATION": "Chyba při deaktivaci uživatele",
        "SEND_FORGOT_PW_EMAIL": "Zaslat email při zapomenutí hesla",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Obecný email při zapomenutí hesla",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Email při zapomenutí hesla MM digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Email při zapomenutí hesla SP",
        "COMPANY": "Společnost",
        "SEND_WELCOME_EMAIL": "Zaslat uvítací email",
        "SEND_WELCOME_EMAIL_DIGI": "Uvítací email MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Uvítací email MM digital bez tlačítka Heslo",
        "SEND_WELCOME_EMAIL_EXTRANET": "Uvítací email SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Uvítací email SP bez tlačítka Heslo",
        "APPLY_FILTER_FOR_USERS": "K zobrazení výsledků použijte filtry nebo hledání",
        "GENERATING_EMAIL": "Vytváří se email....",
        "ERROR_EMAIL_GENERATE": "Chyba při vytváření emailu....",
        "SORT_BY_ACCOUNT_NAME": "Seřadit podle přihlašovacího jména",
        "LOCKED": "Uzamčeno",
        "UNLOCK": "Odemknout",
        "SET_PASSWORD": "Nastavit heslo",
        "PHYSICAL_LOCATION": "Umístění",
        "REQUIRED": "Požadováno",
        "MMPCREATE": "Nový uživatel MMP digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "Email při zapomenutí hesla MMP digital",
        "SEND_WELCOME_EMAIL_MMP": "Uvítací email MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Uvítací email MMP digital bez tlačítka Heslo",
        "USER_TYPE": "Typ uživatele",
        "CANONICAL_NAME": "Obecný název"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Správa uživatelů",
        "USER_WAS_ACTIVATED": "Uživatel byl aktivován",
        "USER_WAS_DEACTIVATED": "Uživatel byl deaktivován",
        "ERROR_USER_ACTIVATION": "Chyba při aktivaci uživatele",
        "ERROR_USER_DEACTIVATION": "Chyba při deaktivaci uživatele",
        "LOADING_USER_ERROR": "Chyba při načítání uživatele",
        "FIRSTNAME": "Jméno",
        "LASTNAME": "Příjmení",
        "EMAIL": "Email",
        "ACCOUNT_NAME": "Přihlašovací jméno uživatele (před Windows 2000)",
        "LANGUAGE": "Jazyk",
        "PRINCIPAL_NAME": "Hlavní jméno uživatele (UPN)",
        "OU": "Organizační jednotka",
        "CLASS_DISPLAY_NAME": "Zobrazené jméno",
        "PHONE": "Telefon",
        "WEBSITE": "Webové stránky",
        "COUNTRY": "Země",
        "STATE": "Stát",
        "LOCATION": "Město",
        "STREET": "Ulice",
        "POSTAL_CODE": "PSČ",
        "COMPANY": "Společnost",
        "DEPARTMENT": "Oddělení",
        "PERSONAL_TITLE": "Oslovení",
        "MANAGER": "Manažer",
        "DESCRIPTION": "Popis",
        "GROUPS": "Skupiny",
        "SAVE": "Uložit",
        "CANCEL": "Zrušit",
        "USER_STATUS": "Stav uživatele",
        "ACTIVE": "Aktivní",
        "INACTIVE": "Neaktivní",
        "ACTIVATE": "Aktivovat",
        "DEACTIVATE": "Deaktivovat",
        "USER_WAS_SAVED": "Uživatel byl uložen. Aktualizace serverů může trvat až 60 sekund<br/> Pokud se vám zobrazují stará data, aktualizujte stránku vždy po 30 sekundách.",
        "UNKNOWN_ERROR": "Při ukládání uživatele došlo k neznámé chybě",
        "PROXY_ADDRESSES": "Proxy adresy",
        "BROWSE": "Procházet",
        "REMOVE": "Odstranit",
        "ONLY_JPG": "Jsou dovoleny pouze obrázky ve formátu jpg!",
        "FILE_SIZE": "Soubor musí být menší než 100 kB!",
        "DIMENSIONS": "Maximální velikost obrázku je 96x96 pixelů!",
        "SEND_FORGOT_PW_EMAIL": "Zaslat email při zapomenutí hesla",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Obecný email při zapomenutí hesla",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Email při zapomenutí hesla MM digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Email při zapomenutí hesla SP",
        "VIRUS_FOUND": "Uložení uživatele se nezdařilo. V příloze byl nalezen malware. Soubor nebude načten. Kontaktujte svého systémového administrátora.",
        "VIRUS_SCANNER_NOT_AVL": "Soubor nemohl být prověřen na přítomnost malware. Prosím, zkuste to znovu později. Pokud problém přetrvává, kontaktujte svého systémového administrátora.",
        "INFO": "Informace:",
        "SEND_WELCOME_EMAIL": "Zaslat uvítací email",
        "SEND_WELCOME_EMAIL_DIGI": "Uvítací email MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Uvítací email MM digital bez tlačítka Heslo",
        "SEND_WELCOME_EMAIL_EXTRANET": "Uvítací email SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Uvítací email SP bez tlačítka Heslo",
        "SAVING_USER_SPINNER": "Ukládání uživatele... Čekejte, prosím",
        "DUPLICATE_USER": "Uživatel již existuje",
        "GENERATING_EMAIL": "Vytváří se email....",
        "ERROR_EMAIL_GENERATE": "Chyba při vytváření emailu....",
        "UNLOCK": "Odemknout",
        "SET_PASSWORD": "Nastavit heslo",
        "COST_CENTER": "Nákladové středisko",
        "JOB_TITLE": "Pracovní pozice",
        "GENDER": "Pohlaví",
        "SEND_FORGOT_PW_EMAIL_MMP": "Email při zapomenutí hesla MMP digital",
        "SEND_WELCOME_EMAIL_MMP": "Uvítací email MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Uvítací email MMP digital bez tlačítka Heslo",
        "USER_NOT_FOUND": "Uživatel nenalezen",
        "USER_TYPE": "Typ uživatele",
        "CANONICAL_NAME": "Obecný název"
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Uživatel byl aktivován",
        "USER_WAS_DEACTIVATED": "Uživatel byl deaktivován",
        "ERROR_USER_ACTIVATION": "Chyba při aktivaci uživatele",
        "ERROR_USER_DEACTIVATION": "Chyba při deaktivaci uživatele",
        "EMAIL_WAS_SENT": "Email byl úspěšně odeslán",
        "EMAIL_NOT_SENT_USER_ACTIVE": "Email nebyl odeslán Uživatel už je aktivní. Použijte raději funkci Zaslat email při zapomenutí hesla",
        "ERROR_EMAIL_SEND": "Chyba při odesílání emailu",
        "EMAIL_NOT_SENT_USER_INACTIVE": "Email nebyl odeslán. Uživatel je neaktivní. Použijte funkci Zaslat registrační email MM digital.",
        "PASSWORD_RESET_TOO_OFTEN": "Funkce resetování hesla byla použita příliš mnohokrát, prosím, zkuste to znovu později",
        "USER_WAS_UNLOCKED": "Uživatel byl odemknut",
        "ERROR_UNLOCK_USER": "Chyba při odemykání uživatele"
    },
    "Backend": {
        "FieldRequired": "Toto pole je povinné.",
        "FirstName": "Jméno",
        "InvalidEmail": "Prosím zadejte správnou emailovou adresu",
        "InvalidPhone": "Neplatné telefonní číslo.",
        "LastName": "Příjmení",
        "StringLength": "Pole musí být řetězec o minimální délce {2} a maximální délce {1}."
    },
    "Emails": {
        "Header": "Váš účet pro aplikaci {{var-app-name}}",
        "Welcome": "Vítejte v aplikaci {{var-app-name}}",
        "HelloLine": "Vážený/á {{var-salutation}} {{var-first-name}} {{var-last-name}}",
        "AccountCreatedLine": "Váš účet pro aplikaci {{var-app-name}} byl úspěšně vytvořen. Pro dokončení aktivace ověřte svou emailovou adresu kliknutím na následující tlačítko:",
        "Login": "Přihlásit se",
        "SingInLink": "K přihlášení můžete v budoucnu použít následující odkaz:",
        "AccountDetails": "Údaje o Vašem účtu:",
        "Email": "Email",
        "FristName": "Jméno",
        "LastName": "Příjmení",
        "SupportAssist": "V případě jakýchkoli dotazů, Vám naše <b><a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-app-name}} podpora</a></b> ráda pomůže.",
        "BestRegards": "Se srdečným pozdravem,<br/> Váš {{var-app-name-2}} tým",
        "ContactSupport": "Kontaktovat podporu",
        "ForgotPassword": "Zapomenuté heslo",
        "PleaseResetPassword": "Prosím, resetujte své heslo pro {{var-app-name}}",
        "ResetPasswordLine": "Heslo svého účtu {{var-app-name}} můžete resetovat během následujících 24 hodin kliknutím na následující tlačítko:",
        "ResetPassword": "Resetovat heslo",
        "IgnoreEmailLine": "V případě, že si nepřejete resetovat heslo, ignorujte tento email.",
        "ResendWelcome1": "Tento přihlašovací odkaz platí 5 dnů:",
        "ResendWelcome2": "Znovu vyžádat přihlašovací odkaz",
        "ContactSupportMMK": "Kontaktujte podporu MM digital",
        "AccountCreatedLine_NoButton": "Váš {{var-app-name}} účet byl úspěšně vytvořen.",
        "ContactSupportMMP": "Kontaktujte podporu MMP digital",
        "CreateUserSubject": "Vítejte v aplikaci {{var-app-name}}",
        "ForgotPasswordSubject": "{{var-app-name}}: Resetovat heslo",
        "SupportAssistMMP": "V případě dotazů se obraťte přímo na svého místně příslušného obchodního partnera. V případě technických potíží se můžete spojit s týmem podpory {{var-app-name}} na <a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-support-email}}</a>",
        "SupportAssistMMK": "V případě jakýchkoli dotazů, Vám naše <b><a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-app-name}} podpora</a></b> ráda pomůže.",
        "SupportAssistSharepoint": "V případě jakýchkoli dotazů, Vám naše <b><a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-app-name}} podpora</a></b> ráda pomůže."
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Vytváří se uvítací email...."
    }
};

/* harmony default export */ __webpack_exports__["a"] = (loc_cs_strings);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loc_de_strings = {
    "Login": {
        "HEADING": "Login MM-ID Plattform",
        "LOGIN": "Login",
        "USER": "Benutzer",
        "PASSWORD": "Passwort",
        "LOGIN_FAIL": "Login fehlgeschlagen",
        "LOGIN_FIELD_REQUIRED": "Der \"Benutzername\" ist ein Pflichtfeld",
        "PASSWORD_FIELD_REQUIRED": "Das \"Passwort\" ist ein Pflichtfeld",
        "FORGOT_PASSWORD": "Passwort vergessen?",
        "DIFFERENT_ACCOUNT": "Melden Sie sich mit einem anderen Account an",
        "NO_ACCOUNT": "Kein Account?",
        "REGISTER": "Registrieren Sie sich bei MM digital",
        "CHANGE_DENIED_TEXT": "Bitte verwenden sie z.B. OWA um Ihr AD-Passwort zu ändern, oder kontaktieren Sie Ihren Support."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Dashboard",
        "ACTION_TEXT": "Aktionen",
        "CHANGE_PASSWORD_TEXT": "Passwort ändern",
        "MY_APPLICATIONS_TEXT": "Meine MM-Anwendungen",
        "APPLICATIONS_TEXT": "MM-Anwendungen",
        "USERS_LIST_TEXT": "Benutzerverwaltung"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Dashboard",
        "MY_APPLICATIONS_TEXT": "Meine MM-Anwendungen",
        "APPLICATIONS_TEXT": "MM-Anwendungen"
    },
    "Header": {
        "USER_MENU_TEXT": "Benutzermenü",
        "ACTION_TEXT": "Aktionen",
        "CHANGE_PASSWORD_TEXT": "Passwort ändern",
        "USERS_LIST_TEXT": "Benutzerverwaltung",
        "USER_GROUPS": "Rollen"
    },
    "Credentials": {
        "OLD_PASSWORD": "Passwort",
        "NEW_PASSWORD": "Neues Passwort",
        "CONFIRM_PASSWORD": "Passwort bestätigen",
        "PASS_DO_NOT_MATCH": "Die Passwörter stimmen nicht überein",
        "PASSWORD_FIELD_REQUIRED": "Das \"Neue Passwort\" ist ein Pflichtfeld",
        "OLD_PASSWORD_FIELD_REQUIRED": "Das \"Alte Passwort\" ist ein Pflichtfeld",
        "SUCCESS_TEXT": "Das Passwort wurde erfolgreich geändert",
        "HEADING": "MM-ID ändern der Anmeldeinformationen",
        "HELP": "Brauche Hilfe?",
        "SAVE": "Speichern",
        "CANCEL": "Abbrechen",
        "PASSWORD_CHANGE_ERROR": "Das Passwort kann jetzt nicht geändert werden. Bitte versuchen sie es später erneut",
        "PASSWORD_CHANGE_LINK_EXPIRED": "Der Passwort zurücksetzen Link ist entweder ungültig, oder abgelaufen. Bitte senden sie sich den Link nochmals.",
        "PASSWORD_STREIGHT_ERROR": "Das Passwort sollte mindestens 10 Symbole enthalten, darunter untere, obere, Sonderzeichen, Ziffern und Unicode",
        "PASSWORD_REQUIREMENTS_TEXT": "Das Passwort muss die folgenden Kriterien erfüllen:",
        "LOWERCASE_LETTER_TEXT": "Mindestens 1 Kleinbuchstabe",
        "UPPERCASE_LETTER_TEXT": "Mindestens 1 Großbuchstabe",
        "NUMBER_TEXT": "Mindestens 1 Zahl",
        "SPECIAL_SYMBOL_TEXT": "Mindestens 1 Sonderzeichen",
        "PASSWORD_LENGTH_TEXT": "Mindestlänge 10 Zeichen",
        "PASSWORD_RESTRICTION_TEXT": "Der Vor-, Nach-, oder Benutzername darf nicht Teil des Passwortes sein",
        "CHANGE_PASSWORD_TEXT": "Passwort ändern",
        "ACTION_TEXT": "Aktionen",
        "CHANGE_DENIED_TEXT": "Bitte verwenden Sie z.B. OWA um Ihr AD-Passwort zu ändern, oder kontaktieren Sie Ihren Support."
    },
    "CreatePassword": {
        "PASSWORD": "Neues Passwort",
        "CONFIRM_PASSWORD": "Bestätigen Sie Ihr Passwort",
        "PASS_DO_NOT_MATCH": "Die Passwörter stimmen nicht überein",
        "PASSWORD_FIELD_REQUIRED": "Das \"Neue Passwort\" ist ein Pflichtfeld",
        "SUCCESS_TEXT": "Die Daten wurden erfolgreich gespeichert",
        "HEADING": "Passwort erstellen",
        "HELP": "Brauchen Sie Hilfe?",
        "SAVE": "Speichern",
        "CANCEL": "Abbrechen",
        "PASSWORD_CHANGE_ERROR": "Das Passwort kann jetzt nicht geändert werden. Bitte versuchen sie es später erneut",
        "PASSWORD_CHANGE_LINK_EXPIRED": "Der Passwort zurücksetzen Link ist entweder ungültig, oder abgelaufen. Bitte senden sie sich den Link nochmals.",
        "PASSWORD_STREIGHT_ERROR": "Das Passwort sollte mindestens 10 Symbole enthalten, darunter untere, obere, Sonderzeichen, Ziffern und Unicode",
        "PASSWORD_REQUIREMENTS_TEXT": "Das Passwort muss die folgenden Kriterien erfüllen:",
        "LOWERCASE_LETTER_TEXT": "Mindestens 1 Kleinbuchstabe",
        "UPPERCASE_LETTER_TEXT": "Mindestens 1 Großbuchstabe",
        "NUMBER_TEXT": "Mindestens 1 Zahl",
        "SPECIAL_SYMBOL_TEXT": "Mindestens 1 Sonderzeichen",
        "PASSWORD_LENGTH_TEXT": "Mindestlänge 10 Zeichen",
        "PASSWORD_RESTRICTION_TEXT": "Der Vor-, Nach-, oder Benutzername darf nicht Teil des Passwortes sein",
        "PASSWORD_WAS_SET": "Der Link zur Passwortvergabe wurde bereits verwendet. Wenn Sie Ihr Passwort nicht mehr wissen, benutzen Sie bitte die Passwort Reset Funktion.",
        "OLD_PASSWORD_REQUIRED": "Das \"Altes Passwort\" ist ein Pflichtfeld",
        "MMID_CHANGE_PASSWORD": "Passwort ändern",
        "OLD_PASSWORD": "Altes Passwort",
        "INVALID_OLD_PASSWORD": "Ungültiges altes Passwort",
        "USER_NOT_FOUND_OR_INACTIVE": "Benutzer nicht gefunden, oder inaktiv",
        "UNKNOWN_ERROR": "Es trat ein Fehler auf, das Passwort konnte nicht geändert werden"
    },
    "ForgotPassword": {
        "USER": "E-Mail",
        "LOGIN_FAIL": "Bitte geben Sie die korrekte E-Mail Adresse ein",
        "LOGIN_FIELD_REQUIRED": "Die \"E-mail Adresse\" ist ein Pflichtfeld",
        "HEADING": "Passwort vergessen",
        "HELP": "Brauchen Sie Hilfe?",
        "SAVE": "Reset Passwort E-Mail senden",
        "CANCEL": "Abbrechen",
        "SUCCESS_TEXT": "Bitte prüfen Sie, ob Sie eine E-Mail erhalten haben.",
        "CHANGE_DENIED_TEXT": "Bitte verwenden Sie z.B. OWA um Ihr AD-Passwort zu ändern, oder kontaktieren Sie Ihren Support.",
        "PASSWORD_RESET_TOO_OFTEN": "Die Passwort Reset Funktion wurde zu oft verwendet, bitte versuchen Sie es später",
        "RESET_FAILED": "Login fehlgeschlagen",
        "LINK_EXPIRED": "Der Link zum Zurücksetzen des Passworts ist abgelaufen. Bitte geben Sie Ihre Emailadresse ein, um Ihnen den Login Link erneut zusenden zu lassen.",
        "HEADING_EXPIRED": "Ihr Login Link ist abgelaufen",
        "SAVE_EXPIRED": "Login Link zusenden"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Benutzerverwaltung",
        "ACTIVE": "Aktiv",
        "INACTIVE": "Inaktiv",
        "MMID": "MMID",
        "EXTRANET": "Externe Benutzer",
        "OU": "Organisationseinheit",
        "ORGANIZATION_UNIT": "Organisationseinheit",
        "LANGUAGE": "Sprache",
        "OPEN_FILTER": "Filter öffnen",
        "CLOSE_FILTER": "Filter schließen",
        "RESET": "Zurücksetzen",
        "RESET_ALL_FILTERS": "Alle Filter zurücksetzen",
        "SEARCH": "Suche",
        "STATUS": "Status",
        "GROUPS": "Gruppen",
        "SHOW_ALL_DETAILS": "Alle Details anzeigen",
        "SHOW_LESS": "Weniger Anzeigen",
        "ASCENDING": "Aufsteigend",
        "DESCENDING": "Absteigend",
        "LIST_END": "Ende der Liste",
        "SORT_BY_LASTNAME": "Nach Nachnamen sortieren",
        "SORT_BY_FIRSTNAME": "Nach Vornamen sortieren",
        "SORT_BY_EMAIL": "Nach E-Mail sortieren",
        "SORT_BY_LANGUAGE": "Nach bevorzugter Sprache sortieren",
        "SORT_BY_STATUS": "Nach Status sortieren",
        "SORT_BY_OU": "Nach Organisationseinheit sortieren",
        "SORT_BY_ACCOUNT_NAME": "Sortieren nach Logon Namen",
        "EDIT": "Bearbeiten",
        "CREATE": "Neuer Benutzer",
        "DIGICREATE": "Neuer MM digital User",
        "EXTRANETCREATE": "Neuer MM SharePoint Extranet User",
        "MMPCREATE": "Neuer MMP digital User",
        "ACTIVATE": "Aktivieren",
        "DEACTIVATE": "Deaktivieren",
        "USER_WAS_ACTIVATED": "Der Benutzer wurde aktiviert",
        "USER_WAS_DEACTIVATED": "Der Benutzer wurde deaktiviert",
        "ERROR_USER_ACTIVATION": "Fehler bei der Aktivierung",
        "ERROR_USER_DEACTIVATION": "Fehler bei der Deaktivierung",
        "SEND_FORGOT_PW_EMAIL": "Passwort vergessen E-Mail senden",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Generisches PW vergessen E-Mail",
        "SEND_FORGOT_PW_EMAIL_DIGI": "MM digital PW vergessen E-Mail",
        "SEND_FORGOT_PW_EMAIL_MMP": "MMP digital PW vergessen E-Mail",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "SP PW vergessen E-Mail",
        "COMPANY": "Firma",
        "SEND_WELCOME_EMAIL": "Willkommens-E-Mail senden",
        "SEND_WELCOME_EMAIL_DIGI": "MM digital Willkommens-E-Mail",
        "SEND_WELCOME_EMAIL_MMP": "MMP digital Willkommens-E-Mail",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "MM digital Willkommens-E-Mail ohne Button",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "MMP digital Willkommens-E-Mail ohne Button",
        "SEND_WELCOME_EMAIL_EXTRANET": "SP Willkommens-E-Mail",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "SP Willkommens-E-Mail ohne Button",
        "APPLY_FILTER_FOR_USERS": "Bitte verwenden Sie die Filter, oder die Suche, um die Ergebnisse anzuzeigen",
        "GENERATING_EMAIL": "E-Mail generieren ....",
        "ERROR_EMAIL_GENERATE": "Fehler beim Generieren der E-Mail ....",
        "LOCKED": "Gesperrt",
        "UNLOCK": "Entsperren",
        "SET_PASSWORD": "Passwort setzen",
        "PHYSICAL_LOCATION": "Lokation",
        "REQUIRED": "Pflichtfeld",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Benutzerverwaltung",
        "USER_WAS_ACTIVATED": "Der Benutzer wurde aktiviert",
        "USER_WAS_DEACTIVATED": "Der Benutzer wurde deaktiviert",
        "ERROR_USER_ACTIVATION": "Fehler bei der Aktivierung",
        "ERROR_USER_DEACTIVATION": "Fehler bei der Deaktivierung",
        "LOADING_USER_ERROR": "Fehler beim Laden des Benutzers",
        "FIRSTNAME": "Vorname",
        "LASTNAME": "Nachname",
        "EMAIL": "E-Mail",
        "ACCOUNT_NAME": "User Login-Name (pre-windows 2000)",
        "LANGUAGE": "Sprache",
        "PRINCIPAL_NAME": "User Principal name",
        "OU": "Organisationseinheit",
        "CLASS_DISPLAY_NAME": "Display name",
        "PHONE": "Telefon",
        "WEBSITE": "Website",
        "COUNTRY": "Land",
        "STATE": "Bundesland",
        "LOCATION": "Stadt",
        "STREET": "Straße",
        "POSTAL_CODE": "PLZ",
        "COMPANY": "Firma",
        "DEPARTMENT": "Abteilung",
        "PERSONAL_TITLE": "Titel",
        "MANAGER": "Manager",
        "DESCRIPTION": "Beschreibung",
        "GROUPS": "Gruppen",
        "SAVE": "Speichern",
        "CANCEL": "Abbrechen",
        "USER_STATUS": "Benutzerstatus",
        "ACTIVE": "Aktiv",
        "INACTIVE": "Inaktiv",
        "ACTIVATE": "Activate",
        "DEACTIVATE": "Deactivate",
        "USER_WAS_SAVED": "Der Benutzer wurde gespeichert. Das Serverupdate kann bis zu 60 sec dauern. <br/> Wenn sie alte Daten sehen, laden sie die Seite bitte alle 30 sec neu.",
        "UNKNOWN_ERROR": "Beim Speichern des Benutzers trat ein Fehler auf",
        "PROXY_ADDRESSES": "Proxy Adressen",
        "BROWSE": "Durchsuchen",
        "REMOVE": "Entfernen",
        "ONLY_JPG": "Es sind nur .jpg Bilder erlaubt!",
        "FILE_SIZE": "Die Dateigröße muss kleiner als 100KB sein!",
        "DIMENSIONS": "Die maximale Bilddimension ist 96x96 Pixel!",
        "SEND_FORGOT_PW_EMAIL": "Passwort vergessen E-Mail senden",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Generisches PW vergessen E-Mail",
        "SEND_FORGOT_PW_EMAIL_DIGI": "MM digital Passwort vergessen E-Mail",
        "SEND_FORGOT_PW_EMAIL_MMP": "MMP digital Passwort vergessen E-Mail",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "SP PW vergessen E-Mail",
        "VIRUS_FOUND": "Der Benutzer wurde nicht gespeichert. Es wurde Malware im Anhang gefunden. Die Datei wurde nicht hochgeladen. Bitte kontaktieren Sie Ihren Systemadministrator.",
        "VIRUS_SCANNER_NOT_AVL": "Die Datei konnte nicht auf Malware überprüft werden. Bitte versuchen sSe es später erneut. Wenn das Problem besteht, kontaktieren Sie bitte Ihren Systemadministrator.",
        "INFO": "Info:",
        "SEND_WELCOME_EMAIL": "Willkommens-E-Mail senden",
        "SEND_WELCOME_EMAIL_DIGI": "MM digital Willkommens-E-Mail",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "MM digital Willkommens-E-Mail ohne Button",
        "SEND_WELCOME_EMAIL_MMP": "MMP digital Willkommens-E-Mail",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "MMP digital Willkommens-E-Mail ohne Button",
        "SEND_WELCOME_EMAIL_EXTRANET": "SP Willkommens-E-Mail",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "SP Willkommens-E-Mail ohne PW Button",
        "SAVING_USER_SPINNER": "Speichere Benutzer... Bitte warten.",
        "DUPLICATE_USER": "Dieser Benutzer existiert bereits",
        "GENERATING_EMAIL": "E-Mail generieren ....",
        "ERROR_EMAIL_GENERATE": "Fehler beim Generieren der E-Mail ....",
        "UNLOCK": "Entsperren",
        "SET_PASSWORD": "Passwort setzen",
        "COST_CENTER": "Cost Center",
        "JOB_TITLE": "Jobtitel",
        "GENDER": "Geschlecht",
        "USER_NOT_FOUND": "Benutzer nicht gefunden",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Willkommens-E-Mail generieren ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Der Benutzer wurde aktiviert",
        "USER_WAS_DEACTIVATED": "Der Benutzer wurde deaktiviert",
        "ERROR_USER_ACTIVATION": "Fehler bei der Aktivierung",
        "ERROR_USER_DEACTIVATION": "Fehler bei der Deaktivierung",
        "EMAIL_WAS_SENT": "E-Mail wurde erfolgreich gesendet",
        "EMAIL_NOT_SENT_USER_ACTIVE": "E-Mail wurde nicht gesendet. Der Benutzer ist aktiv. Bitte verwenden Sie die Passwort vergessen E-Mail senden Funktion",
        "ERROR_EMAIL_SEND": "Fehler beim Versuch die E-Mail zu versenden",
        "EMAIL_NOT_SENT_USER_INACTIVE": "E-Mail wurde nicht gesendet. Der Benutzer ist inaktiv. Bitte verwenden Sie die MM digital Registrierungs-E-Mail senden Funktion",
        "PASSWORD_RESET_TOO_OFTEN": "Die Passwort Reset Funktion wurde zu oft verwendet, bitte versuchen Sie es später",
        "USER_WAS_UNLOCKED": "Benutzer wurde entsperrt",
        "ERROR_UNLOCK_USER": "Fehler beim Entsperren des Benutzers"
    }
};

/* harmony default export */ __webpack_exports__["a"] = (loc_de_strings);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loc_en_strings = {
	"Login": {
		"HEADING": "Login MM-ID Platform",
		"LOGIN": "Login",
		"USER": "User",
		"PASSWORD": "Password",
		"LOGIN_FAIL": "Login failed",
		"LOGIN_FIELD_REQUIRED": "The \"Username\" is a mandatory field",
		"PASSWORD_FIELD_REQUIRED": "The \"Password\" is a field is required",
		"FORGOT_PASSWORD": "Forgot password?",
		"DIFFERENT_ACCOUNT": "Sign in with a different account",
		"NO_ACCOUNT": "No account? ",
		"REGISTER": "Register with MM digital",
		"CHANGE_DENIED_TEXT": "Please use e.g. OWA to change your AD-password, or contact your support."
	},
	"Dashboard": {
		"DASHBOARD_TEXT": "Dashboard",
		"ACTION_TEXT": "Actions",
		"CHANGE_PASSWORD_TEXT": "Change Password",
		"MY_APPLICATIONS_TEXT": "My MM Applications",
		"APPLICATIONS_TEXT": "MM Applications",
		"USERS_LIST_TEXT": "User Management"
	},
	"DashboardHome": {
		"ACTION_TEXT": "Dashboard",
		"MY_APPLICATIONS_TEXT": "My MM Applications",
		"APPLICATIONS_TEXT": "MM Applications"
	},
	"Header": {
		"USER_MENU_TEXT": "User Menu",
		"ACTION_TEXT": "Actions",
		"CHANGE_PASSWORD_TEXT": "Change Password",
		"USERS_LIST_TEXT": "User Management",
		"USER_GROUPS": "Roles"
	},
	"Credentials": {
		"OLD_PASSWORD": "Old Password",
		"NEW_PASSWORD": "New Password",
		"CONFIRM_PASSWORD": "Confirm Password",
		"PASS_DO_NOT_MATCH": " The passwords do not match",
		"PASSWORD_FIELD_REQUIRED": "The \"Password\" is a mandatory field",
		"OLD_PASSWORD_FIELD_REQUIRED": "The \"Old Password\" is a mandatory field",
		"SUCCESS_TEXT": "Password has been changed successfully",
		"HEADING": "MM-ID Change Credentials",
		"HELP": "Need Help?",
		"SAVE": "Change",
		"CANCEL": "Cancel",
		"PASSWORD_CHANGE_ERROR": "The data could not be saved. Please try again later",
		"PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
		"PASSWORD_STREIGHT_ERROR": "Password should be minimum 10 symbols, contain lower, upper, special character, digit",
		"PASSWORD_REQUIREMENTS_TEXT": "Password must meet the following requirements:",
		"LOWERCASE_LETTER_TEXT": "At least one letter ",
		"UPPERCASE_LETTER_TEXT": "At least one capital letter",
		"NUMBER_TEXT": "At least one number",
		"SPECIAL_SYMBOL_TEXT": "At least one special symbol",
		"PASSWORD_LENGTH_TEXT": "Be at least 10 characters",
		"PASSWORD_RESTRICTION_TEXT": "The first, last, or user name must not be part of the password",
		"CHANGE_PASSWORD_TEXT": "Change Password",
		"ACTION_TEXT": "Actions",
		"CHANGE_DENIED_TEXT": "Please use e.g. OWA to change your AD-password, or contact your support."
	},
	"CreatePassword": {
		"PASSWORD": "Create a Password",
		"CONFIRM_PASSWORD": "Confirm your Password",
		"PASS_DO_NOT_MATCH": "The passwords do not match",
		"PASSWORD_FIELD_REQUIRED": "The \"Password\" is a mandatory field",
		"SUCCESS_TEXT": "The data has been successfully saved",
		"HEADING": "Create Password",
		"HELP": "Need Help?",
		"SAVE": "Change",
		"CANCEL": "Cancel",
		"PASSWORD_CHANGE_ERROR": "The data could not be saved. Please try again later",
		"PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
		"PASSWORD_STREIGHT_ERROR": "Password should be minimum 10 symbols, contain lower, upper, special character, digit",
		"PASSWORD_REQUIREMENTS_TEXT": "Password must meet the following requirements:",
		"LOWERCASE_LETTER_TEXT": "At least one letter",
		"UPPERCASE_LETTER_TEXT": "At least one capital letter",
		"NUMBER_TEXT": "At least one number",
		"SPECIAL_SYMBOL_TEXT": "At least one special symbol",
		"PASSWORD_LENGTH_TEXT": "Be at least 10 characters",
		"PASSWORD_RESTRICTION_TEXT": "The first, last, or user name must not be part of the password",
		"PASSWORD_WAS_SET": "The link has already been used to set the password, if you don’t remember the password, please use the reset password function.",
		"OLD_PASSWORD_REQUIRED": "The \"Old password\" is a mandatory field",
		"MMID_CHANGE_PASSWORD": "Change password",
		"OLD_PASSWORD": "Old password",
		"INVALID_OLD_PASSWORD": "Invalid old password",
		"USER_NOT_FOUND_OR_INACTIVE": "User not found or inactive",
		"UNKNOWN_ERROR": "Something went wrong on change password"
	},
	"ForgotPassword": {
		"USER": "E-mail",
		"LOGIN_FAIL": "Please input correct e-mail address",
		"LOGIN_FIELD_REQUIRED": "\"E-mail\" is a mandatory field",
		"HEADING": "Forgot Password",
		"HELP": "Need Help?",
		"SAVE": "Send Reset Password E-mail",
		"CANCEL": "Cancel",
		"SUCCESS_TEXT": "Please check your inbox if you have received an e-mail.",
		"CHANGE_DENIED_TEXT": "Please use e.g. OWA to change your AD-password, or contact your support.",
		"PASSWORD_RESET_TOO_OFTEN": "The password reset function has been used too often, please try again later",
		"RESET_FAILED": "Login failed",
		"LINK_EXPIRED": "Your login link has expired. Please enter your e-mail address to request the login link again.",
		"HEADING_EXPIRED": "Your login link has expired",
		"SAVE_EXPIRED": "Request login link"
	},
	"UsersList": {
		"USERS_LIST_TEXT": "User Management",
		"ACTIVE": "Active",
		"INACTIVE": "Inactive",
		"MMID": "MMID",
		"EXTRANET": "External Users",
		"OU": "Organisational Unit",
		"ORGANIZATION_UNIT": "Organization unit",
		"LANGUAGE": "Language",
		"OPEN_FILTER": "Open filter",
		"CLOSE_FILTER": "Close filter",
		"RESET": "reset",
		"RESET_ALL_FILTERS": "Reset all filters",
		"SEARCH": "Search",
		"STATUS": "Status",
		"GROUPS": "Groups",
		"SHOW_ALL_DETAILS": "Show all details",
		"SHOW_LESS": "Show less",
		"ASCENDING": "Ascending",
		"DESCENDING": "Descending",
		"LIST_END": "End of list",
		"SORT_BY_LASTNAME": "Sort by Last Name",
		"SORT_BY_FIRSTNAME": "Sort by First Name",
		"SORT_BY_EMAIL": "Sort by E-mail",
		"SORT_BY_LANGUAGE": "Sort by preferred language",
		"SORT_BY_STATUS": "Sort by status",
		"SORT_BY_OU": "Sort by OU",
		"SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
		"EDIT": "Edit",
		"CREATE": "New User",
		"DIGICREATE": "New MM digital User",
		"EXTRANETCREATE": "New MM SharePoint Extranet User",
		"MMPCREATE": "New MMP digital User",
		"ACTIVATE": "Activate",
		"DEACTIVATE": "Deactivate",
		"USER_WAS_ACTIVATED": "User was activated",
		"USER_WAS_DEACTIVATED": "User was deactivated",
		"ERROR_USER_ACTIVATION": "Error during user activation",
		"ERROR_USER_DEACTIVATION": "Error during user deactivation",
		"SEND_FORGOT_PW_EMAIL": "Send Forgot Password E-mail",
		"SEND_FORGOT_PW_EMAIL_GENERIC": "Generic Forgot PW E-mail",
		"SEND_FORGOT_PW_EMAIL_DIGI": "MM digital Forgot PW E-mail",
		"SEND_FORGOT_PW_EMAIL_MMP": "MMP digital Forgot PW E-mail",
		"SEND_FORGOT_PW_EMAIL_EXTRANET": "SP Forgot PW E-mail",
		"COMPANY": "Company",
		"SEND_WELCOME_EMAIL": "Send Welcome E-mail",
		"SEND_WELCOME_EMAIL_DIGI": "MM digital Welcome E-mail",
		"SEND_WELCOME_EMAIL_DIGI_NO_PASS": "MM digital Welcome E-mail without PW Button",
		"SEND_WELCOME_EMAIL_MMP": "MMP digital Welcome E-mail",
		"SEND_WELCOME_EMAIL_MMP_NO_PASS": "MMP digital Welcome E-mail without PW Button",
		"SEND_WELCOME_EMAIL_EXTRANET": "SP Welcome E-mail",
		"SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "SP Welcome E-mail without PW Button",
		"APPLY_FILTER_FOR_USERS": "Please use the filters, or the search to display the results",
		"GENERATING_EMAIL": "Generating E-mail....",
		"ERROR_EMAIL_GENERATE": "Error generating E-mail....",
		"LOCKED": "Locked",
		"UNLOCK": "Unlock",
		"SET_PASSWORD": "Set Password",
		"PHYSICAL_LOCATION": "Location",
		"REQUIRED": "Required",
		"USER_TYPE": "User type",
		"CANONICAL_NAME": "Canonical name"
	},
	"EditUser": {
		"USERS_LIST_TEXT": "User Management",
		"USER_WAS_ACTIVATED": "User was activated",
		"USER_WAS_DEACTIVATED": "User was deactivated",
		"ERROR_USER_ACTIVATION": "Error during user activation",
		"ERROR_USER_DEACTIVATION": "Error during user deactivation",
		"LOADING_USER_ERROR": "Loading user error",
		"FIRSTNAME": "First name",
		"LASTNAME": "Last name",
		"EMAIL": "E-mail",
		"ACCOUNT_NAME": "User logon name (pre-windows 2000)",
		"LANGUAGE": "Language",
		"PRINCIPAL_NAME": "User Principal name",
		"OU": "Organization unit",
		"CLASS_DISPLAY_NAME": "Display name",
		"PHONE": "Phone",
		"WEBSITE": "Website",
		"COUNTRY": "Country",
		"STATE": "State",
		"LOCATION": "City",
		"STREET": "Street",
		"POSTAL_CODE": "Postal code",
		"COMPANY": "Company",
		"DEPARTMENT": "Department",
		"PERSONAL_TITLE": "Personal title",
		"MANAGER": "Manager",
		"DESCRIPTION": "Description",
		"GROUPS": "Groups",
		"SAVE": "Save",
		"CANCEL": "Cancel",
		"USER_STATUS": "User status",
		"ACTIVE": "Active",
		"INACTIVE": "Inactive",
		"ACTIVATE": "Activate",
		"DEACTIVATE": "Deactivate",
		"USER_WAS_SAVED": "The user was saved. Updating the servers can take up to 60 sec.<br/> If you see old data, please refresh the page every 30 sec.",
		"UNKNOWN_ERROR": "An unknown error occurred while saving the user",
		"PROXY_ADDRESSES": "Proxy addresses",
		"BROWSE": "Browse",
		"REMOVE": "Remove",
		"ONLY_JPG": "Only jpg images are allowed!",
		"FILE_SIZE": "File size must be less than 100KB!",
		"DIMENSIONS": "Maximum image dimensions are 96x96 pixels!",
		"SEND_FORGOT_PW_EMAIL": "Send Forgot Password E-mail",
		"SEND_FORGOT_PW_EMAIL_GENERIC": "Generic Forgot PW E-mail",
		"SEND_FORGOT_PW_EMAIL_DIGI": "MM digital Forgot PW E-mail",
		"SEND_FORGOT_PW_EMAIL_MMP": "MMP digital Forgot PW E-mail",
		"SEND_FORGOT_PW_EMAIL_EXTRANET": "SP Forgot PW E-mail",
		"VIRUS_FOUND": "The user could not be saved. Malware has been found in the attachment. The file will not be uploaded. Please contact your system administrator.",
		"VIRUS_SCANNER_NOT_AVL": "The file could not be scanned for malware. Please try again later. If the problem persists contact your system administrator.",
		"INFO": "Info:",
		"SEND_WELCOME_EMAIL": "Send Welcome E-mail",
		"SEND_WELCOME_EMAIL_DIGI": "MM digital Welcome E-mail",
		"SEND_WELCOME_EMAIL_DIGI_NO_PASS": "MM digital Welcome E-mail without PW Button",
		"SEND_WELCOME_EMAIL_MMP": "MMP digital Welcome E-mail",
		"SEND_WELCOME_EMAIL_MMP_NO_PASS": "MMP digital Welcome E-mail without PW Button",
		"SEND_WELCOME_EMAIL_EXTRANET": "SP Welcome E-mail",
		"SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "SP Welcome E-mail without PW Button",
		"SAVING_USER_SPINNER": "Saving user... Please, wait",
		"DUPLICATE_USER": "User already exists",
		"GENERATING_EMAIL": "Generating E-mail....",
		"ERROR_EMAIL_GENERATE": "Error generating E-mail....",
		"UNLOCK": "Unlock",
		"SET_PASSWORD": "Set Password",
		"COST_CENTER": "Cost Center",
		"JOB_TITLE": "Job title",
		"GENDER": "Gender",
		"USER_NOT_FOUND": "User not found",
		"USER_TYPE": "User type",
		"CANONICAL_NAME": "Canonical name"
	},
	"ResendWelcome": {
		"GENERATING_EMAIL": "Generating welcome E-mail...."
	},
	"Shared": {
		"USER_WAS_ACTIVATED": "User was activated",
		"USER_WAS_DEACTIVATED": "User was deactivated",
		"ERROR_USER_ACTIVATION": "Error during user activation",
		"ERROR_USER_DEACTIVATION": "Error during user deactivation",
		"EMAIL_WAS_SENT": "E-mail was sent successfully",
		"EMAIL_NOT_SENT_USER_ACTIVE": "E-mail was not sent. The user already is active. Use the Send Forgot Password E-mail functionality instead",
		"ERROR_EMAIL_SEND": "Error trying to send the e-mail",
		"EMAIL_NOT_SENT_USER_INACTIVE": "E-mail was not sent. The user is inactive. Use the Send MM digital registration E-mail functionality.",
		"PASSWORD_RESET_TOO_OFTEN": "The password reset function has been used too often, please try again later",
		"USER_WAS_UNLOCKED": "User was unlocked",
		"ERROR_UNLOCK_USER": "Error unlocking user"
	}
};

/* harmony default export */ __webpack_exports__["a"] = (loc_en_strings);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loc_es_strings = {
    "Login": {
        "HEADING": "Iniciar sesión en la plataforma MM-ID",
        "LOGIN": "Iniciar sesión",
        "USER": "Usuario",
        "PASSWORD": "Contraseña",
        "LOGIN_FAIL": "Error al iniciar sesión",
        "LOGIN_FIELD_REQUIRED": "El campo \"Nombre de usuario\" es obligatorio",
        "PASSWORD_FIELD_REQUIRED": "El campo \"Contraseña\" es obligatorio",
        "FORGOT_PASSWORD": "¿Olvidó su contraseña?",
        "DIFFERENT_ACCOUNT": "Registrarse con una cuenta diferente",
        "NO_ACCOUNT": "¿No tiene una cuenta?",
        "REGISTER": "Registrarse en MM digital",
        "CHANGE_DENIED_TEXT": "Use p. ej. OWA para cambiar su contraseña AD o póngase en contacto con el Servicio de Asistencia."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Cuadro de mando",
        "ACTION_TEXT": "Acciones",
        "CHANGE_PASSWORD_TEXT": "Cambiar contraseña",
        "MY_APPLICATIONS_TEXT": "Mis aplicaciones MM",
        "APPLICATIONS_TEXT": "Aplicaciones MM",
        "USERS_LIST_TEXT": "Gestión de usuarios"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Cuadro de mando",
        "MY_APPLICATIONS_TEXT": "Mis aplicaciones MM",
        "APPLICATIONS_TEXT": "Aplicaciones MM"
    },
    "Header": {
        "USER_MENU_TEXT": "Menú del usuario",
        "ACTION_TEXT": "Acciones",
        "CHANGE_PASSWORD_TEXT": "Cambiar contraseña",
        "USERS_LIST_TEXT": "Gestión de usuarios",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Contraseña anterior",
        "NEW_PASSWORD": "Nueva contraseña",
        "CONFIRM_PASSWORD": "Confirmar contraseña",
        "PASS_DO_NOT_MATCH": "Las contraseñas no coinciden",
        "PASSWORD_FIELD_REQUIRED": "El campo \"Contraseña\" es obligatorio",
        "OLD_PASSWORD_FIELD_REQUIRED": "El campo \"Contraseña anterior\" es obligatorio",
        "SUCCESS_TEXT": "La contraseña se ha cambiado con éxito",
        "HEADING": "Cambiar crendenciales MM-ID",
        "HELP": "¿Necesita ayuda?",
        "SAVE": "Cambiar",
        "CANCEL": "Cancelar",
        "PASSWORD_CHANGE_ERROR": "La información no pudo guardarse. Inténtelo mas tarde.",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "La contraseña debe tener un mínimo de 10 símbolos y contener mayúsculas, minúsculas, caracteres especiales y números",
        "PASSWORD_REQUIREMENTS_TEXT": "La contraseña debe cumplir con los siguientes requisitos:",
        "LOWERCASE_LETTER_TEXT": "Al menos una letra minúscula",
        "UPPERCASE_LETTER_TEXT": "Al menos una letra mayúscula",
        "NUMBER_TEXT": "Al menos un número",
        "SPECIAL_SYMBOL_TEXT": "Al menos un símbolo",
        "PASSWORD_LENGTH_TEXT": "Contener al menos 10 caracteres",
        "PASSWORD_RESTRICTION_TEXT": "El apellido, el nombre o el nombre de usuario no deben ser parte de la contraseña",
        "CHANGE_PASSWORD_TEXT": "Cambiar contraseña",
        "ACTION_TEXT": "Acciones",
        "CHANGE_DENIED_TEXT": "Use p. ej. OWA para cambiar su contraseña AD o póngase en contacto con el Servicio de Asistencia."
    },
    "CreatePassword": {
        "PASSWORD": "Crear una contraseña",
        "CONFIRM_PASSWORD": "Confirmar contraseña",
        "PASS_DO_NOT_MATCH": "Las contraseñas no coinciden",
        "PASSWORD_FIELD_REQUIRED": "El campo \"Contraseña\" es obligatorio",
        "SUCCESS_TEXT": "La información se ha guardado con éxito",
        "HEADING": "Crear constraseña",
        "HELP": "¿Necesita ayuda?",
        "SAVE": "Cambiar",
        "CANCEL": "Cancelar",
        "PASSWORD_CHANGE_ERROR": "La información no pudo guardarse. Inténtelo mas tarde.",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "La contraseña debe tener un mínimo de 10 símbolos y contener mayúsculas, minúsculas, caracteres especiales y números",
        "PASSWORD_REQUIREMENTS_TEXT": "La contraseña debe cumplir con los siguientes requisitos:",
        "LOWERCASE_LETTER_TEXT": "Al menos una letra minúscula",
        "UPPERCASE_LETTER_TEXT": "Al menos una letra mayúscula",
        "NUMBER_TEXT": "Al menos un número",
        "SPECIAL_SYMBOL_TEXT": "Al menos un símbolo",
        "PASSWORD_LENGTH_TEXT": "Contener al menos 10 caracteres",
        "PASSWORD_RESTRICTION_TEXT": "El apellido, el nombreo o el nombre de usuario no deben ser parte de la contraseña",
        "PASSWORD_WAS_SET": "El enlace ya ha sido usado para establecer la contraseña, si no recuerda la contraseña, utilice la función de restablecimiento de contraseña.",
        "OLD_PASSWORD_REQUIRED": "El campo \"Contraseña anterior\" es obligatorio.",
        "MMID_CHANGE_PASSWORD": "Cambiar contraseña",
        "OLD_PASSWORD": "Contraseña anterior",
        "INVALID_OLD_PASSWORD": "Contraseña anterior inválida",
        "USER_NOT_FOUND_OR_INACTIVE": "Usuario no encontrado o inactivo",
        "UNKNOWN_ERROR": "Se ha producido un error al cambiar la contraseña"
    },
    "ForgotPassword": {
        "USER": "Correo electrónico",
        "LOGIN_FAIL": "Introduzca la dirección de correo electrónico correcta",
        "LOGIN_FIELD_REQUIRED": "El campo \"Correo electrónico\" es obligatorio",
        "HEADING": "Olvidé mi contraseña",
        "HELP": "¿Necesita ayuda?",
        "SAVE": "Enviar correo electrónico de restablecimiento de contraseña",
        "CANCEL": "Cancelar",
        "SUCCESS_TEXT": "Le hemos enviado un correo electónico, compruebe su bandeja de entrada.",
        "CHANGE_DENIED_TEXT": "Use p. ej. OWA para cambiar su contraseña AD o póngase en contacto con el Servicio de Asistencia.",
        "PASSWORD_RESET_TOO_OFTEN": "La función de restablecimiento de contraseña se ha usado muchas veces, inténtelo más tarde",
        "RESET_FAILED": "Error al iniciar sesión",
        "LINK_EXPIRED": "El enlace de inicio de sesión ha expirado. Introduzca su dirección de correo electrónico para solicitar nuevamente el enlace de inicio de sesión.",
        "HEADING_EXPIRED": "El enlace de inicio de sesión ha expirado",
        "SAVE_EXPIRED": "Solicitar el enlace de inicio de sesión"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Gestión de usuarios",
        "ACTIVE": "Activo",
        "INACTIVE": "Inactivo",
        "MMID": "MMID",
        "EXTRANET": "Usuarios externos",
        "OU": "Unidad organizacional",
        "ORGANIZATION_UNIT": "Unidad organizativa",
        "LANGUAGE": "Idioma",
        "OPEN_FILTER": "Abrir filtro",
        "CLOSE_FILTER": "Cerrar filtro",
        "RESET": "restablecer",
        "RESET_ALL_FILTERS": "restablecer todos los filtros",
        "SEARCH": "Buscar",
        "STATUS": "Estado",
        "GROUPS": "Grupos",
        "SHOW_ALL_DETAILS": "Mostrar todos los detalles",
        "SHOW_LESS": "Mostrar menos",
        "ASCENDING": "Ascendente",
        "DESCENDING": "Descendente",
        "LIST_END": "Fin de la lista",
        "SORT_BY_LASTNAME": "Ordenar por apellido",
        "SORT_BY_FIRSTNAME": "Ordenar por nombre",
        "SORT_BY_EMAIL": "Ordenar por correo electrónico",
        "SORT_BY_LANGUAGE": "Ordenar por idioma preferido",
        "SORT_BY_STATUS": "Ordenar por estado",
        "SORT_BY_OU": "Ordenar por UO",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Editar",
        "CREATE": "Nuevo usuario",
        "DIGICREATE": "Nuevo usuario MM digital",
        "EXTRANETCREATE": "Nuevo usuario de extranet de MM SharePoint",
        "MMPCREATE": "Nuevo usuario MMP digital",
        "ACTIVATE": "Activar",
        "DEACTIVATE": "Desactivar",
        "USER_WAS_ACTIVATED": "El usuario fue desactivado",
        "USER_WAS_DEACTIVATED": "El usuario fue desactivado",
        "ERROR_USER_ACTIVATION": "Se produjo un error durante la activación del usuario",
        "ERROR_USER_DEACTIVATION": "Se produjo un error durante la desactivación del usuario",
        "SEND_FORGOT_PW_EMAIL": "Enviar correo electrónico de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Correo electrónico genérico de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Correo electrónico de \"Olvidé mi contraseña\" de MM digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "Correo electrónico de \"Olvidé mi contraseña\" de MMP digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Correo electrónico de \"Olvidé mi contraseña\" SP",
        "COMPANY": "Empresa",
        "SEND_WELCOME_EMAIL": "Enviar correo electrónico de bienvenida",
        "SEND_WELCOME_EMAIL_DIGI": "Correo electrónico de bienvenida de MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Correo electrónico de bienvenida de MM digital sin botón de contraseña",
        "SEND_WELCOME_EMAIL_MMP": "Correo electrónico de bienvenida de MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Correo electrónico de bienvenida de MMP digital sin botón de contraseña",
        "SEND_WELCOME_EMAIL_EXTRANET": "Correo electrónico de bienvenida SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Correo electrónico de bienvenida SP sin botón de contraseña",
        "APPLY_FILTER_FOR_USERS": "Use los filtros o la búsqueda para mostrar los resultados",
        "GENERATING_EMAIL": "Generando correo electrónico ....",
        "ERROR_EMAIL_GENERATE": "Error al generar un correo electrónico ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Gestión de usuarios",
        "USER_WAS_ACTIVATED": "Se activó el usuario",
        "USER_WAS_DEACTIVATED": "Se desactivó el usuario",
        "ERROR_USER_ACTIVATION": "Se produjo un error durante la activación del usuario",
        "ERROR_USER_DEACTIVATION": "Se produjo un error durante la desactivación del usuario",
        "LOADING_USER_ERROR": "Se produjo un error al cargar el usuario",
        "FIRSTNAME": "Nombre",
        "LASTNAME": "Apellido",
        "EMAIL": "Correo electrónico",
        "ACCOUNT_NAME": "Nombre de inicio de sesión del usuario (pre-windows 2000)",
        "LANGUAGE": "Idioma",
        "PRINCIPAL_NAME": "Nombre del usuario principal",
        "OU": "Unidad organizativa",
        "CLASS_DISPLAY_NAME": "Nombre para mostrar",
        "PHONE": "Teléfono",
        "WEBSITE": "Página web",
        "COUNTRY": "País",
        "STATE": "Estado",
        "LOCATION": "Ciudad",
        "STREET": "Calle",
        "POSTAL_CODE": "Código postal",
        "COMPANY": "Empresa",
        "DEPARTMENT": "Departamento",
        "PERSONAL_TITLE": "Tratamiento personal",
        "MANAGER": "Director",
        "DESCRIPTION": "Descripción",
        "GROUPS": "Grupos",
        "SAVE": "Guardar",
        "CANCEL": "Cancelar",
        "USER_STATUS": "Estado del usuario",
        "ACTIVE": "Activo",
        "INACTIVE": "Inactivo",
        "ACTIVATE": "Activar",
        "DEACTIVATE": "Desactivar",
        "USER_WAS_SAVED": "Se guardó el usuario",
        "UNKNOWN_ERROR": "Se ha producido un error desconocido al guardar el usuario",
        "PROXY_ADDRESSES": "Direcciones proxy",
        "BROWSE": "Examinar",
        "REMOVE": "Eliminar",
        "ONLY_JPG": "¡Solo se permiten imágenes jpg!",
        "FILE_SIZE": "¡El tamaño del archivo debe ser menor que 100 KB!",
        "DIMENSIONS": "¡Las dimensiones máximas de la imagen deben ser 96x96 pixeles!",
        "SEND_FORGOT_PW_EMAIL": "Enviar correo electrónico de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Correo electrónico genérico de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Correo electrónico MM digital de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_MMP": "Correo electrónico MMP digital de \"Olvidé mi contraseña\"",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Correo electrónico \"Olvidé mi contraseña\" SP",
        "VIRUS_FOUND": "No se pudo guardar el usuario. Se encontró un malware en el adjunto. El archivo no se cargará. Póngase en contacto con el administrador del sistema.",
        "VIRUS_SCANNER_NOT_AVL": "No se pudo analizar el archivo por malware. Inténtelo más tarde. Si el problema persiste, póngase en contacto con el administrador del sistema.",
        "INFO": "Acerca de",
        "SEND_WELCOME_EMAIL": "Enviar correo electrónico de bienvenida",
        "SEND_WELCOME_EMAIL_DIGI": "Correo electrónico de bienvenida de MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Correo electrónico de bienvenida de MM digital sin botón de contraseña",
        "SEND_WELCOME_EMAIL_MMP": "Correo electrónico de bienvenida de MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Correo electrónico de bienvenida de MMP digital sin botón de contraseña",
        "SEND_WELCOME_EMAIL_EXTRANET": "Correo electrónico de bienvenida SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Correo electrónico de bienvenida SP sin botón de contraseña",
        "SAVING_USER_SPINNER": "Guardando el usuario... Por favor, espere",
        "DUPLICATE_USER": "El usuario ya existe",
        "GENERATING_EMAIL": "Generando correo electrónico ....",
        "ERROR_EMAIL_GENERATE": "Error al generar un correo electrónico ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Usuario no encontrado",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Generando un correo electrónico de bienvenida ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Se activó el usuario",
        "USER_WAS_DEACTIVATED": "Se desactivó el usuario",
        "ERROR_USER_ACTIVATION": "Se produjo un error durante la activación del usuario",
        "ERROR_USER_DEACTIVATION": "Se produjo un error durante la desactivación del usuario",
        "EMAIL_WAS_SENT": "El correo electrónico fue enviado con éxito",
        "EMAIL_NOT_SENT_USER_ACTIVE": "No se envió el correo electrónico. El usuario ya está activo. En su lugar, use la función de enviar correo electrónico de \"Olvidé mi contraseña\"",
        "ERROR_EMAIL_SEND": "Error al intentar enviar el correo electrónico",
        "EMAIL_NOT_SENT_USER_INACTIVE": "No se envió el correo electrónico. El usuario está inactivo. Use la función de enviar correo registro en MM digital",
        "PASSWORD_RESET_TOO_OFTEN": "La función de restablecimiento de contraseña se ha usado muchas veces, inténtelo más tarde",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

/* harmony default export */ __webpack_exports__["a"] = (loc_es_strings);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loc_fr_strings = {
    "Login": {
        "HEADING": "Connexion MM-ID Plateforme",
        "LOGIN": "Connexion",
        "USER": "Utilisateur",
        "PASSWORD": "Mot de passe",
        "LOGIN_FAIL": "Échec connexion",
        "LOGIN_FIELD_REQUIRED": "Le champ \" Nom d'utilisateur \" est obligatoire",
        "PASSWORD_FIELD_REQUIRED": "Le champ \"Mot de passe\" est obligatoire",
        "FORGOT_PASSWORD": "Mot de passe oublié ?",
        "DIFFERENT_ACCOUNT": "Se connecter avec un autre compte",
        "NO_ACCOUNT": "Pas de compte ?",
        "REGISTER": "S'enregistrer avec MM digital",
        "CHANGE_DENIED_TEXT": "Veuillez utiliser p.ex. OWA pour changer votre mote de passe AD, ou contacter le service d'assistance."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Tableau de bord",
        "ACTION_TEXT": "Actions",
        "CHANGE_PASSWORD_TEXT": "Changer mot de passe",
        "MY_APPLICATIONS_TEXT": "Mes applications MM",
        "APPLICATIONS_TEXT": "Applications MM",
        "USERS_LIST_TEXT": "Gestion des utilisateurs"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Tableau de bord",
        "MY_APPLICATIONS_TEXT": "Mes applications MM",
        "APPLICATIONS_TEXT": "Applications MM"
    },
    "Header": {
        "USER_MENU_TEXT": "Menu utilisateur",
        "ACTION_TEXT": "Actions",
        "CHANGE_PASSWORD_TEXT": "Changer mot de passe",
        "USERS_LIST_TEXT": "Gestion des utilisateurs",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Ancien mot de passe",
        "NEW_PASSWORD": "Nouveau mot de passe",
        "CONFIRM_PASSWORD": "Confirmer mot de passe",
        "PASS_DO_NOT_MATCH": "␣Le mot de passe ne correspond pas",
        "PASSWORD_FIELD_REQUIRED": "Le champ \"Mot de passe\" est obligatoire",
        "OLD_PASSWORD_FIELD_REQUIRED": "L' \"Ancien mot de passe\" est un champ obligatoire",
        "SUCCESS_TEXT": "Le mot de passe a été modifié avec succès. ",
        "HEADING": "MM-ID Modification identification",
        "HELP": "Besoin d'aide ?",
        "SAVE": "Modifier",
        "CANCEL": "Annuler",
        "PASSWORD_CHANGE_ERROR": "Les données n'ont pas pu être sauvegardées. Veuillez réessayer plus tard.",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Le mot de passe doit contenir au moins 10 symboles, au moins un caractère en lettre minuscule, un autre en lettre majuscule, un caractère spécial et un chiffre",
        "PASSWORD_REQUIREMENTS_TEXT": "Le mot de passe doit satisfaire les exigences suivantes :",
        "LOWERCASE_LETTER_TEXT": "Au moins une lettre␣",
        "UPPERCASE_LETTER_TEXT": "Au moins une lettre majuscule",
        "NUMBER_TEXT": "Au moins un chiffre",
        "SPECIAL_SYMBOL_TEXT": "Au moins un symbole spécial",
        "PASSWORD_LENGTH_TEXT": "Contenir au moins 10 caractères",
        "PASSWORD_RESTRICTION_TEXT": "Le nom, prénom ou nom d'utilisateur ne doivent pas être contenus dans le mot de passe",
        "CHANGE_PASSWORD_TEXT": "Changer mot de passe",
        "ACTION_TEXT": "Actions",
        "CHANGE_DENIED_TEXT": "Veuillez utiliser p.ex. OWA pour changer votre mote de passe AD, ou contacter l'assistance."
    },
    "CreatePassword": {
        "PASSWORD": "Créer un mot de passe",
        "CONFIRM_PASSWORD": "Confirmer votre mot de passe",
        "PASS_DO_NOT_MATCH": "Le mot de passe ne correspond pas",
        "PASSWORD_FIELD_REQUIRED": "Le champ \"Mot de passe\" est obligatoire",
        "SUCCESS_TEXT": "Les données ont été sauvegardées avec succès",
        "HEADING": "Créer mot de passe",
        "HELP": "Besoin d'aide ?",
        "SAVE": "Modifier",
        "CANCEL": "Annuler",
        "PASSWORD_CHANGE_ERROR": "Les données n'ont pas pu être sauvegardées. Veuillez réessayer plus tard.",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Le mot de passe doit contenir au moins 10 symboles, au moins un caractère en lettre minuscule, un autre en lettre majuscule, un caractère spécial et un chiffre",
        "PASSWORD_REQUIREMENTS_TEXT": "Le mot de passe doit satisfaire les exigences suivantes :",
        "LOWERCASE_LETTER_TEXT": "Au moins une lettre",
        "UPPERCASE_LETTER_TEXT": "Au moins une lettre majuscule",
        "NUMBER_TEXT": "Au moins un chiffre",
        "SPECIAL_SYMBOL_TEXT": "Au moins un symbole spécial",
        "PASSWORD_LENGTH_TEXT": "Contenir au moins 10 caractères",
        "PASSWORD_RESTRICTION_TEXT": "Le nom, prénom ou nom d'utilisateur ne doivent pas être contenus dans le mot de passe",
        "PASSWORD_WAS_SET": "Le lien a déjà été utilisé pour créer le mot de passe, si vous ne vous souvenez pas du mot de passe, veuillez utiliser la fonction de réinitialisation du mot de passe",
        "OLD_PASSWORD_REQUIRED": "L' \"Ancien mot de passe\" est un champ obligatoire",
        "MMID_CHANGE_PASSWORD": "Changer mot de passe",
        "OLD_PASSWORD": "Ancien mot de passe",
        "INVALID_OLD_PASSWORD": "Ancien mot de passe incorrect",
        "USER_NOT_FOUND_OR_INACTIVE": "Utilisateur introuvable ou inactif",
        "UNKNOWN_ERROR": "Une erreur s'est produite lors de la modification du mot de passe"
    },
    "ForgotPassword": {
        "USER": "E-mail",
        "LOGIN_FAIL": "Veuillez saisir une adresse e-mail correcte",
        "LOGIN_FIELD_REQUIRED": "Le champ \"E-mail\" est obligatoire",
        "HEADING": "Mot de passe oublié",
        "HELP": "Besoin d'aide ?",
        "SAVE": "Envoyer e-mail de réinitialisation du mot de passe",
        "CANCEL": "Annuler",
        "SUCCESS_TEXT": "Veuillez contrôler votre boîte de réception d'e-mail",
        "CHANGE_DENIED_TEXT": "Veuillez utiliser p.ex. OWA pour changer votre mote de passe AD, ou contacter l'assistance.",
        "PASSWORD_RESET_TOO_OFTEN": "La fonction de réinitialisation du mot de passe a été utilisée à de trop nombreuses reprises, veuillez réessayer plus tard.",
        "RESET_FAILED": "Échec connexion",
        "LINK_EXPIRED": "Votre connexion a expiré. Veuillez saisir votre adresse e-mail afin d'obtenir une nouvelle fois le lien de connexion.",
        "HEADING_EXPIRED": "Votre lien de connexion a expiré",
        "SAVE_EXPIRED": "Demander un lien de connexion"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Gestion des utilisateurs",
        "ACTIVE": "Actif",
        "INACTIVE": "Inactif",
        "MMID": "MMID",
        "EXTRANET": "Utilisateurs externes",
        "OU": "Unité organisationnelle",
        "ORGANIZATION_UNIT": "Unité d'organisation",
        "LANGUAGE": "Langue",
        "OPEN_FILTER": "Ouvrir filtre",
        "CLOSE_FILTER": "Fermer filtre",
        "RESET": "réinitialiser",
        "RESET_ALL_FILTERS": "Réinitialiser les filtres",
        "SEARCH": "Recherche",
        "STATUS": "Statut",
        "GROUPS": "Groupes",
        "SHOW_ALL_DETAILS": "Montrer tous les détails",
        "SHOW_LESS": "Montrer moins",
        "ASCENDING": "Croissant",
        "DESCENDING": "Décroissant",
        "LIST_END": "Fin de liste",
        "SORT_BY_LASTNAME": "Trier par nom de famille",
        "SORT_BY_FIRSTNAME": "Tier par prénom",
        "SORT_BY_EMAIL": "Trier par e-mail",
        "SORT_BY_LANGUAGE": "Trier par langue de préférence",
        "SORT_BY_STATUS": "Trier par statut",
        "SORT_BY_OU": "Trier par OU",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Modifier",
        "CREATE": "Nouvel utilisateur",
        "DIGICREATE": "Nouvel utilisateur MM digital",
        "EXTRANETCREATE": "Nouvel utilisateur MM SharePoint Extranet",
        "MMPCREATE": "Nouvel utilisateur MMP digital",
        "ACTIVATE": "Activé",
        "DEACTIVATE": "Désactivé",
        "USER_WAS_ACTIVATED": "L'utilisateur a été activé",
        "USER_WAS_DEACTIVATED": "L'utilisateur a été désactivé",
        "ERROR_USER_ACTIVATION": "Une erreur s'est produite durant l'activation de l'utilisateur",
        "ERROR_USER_DEACTIVATION": "Une erreur s'est produite durant la désactivation de l'utilisateur",
        "SEND_FORGOT_PW_EMAIL": "Envoyer un e-mail pour mot de passe oublié",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "E-mail générique pour PW oublié",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-mail MM digital PW oublié",
        "SEND_FORGOT_PW_EMAIL_MMP": "E-mail MMP digital PW oublié",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "E-mail SP PW oublié",
        "COMPANY": "Compagnie",
        "SEND_WELCOME_EMAIL": "Envoyer un e-mail de bienvenue",
        "SEND_WELCOME_EMAIL_DIGI": "Email de bienvenue MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-mail de bienvenue MM digital sans bouton PW",
        "SEND_WELCOME_EMAIL_MMP": "Email de bienvenue MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "E-mail de bienvenue MMP digital sans bouton PW",
        "SEND_WELCOME_EMAIL_EXTRANET": "E-mail de bienvenue SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "E-mail de bienvenue SP sans bouton PW",
        "APPLY_FILTER_FOR_USERS": "Veuillez utiliser les filtres, ou chercher à afficher les résultats",
        "GENERATING_EMAIL": "Génération d'e-mail ....",
        "ERROR_EMAIL_GENERATE": "Erreur lors de la génération de l'e-mail ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Gestion des utilisateurs",
        "USER_WAS_ACTIVATED": "L'utilisateur a été activé",
        "USER_WAS_DEACTIVATED": "L'utilisateur a été désactivé",
        "ERROR_USER_ACTIVATION": "Une erreur s'est produite durant l'activation de l'utilisateur",
        "ERROR_USER_DEACTIVATION": "Une erreur s'est produite durant la désactivation de l'utilisateur",
        "LOADING_USER_ERROR": "Une erreur s'est produite lors de la connexion de l'utilisateur",
        "FIRSTNAME": "Prénom",
        "LASTNAME": "Nom",
        "EMAIL": "E-mail",
        "ACCOUNT_NAME": "Nom de connexion de l'utilisateur (pre-windows 2000)",
        "LANGUAGE": "Langue",
        "PRINCIPAL_NAME": "Nom de l'utilisateur principal",
        "OU": "Unité d'organisation",
        "CLASS_DISPLAY_NAME": "Afficher le nom",
        "PHONE": "Téléphone",
        "WEBSITE": "Site web",
        "COUNTRY": "Pays",
        "STATE": "État",
        "LOCATION": "Ville",
        "STREET": "Rue",
        "POSTAL_CODE": "Code postal",
        "COMPANY": "Compagnie",
        "DEPARTMENT": "Service",
        "PERSONAL_TITLE": "Intitulé du poste",
        "MANAGER": "Manager",
        "DESCRIPTION": "Description",
        "GROUPS": "Groupes",
        "SAVE": "Sauvegarder",
        "CANCEL": "Annuler",
        "USER_STATUS": "Statut de l'utilisateur",
        "ACTIVE": "Actif",
        "INACTIVE": "Inactif",
        "ACTIVATE": "Activé",
        "DEACTIVATE": "Désactivé",
        "USER_WAS_SAVED": "L'utilisateur a été sauvegardé",
        "UNKNOWN_ERROR": "Une erreur inconnue s'est produite lors de la sauvegarde de l'utilisateur",
        "PROXY_ADDRESSES": "Adresses Proxy",
        "BROWSE": "Naviguer",
        "REMOVE": "Enlever",
        "ONLY_JPG": "Seules les images jpg sont acceptées !",
        "FILE_SIZE": "La taille du fichier doit être inférieure à 100 KB !",
        "DIMENSIONS": "La dimension maximale des images est 96x96 pixels !",
        "SEND_FORGOT_PW_EMAIL": "Envoyer un e-mail pour mot de passe oublié",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "E-mail générique pour PW oublié",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-mail MM digital PW oublié",
        "SEND_FORGOT_PW_EMAIL_MMP": "E-mail MMP digital PW oublié",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "E-mail SP PW oublié",
        "VIRUS_FOUND": "L'utilisateur n'a pas pu être enregistré. Des logiciels malveillants ont été trouvés dans la pièce jointe. Le fichier ne sera pas téléchargé. Veuillez contacter votre administrateur système.",
        "VIRUS_SCANNER_NOT_AVL": "Le fichier n'a pas pu être analysé contre les logiciels malveillants. Veuillez réessayer plus tard. Si le problème persiste, contactez votre administrateur système.",
        "INFO": "Info :",
        "SEND_WELCOME_EMAIL": "Envoyer un e-mail de bienvenue",
        "SEND_WELCOME_EMAIL_DIGI": "Email de bienvenue MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-mail de bienvenue MM digital sans bouton PW",
        "SEND_WELCOME_EMAIL_MMP": "Email de bienvenue MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "E-mail de bienvenue MMP digital sans bouton PW",
        "SEND_WELCOME_EMAIL_EXTRANET": "E-mail de bienvenue SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "E-mail de bienvenue SP sans bouton PW",
        "SAVING_USER_SPINNER": "Sauvegarder l'utilisateur...Patientez",
        "DUPLICATE_USER": "L'utilisateur existe déjà",
        "GENERATING_EMAIL": "Génération d'e-mail ....",
        "ERROR_EMAIL_GENERATE": "Erreur lors de la génération de l'e-mail ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Utilisateur introuvable",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Générer un e-mail de bienvenue ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "L'utilisateur a été activé",
        "USER_WAS_DEACTIVATED": "L'utilisateur a été désactivé",
        "ERROR_USER_ACTIVATION": "Une erreur s'est produite durant l'activation de l'utilisateur",
        "ERROR_USER_DEACTIVATION": "Une erreur s'est produite durant la désactivation de l'utilisateur",
        "EMAIL_WAS_SENT": "L'e-mail a été envoyé correctement",
        "EMAIL_NOT_SENT_USER_ACTIVE": "L'e-mail n'a pas été envoyé. L'utilisateur est déjà actif. Utilisez à la place la fonctionnalité Envoyer un mot de passe oublié",
        "ERROR_EMAIL_SEND": "Erreur lors de l'envoi de l'email",
        "EMAIL_NOT_SENT_USER_INACTIVE": "L'e-mail n'a pas été envoyé. L'utilisateur est inactif. Utilisez la fonctionnalité Envoyer un e-mail d'inscription MM digital.",
        "PASSWORD_RESET_TOO_OFTEN": "La fonction de réinitialisation du mot de passe a été utilisée à de trop nombreuses reprises, veuillez réessayer plus tard.",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

/* harmony default export */ __webpack_exports__["a"] = (loc_fr_strings);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loc_it_strings = {
    "Login": {
        "HEADING": "Accesso alla piattaforma MM-ID",
        "LOGIN": "Accesso",
        "USER": "Utente",
        "PASSWORD": "Password",
        "LOGIN_FAIL": "Accesso non riuscito",
        "LOGIN_FIELD_REQUIRED": "Il campo \"Nome utente\" è obbligatorio",
        "PASSWORD_FIELD_REQUIRED": "Il campo \"Password\" è obbligatorio",
        "FORGOT_PASSWORD": "Hai dimenticato la password?",
        "DIFFERENT_ACCOUNT": "Accedi con un account diverso",
        "NO_ACCOUNT": "Non hai un account?",
        "REGISTER": "Registrati con MM digital",
        "CHANGE_DENIED_TEXT": "Per modificare la tua AD-password, utilizza ad esempio OWA, o contatta il tuo servizio assistenza."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Dashboard",
        "ACTION_TEXT": "Azioni",
        "CHANGE_PASSWORD_TEXT": "Modifica la password",
        "MY_APPLICATIONS_TEXT": "Le mie applicazioni MM",
        "APPLICATIONS_TEXT": "Applicazioni MM",
        "USERS_LIST_TEXT": "Gestione utente"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Dashboard",
        "MY_APPLICATIONS_TEXT": "Le mie applicazioni MM",
        "APPLICATIONS_TEXT": "Applicazioni MM"
    },
    "Header": {
        "USER_MENU_TEXT": "Menu utente",
        "ACTION_TEXT": "Azioni",
        "CHANGE_PASSWORD_TEXT": "Modifica password",
        "USERS_LIST_TEXT": "Gestione utente",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Vecchia password",
        "NEW_PASSWORD": "Nuova password",
        "CONFIRM_PASSWORD": "Conferma password",
        "PASS_DO_NOT_MATCH": "Le password non corrispondono",
        "PASSWORD_FIELD_REQUIRED": "Il campo \"Password\" è obbligatorio",
        "OLD_PASSWORD_FIELD_REQUIRED": "Il campo \"Vecchia password\" è obbligatorio",
        "SUCCESS_TEXT": "La password è stata correttamente modificata",
        "HEADING": "Modifica credenziali MM-ID",
        "HELP": "Serve aiuto?",
        "SAVE": "Modifica",
        "CANCEL": "Annulla",
        "PASSWORD_CHANGE_ERROR": "Impossibile salvare i dati. Riprova più tardi",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "La password deve contenere almeno 10 caratteri, tra cui minuscole, maiuscole, caratteri speciali, cifre",
        "PASSWORD_REQUIREMENTS_TEXT": "La password deve soddisfare i seguenti requisiti:",
        "LOWERCASE_LETTER_TEXT": "Almeno una lettera",
        "UPPERCASE_LETTER_TEXT": "Almeno una lettera maiuscola",
        "NUMBER_TEXT": "Almeno un numero",
        "SPECIAL_SYMBOL_TEXT": "Almeno un carattere speciale",
        "PASSWORD_LENGTH_TEXT": "Deve contenere almeno 10 caratteri",
        "PASSWORD_RESTRICTION_TEXT": "Il nome, il cognome o il nome utente non possono far parte della password",
        "CHANGE_PASSWORD_TEXT": "Modifica password",
        "ACTION_TEXT": "Azioni",
        "CHANGE_DENIED_TEXT": "Per modificare la tua AD-password, utilizza ad esempio OWA, o contatta il tuo servizio assistenza."
    },
    "CreatePassword": {
        "PASSWORD": "Crea una password",
        "CONFIRM_PASSWORD": "Conferma password",
        "PASS_DO_NOT_MATCH": "Le password non corrispondono",
        "PASSWORD_FIELD_REQUIRED": "Il campo \"Password\" è obbligatorio",
        "SUCCESS_TEXT": "I dati sono stati correttamente salvati",
        "HEADING": "Crea password",
        "HELP": "Serve aiuto?",
        "SAVE": "Modifica",
        "CANCEL": "Annulla",
        "PASSWORD_CHANGE_ERROR": "Impossibile salvare i dati. Riprova più tardi",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "La password deve contenere almeno 10 caratteri, tra cui minuscole, maiuscole, caratteri speciali, cifre",
        "PASSWORD_REQUIREMENTS_TEXT": "La password deve soddisfare i seguenti requisiti:",
        "LOWERCASE_LETTER_TEXT": "Almeno una lettera",
        "UPPERCASE_LETTER_TEXT": "Almeno una lettera maiuscola",
        "NUMBER_TEXT": "Almeno un numero",
        "SPECIAL_SYMBOL_TEXT": "Almeno un carattere speciale",
        "PASSWORD_LENGTH_TEXT": "Deve contenere almeno 10 caratteri",
        "PASSWORD_RESTRICTION_TEXT": "Il nome, il cognome o il nome utente non possono far parte della password",
        "PASSWORD_WAS_SET": "Il link è già stato utilizzato per impostare la password; se non ricordi la password, utilizza la funzione per reimpostare la password.",
        "OLD_PASSWORD_REQUIRED": "Il campo \"Vecchia password\" è obbligatorio",
        "MMID_CHANGE_PASSWORD": "Modifica password",
        "OLD_PASSWORD": "Vecchia password",
        "INVALID_OLD_PASSWORD": "Vecchia password non valida",
        "USER_NOT_FOUND_OR_INACTIVE": "Utente non trovato o inattivo",
        "UNKNOWN_ERROR": "Qualcosa è andato storto, in fase di modifica della password"
    },
    "ForgotPassword": {
        "USER": "E-mail",
        "LOGIN_FAIL": "Inserisci un indirizzo e-mail corretto",
        "LOGIN_FIELD_REQUIRED": "Il campo \"E-mail\" è obbligatorio",
        "HEADING": "Ho dimenticato la password",
        "HELP": "Hai bisogno d'aiuto?",
        "SAVE": "Invia e-mail per reimpostare la password",
        "CANCEL": "Annulla",
        "SUCCESS_TEXT": "Per verificare la ricezione dell'e-mail, controlla la tua cartella della Posta in arrivo.",
        "CHANGE_DENIED_TEXT": "Per modificare la tua AD-password, utilizza ad esempio OWA, o contatta il tuo servizio assistenza.",
        "PASSWORD_RESET_TOO_OFTEN": "La funzione di reimpostazione della password è stata utilizzata troppe volte, riprova più tardi",
        "RESET_FAILED": "Accesso non riuscito",
        "LINK_EXPIRED": "Il link d'accesso è scaduto. Inserisci il tuo indirizzo e-mail per richiedere nuovamente il link d'accesso.",
        "HEADING_EXPIRED": "Il tuo link d'accesso è scaduto",
        "SAVE_EXPIRED": "Richiedi link d'accesso"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Gestione utente",
        "ACTIVE": "Attivo",
        "INACTIVE": "Inattivo",
        "MMID": "MMID",
        "EXTRANET": "Utenti esterni",
        "OU": "Unità organizzativa",
        "ORGANIZATION_UNIT": "Unità di organizzazione",
        "LANGUAGE": "Lingua",
        "OPEN_FILTER": "Apri filtro",
        "CLOSE_FILTER": "Chiudi filtro",
        "RESET": "azzera",
        "RESET_ALL_FILTERS": "Azzera tutti i filtri",
        "SEARCH": "Ricerca",
        "STATUS": "Stato",
        "GROUPS": "Gruppi",
        "SHOW_ALL_DETAILS": "Mostra tutti i dettagli",
        "SHOW_LESS": "Mostra meno",
        "ASCENDING": "Ascendente",
        "DESCENDING": "Discendente",
        "LIST_END": "Termine dell'elenco",
        "SORT_BY_LASTNAME": "Ordina per cognome",
        "SORT_BY_FIRSTNAME": "Ordina per nome",
        "SORT_BY_EMAIL": "Ordina per e-mail",
        "SORT_BY_LANGUAGE": "Ordina per lingua preferita",
        "SORT_BY_STATUS": "Ordina per stato",
        "SORT_BY_OU": "Ordina per OU",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Modifica",
        "CREATE": "Nuovo utente",
        "DIGICREATE": "Nuovo utente MM digital",
        "EXTRANETCREATE": "Nuovo utente MM SharePoint Extranet",
        "MMPCREATE": "Nuovo utente MMP digital",
        "ACTIVATE": "Attiva",
        "DEACTIVATE": "Disattiva",
        "USER_WAS_ACTIVATED": "L'utente è stato attivato",
        "USER_WAS_DEACTIVATED": "L'utente è stato disattivato",
        "ERROR_USER_ACTIVATION": "Si è verificato un errore durante l'attivazione dell'utente",
        "ERROR_USER_DEACTIVATION": "Si è verificato un errore durante la disattivazione dell'utente",
        "SEND_FORGOT_PW_EMAIL": "Invia e-mail per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "E-mail generica per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-mail MM digital per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_MMP": "E-mail MMP digital per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "E-mail SP per password dimenticata",
        "COMPANY": "Società",
        "SEND_WELCOME_EMAIL": "Invia e-mail di benvenuto",
        "SEND_WELCOME_EMAIL_DIGI": "E-mail di benvenuto di MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-mail di benvenuto di MM digital senza pulsante PW",
        "SEND_WELCOME_EMAIL_MMP": "E-mail di benvenuto di MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "E-mail di benvenuto di MMP digital senza pulsante PW",
        "SEND_WELCOME_EMAIL_EXTRANET": "E-mail di benvenuto SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "E-mail di benvenuto SP senza pulsante PW",
        "APPLY_FILTER_FOR_USERS": "Per visualizzare i risultati, utilizza i filtri o la ricerca",
        "GENERATING_EMAIL": "Generazione dell'e-mail in corso...",
        "ERROR_EMAIL_GENERATE": "Errore durante la generazione dell' e-mail...",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Gestione utente",
        "USER_WAS_ACTIVATED": "L'utente è stato attivato",
        "USER_WAS_DEACTIVATED": "L'utente è stato disattivato",
        "ERROR_USER_ACTIVATION": "Si è verificato un errore durante l'attivazione dell'utente",
        "ERROR_USER_DEACTIVATION": "Si è verificato un errore durante la disattivazione dell'utente",
        "LOADING_USER_ERROR": "Si è verificato un errore durante il caricamento dell'utente",
        "FIRSTNAME": "Nome",
        "LASTNAME": "Cognome",
        "EMAIL": "E-mail",
        "ACCOUNT_NAME": "Nome di accesso dell'utente (pre-windows 2000)",
        "LANGUAGE": "Lingua",
        "PRINCIPAL_NAME": "Nome principale utente",
        "OU": "Unità di organizzazione",
        "CLASS_DISPLAY_NAME": "Nome visualizzato",
        "PHONE": "Telefono",
        "WEBSITE": "Sito web",
        "COUNTRY": "Paese",
        "STATE": "Stato",
        "LOCATION": "Città",
        "STREET": "Via",
        "POSTAL_CODE": "Codice postale",
        "COMPANY": "Società",
        "DEPARTMENT": "Dipartimento",
        "PERSONAL_TITLE": "Titolo personale",
        "MANAGER": "Manager",
        "DESCRIPTION": "Descrizione",
        "GROUPS": "Gruppi",
        "SAVE": "Salva",
        "CANCEL": "Annulla",
        "USER_STATUS": "Stato utente",
        "ACTIVE": "Attivo",
        "INACTIVE": "Inattivo",
        "ACTIVATE": "Attiva",
        "DEACTIVATE": "Disattiva",
        "USER_WAS_SAVED": "L'utente è stato salvato",
        "UNKNOWN_ERROR": "Si è verificato un errore sconosciuto in fase di salvataggio dell'utente",
        "PROXY_ADDRESSES": "Indirizzi proxy",
        "BROWSE": "Naviga",
        "REMOVE": "Rimuovi",
        "ONLY_JPG": "Sono consentite solo immagini in formato jpg!",
        "FILE_SIZE": "Le dimensioni del file devono essere inferiori ai 100 KB!",
        "DIMENSIONS": "La dimensione massima consentita per l'immagine è di 96X96 pixel!",
        "SEND_FORGOT_PW_EMAIL": "Invia e-mail per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "E-mail generica per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-mail MM digital per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_MMP": "E-mail MMP digital per password dimenticata",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "E-mail SP per password dimenticata",
        "VIRUS_FOUND": "L'utente non può essere salvato. Nell'allegato è stato rilevato un programma contenente malware. Il file non verrà caricato. Contatta l'amministratore di sistema.",
        "VIRUS_SCANNER_NOT_AVL": "Impossibile scansionare il file per il rilevamento di malware. Riprova più tardi. Se il problema persiste, contatta il tuo amministratore di sistema.",
        "INFO": "Info:",
        "SEND_WELCOME_EMAIL": "Invia e-mail di benvenuto",
        "SEND_WELCOME_EMAIL_DIGI": "E-mail di benvenuto di MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-mail di benvenuto di MM digital senza pulsante PW",
        "SEND_WELCOME_EMAIL_MMP": "E-mail di benvenuto di MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "E-mail di benvenuto di MMP digital senza pulsante PW",
        "SEND_WELCOME_EMAIL_EXTRANET": "E-mail di benvenuto SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "E-mail di benvenuto SP senza pulsante PW",
        "SAVING_USER_SPINNER": "Salvataggio dell'utente in corso... Attendi, per favore",
        "DUPLICATE_USER": "L'utente è già esistente",
        "GENERATING_EMAIL": "Generazione dell'e-mail...",
        "ERROR_EMAIL_GENERATE": "Errore durante la generazione dell'e-mail...",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Utente non trovato",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Generazione dell'e-mail di benvenuto..."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "L'utente è stato attivato",
        "USER_WAS_DEACTIVATED": "L'utente è stato disattivato",
        "ERROR_USER_ACTIVATION": "Si è verificato un errore durante l'attivazione dell'utente",
        "ERROR_USER_DEACTIVATION": "Si è verificato un errore durante la disattivazione dell'utente",
        "EMAIL_WAS_SENT": "L'e-mail è stata correttamente inviata",
        "EMAIL_NOT_SENT_USER_ACTIVE": "L'e-mail non è stata inviata. L'utente risulta già attivo. Utilizza, invece, la funzione \"Invia e-mail per password dimenticata\"",
        "ERROR_EMAIL_SEND": "Si è verificato un errore nel tentativo di invio dell'e-mail",
        "EMAIL_NOT_SENT_USER_INACTIVE": "L'e-mail non è stata inviata. L'utente risulta inattivo. Utilizza la funzione \"Invia e-mail di registrazione a MM digital\".",
        "PASSWORD_RESET_TOO_OFTEN": "La funzione di reimpostazione della password è stata utilizzata troppe volte, riprova più tardi",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

/* harmony default export */ __webpack_exports__["a"] = (loc_it_strings);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loc_nl_strings = {
    "Login": {
        "HEADING": "Inloggen MM-ID Platform",
        "LOGIN": "Inloggen",
        "USER": "Gebruikersnaam",
        "PASSWORD": "Wachtwoord",
        "LOGIN_FAIL": "Inloggen mislukt",
        "LOGIN_FIELD_REQUIRED": "Veld \"Gebruikersnaam\" is verplicht",
        "PASSWORD_FIELD_REQUIRED": "Veld \"Wachtwoord\" is verplicht",
        "FORGOT_PASSWORD": "Wachtwoord vergeten?",
        "DIFFERENT_ACCOUNT": "Aanmelden met een ander account",
        "NO_ACCOUNT": "Geen account?",
        "REGISTER": "Registreren bij MM digital\n",
        "CHANGE_DENIED_TEXT": "Gebruik bijv. OWA om uw AD-wachtwoord te wijzigen, of neem contact op met uw ondersteuningsafdeling"
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Dashboard",
        "ACTION_TEXT": "Acties",
        "CHANGE_PASSWORD_TEXT": "Wachtwoord wijzigen",
        "MY_APPLICATIONS_TEXT": "Mijn MM-toepassingen",
        "APPLICATIONS_TEXT": "MM-toepassingen",
        "USERS_LIST_TEXT": "Gebruikersbeheer"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Dashboard",
        "MY_APPLICATIONS_TEXT": "Mijn MM-toepassingen",
        "APPLICATIONS_TEXT": "MM-toepassingen"
    },
    "Header": {
        "USER_MENU_TEXT": "Gebruikersmenu",
        "ACTION_TEXT": "Acties",
        "CHANGE_PASSWORD_TEXT": "Wachtwoord wijzigen",
        "USERS_LIST_TEXT": "Gebruikersbeheer",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Oud wachtwoord",
        "NEW_PASSWORD": "Nieuw wachtwoord",
        "CONFIRM_PASSWORD": "Wachtwoord bevestigen",
        "PASS_DO_NOT_MATCH": "De wachtwoorden komen niet overeen",
        "PASSWORD_FIELD_REQUIRED": "Veld \"Wachtwoord\" is verplicht",
        "OLD_PASSWORD_FIELD_REQUIRED": "Veld \"Oud wachtwoord\" is verplicht",
        "SUCCESS_TEXT": "Wachtwoord is met succes gewijzigd",
        "HEADING": "Inloggegevens MM-ID wijzigen",
        "HELP": "Hulp nodig?",
        "SAVE": "Wijzigen",
        "CANCEL": "Annuleren",
        "PASSWORD_CHANGE_ERROR": "De gegevens konden niet worden opgeslagen. Probeer het later nog eens",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Wachtwoord moet tenminste uit 10 tekens bestaan en moet een kleine letter, hoofdletter, speciaal teken en cijfer bevatten",
        "PASSWORD_REQUIREMENTS_TEXT": "Wachtwoord moet aan de volgende vereisten voldoen:",
        "LOWERCASE_LETTER_TEXT": "Ten minste één  letter",
        "UPPERCASE_LETTER_TEXT": "Ten minste één hoofdletter",
        "NUMBER_TEXT": "Ten minste één cijfer",
        "SPECIAL_SYMBOL_TEXT": "Ten minste één speciaal teken",
        "PASSWORD_LENGTH_TEXT": "Moet ten minste 10 tekens bevatten",
        "PASSWORD_RESTRICTION_TEXT": "Uw voornaam, achternaam of gebruikersnaam mogen geen deel uitmaken van het wachtwoord",
        "CHANGE_PASSWORD_TEXT": "Wachtwoord wijzigen",
        "ACTION_TEXT": "Acties",
        "CHANGE_DENIED_TEXT": "Gebruik bijv. OWA om uw AD-wachtwoord te wijzigen, of neem contact op met uw ondersteuningsafdeling"
    },
    "CreatePassword": {
        "PASSWORD": "Wachtwoord aanmaken",
        "CONFIRM_PASSWORD": "Uw wachtwoord bevestigen",
        "PASS_DO_NOT_MATCH": "De wachtwoorden komen niet overeen",
        "PASSWORD_FIELD_REQUIRED": "Veld \"Wachtwoord\" is verplicht",
        "SUCCESS_TEXT": "De gegevens zijn met succes opgeslagen",
        "HEADING": "Wachtwoord aanmaken",
        "HELP": "Hulp nodig?",
        "SAVE": "Wijzigen",
        "CANCEL": "Annuleren",
        "PASSWORD_CHANGE_ERROR": "De gegevens konden niet worden opgeslagen. Probeer het later nog eens",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Wachtwoord moet ten minste uit 10 tekens bestaan en moet een kleine letter, hoofdletter, speciaal teken en cijfer bevatten",
        "PASSWORD_REQUIREMENTS_TEXT": "Wachtwoord moet aan de volgende vereisten voldoen:",
        "LOWERCASE_LETTER_TEXT": "Ten minste één letter",
        "UPPERCASE_LETTER_TEXT": "Ten minste één hoofdletter",
        "NUMBER_TEXT": "Ten minste één cijfer",
        "SPECIAL_SYMBOL_TEXT": "Ten minste één speciaal teken",
        "PASSWORD_LENGTH_TEXT": "Moet ten minste 10 tekens bevatten",
        "PASSWORD_RESTRICTION_TEXT": "De voornaam-, achternaam of gebruikersnaam mogen geen deel uitmaken van het wachtwoord",
        "PASSWORD_WAS_SET": "De link werd al gebruikt om een wachtwoord in te stellen. Als u het wachtwoord niet meer weet, gebruik dan de functie wachtwoord opnieuw instellen..",
        "OLD_PASSWORD_REQUIRED": "Veld \"Oud wachtwoord\" is verplicht",
        "MMID_CHANGE_PASSWORD": "Wachtwoord wijzigen",
        "OLD_PASSWORD": "Oud wachtwoord",
        "INVALID_OLD_PASSWORD": "Ongeldig oud wachtwoord",
        "USER_NOT_FOUND_OR_INACTIVE": "Gebruiker niet gevonden of inactief",
        "UNKNOWN_ERROR": "Er is iets verkeerd gegaan bij het wijzigen van het wachtwoord"
    },
    "ForgotPassword": {
        "USER": "E-mail",
        "LOGIN_FAIL": "Voer juist e-mailadres in",
        "LOGIN_FIELD_REQUIRED": "\"E-mail\" is een verplicht veld",
        "HEADING": "Wachtwoord vergeten",
        "HELP": "Hulp nodig?",
        "SAVE": "E-mail zenden om wachtwoord opnieuw in te stellen",
        "CANCEL": "Annuleren",
        "SUCCESS_TEXT": "Controleer in uw inbox of u een e-mail ontvangen hebt.",
        "CHANGE_DENIED_TEXT": "Gebruik bijv. OWA om uw AD-wachtwoord te wijzigen, of neem contact op met uw ondersteuningsafdeling.",
        "PASSWORD_RESET_TOO_OFTEN": "De functie wachtwoord opnieuw instellen is te vaak gebruikt, probeer het later nog eens",
        "RESET_FAILED": "Inloggen mislukt",
        "LINK_EXPIRED": "Uw inloglink is verlopen. Vul uw e-mailadres in om de link opnieuw aan te vragen.",
        "HEADING_EXPIRED": "Uw inloglink is verlopen",
        "SAVE_EXPIRED": "Inloglink aanvragen"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Gebruikersbeheer",
        "ACTIVE": "Actief",
        "INACTIVE": "Inactief",
        "MMID": "MMID",
        "EXTRANET": "Externe gebruikers",
        "OU": "Organisatorische eenheid",
        "ORGANIZATION_UNIT": "Organisatie-eenheid",
        "LANGUAGE": "Taal",
        "OPEN_FILTER": "Filter openen",
        "CLOSE_FILTER": "Filter sluiten",
        "RESET": "terugzetten",
        "RESET_ALL_FILTERS": "Alle filters terugzetten",
        "SEARCH": "Zoeken",
        "STATUS": "Status",
        "GROUPS": "Groepen",
        "SHOW_ALL_DETAILS": "Alle gegevens tonen",
        "SHOW_LESS": "Minder tonen",
        "ASCENDING": "Oplopend",
        "DESCENDING": "Aflopend",
        "LIST_END": "Einde van de lijst",
        "SORT_BY_LASTNAME": "Sorteren op achternaam",
        "SORT_BY_FIRSTNAME": "Sorteren op voornaam",
        "SORT_BY_EMAIL": "Sorteren op e-mail",
        "SORT_BY_LANGUAGE": "Sorteren op voorkeurstaal",
        "SORT_BY_STATUS": "Sorteren op status",
        "SORT_BY_OU": "Sorteren op OU",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Bewerken",
        "CREATE": "Nieuwe gebruiker",
        "DIGICREATE": "Nieuwe MM digital-gebruiker",
        "EXTRANETCREATE": "Nieuwe MM SharePoint Extranet-gebruiker",
        "MMPCREATE": "Nieuwe MMP digital-gebruiker",
        "ACTIVATE": "Activeren",
        "DEACTIVATE": "Deactiveren",
        "USER_WAS_ACTIVATED": "Gebruiker is geactiveerd",
        "USER_WAS_DEACTIVATED": "Gebruiker is gedeactiveerd",
        "ERROR_USER_ACTIVATION": "Fout bij activeren van gebruiker",
        "ERROR_USER_DEACTIVATION": "Fout bij deactiveren van gebruiker",
        "SEND_FORGOT_PW_EMAIL": "Zend e-mail wachtwoord vergeten",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Generieke e-mail WW vergeten",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Zend e-mail MM digital WW vergeten",
        "SEND_FORGOT_PW_EMAIL_MMP": "Zend e-mail MMP digital WW vergeten",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Zend e-mail SP WW vergeten",
        "COMPANY": "Bedrijf",
        "SEND_WELCOME_EMAIL": "Zend welkomstmail",
        "SEND_WELCOME_EMAIL_DIGI": "MM digital welkomstmail",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "MM digital welkomstmail zonder WW-knop",
        "SEND_WELCOME_EMAIL_MMP": "MMP digital welkomstmail",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "MMP digital welkomstmail zonder WW-knop",
        "SEND_WELCOME_EMAIL_EXTRANET": "SP welkomstmail",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "SP welkomstmail zonder WW-knop",
        "APPLY_FILTER_FOR_USERS": "Gebruik de filters of de zoekfunctie om de resultaten weer te geven",
        "GENERATING_EMAIL": "Genererer e-mail ....",
        "ERROR_EMAIL_GENERATE": "Fout bij het genereren van e-mail ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Gebruikersbeheer",
        "USER_WAS_ACTIVATED": "Gebruiker is geactiveerd",
        "USER_WAS_DEACTIVATED": "Gebruiker is gedeactiveerd",
        "ERROR_USER_ACTIVATION": "Fout bij activeren van gebruiker",
        "ERROR_USER_DEACTIVATION": "Fout bij deactiveren van gebruiker",
        "LOADING_USER_ERROR": "Fout bij laden van gebruiker",
        "FIRSTNAME": "Voornaam",
        "LASTNAME": "Achternaam",
        "EMAIL": "E-mail",
        "ACCOUNT_NAME": "Naam gebruikerslogin (pre-windows 2000)",
        "LANGUAGE": "Taal",
        "PRINCIPAL_NAME": "Naam gebruikerslogin",
        "OU": "Organisatorische eenheid",
        "CLASS_DISPLAY_NAME": "Weergavenaam",
        "PHONE": "Telefoon",
        "WEBSITE": "Website",
        "COUNTRY": "Land",
        "STATE": "Staat",
        "LOCATION": "Stad",
        "STREET": "Straat",
        "POSTAL_CODE": "Postcode",
        "COMPANY": "Bedrijf",
        "DEPARTMENT": "Afdeling",
        "PERSONAL_TITLE": "Aanspreektitel",
        "MANAGER": "Manager",
        "DESCRIPTION": "Beschrijving",
        "GROUPS": "Groepen",
        "SAVE": "Opslaan",
        "CANCEL": "Annuleren",
        "USER_STATUS": "Gebruikersstatus",
        "ACTIVE": "Actief",
        "INACTIVE": "Inactief",
        "ACTIVATE": "Activeren",
        "DEACTIVATE": "Deactiveren",
        "USER_WAS_SAVED": "Gebruiker is opgeslagen",
        "UNKNOWN_ERROR": "Bij het opslaan van de gebruiker is een onbekende fout opgetreden.",
        "PROXY_ADDRESSES": "Proxy-adressen",
        "BROWSE": "Bladeren",
        "REMOVE": "Verwijderen",
        "ONLY_JPG": "Alleen jpg-afbeeldingen zijn toegelaten!",
        "FILE_SIZE": "Bestand moet kleiner zijn dan 100 kB!",
        "DIMENSIONS": "Maximale grootte afbeeldingen is 96X96 pixels!",
        "SEND_FORGOT_PW_EMAIL": "Zend e-mail wachtwoord vergeten",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Generieke e-mail WW vergeten",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-mail MM digital WW vergeten",
        "SEND_FORGOT_PW_EMAIL_MMP": "E-mail MMP digital WW vergeten",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "E-mail SP WW vergeten",
        "VIRUS_FOUND": "De gebruiker kon niet worden opgeslagen. Er is malware gevonden in de bijlage. Het bestand wordt niet geüpload. Neem contact op met uw systeembeheerder.",
        "VIRUS_SCANNER_NOT_AVL": "Het bestand kon niet worden gescand op malware. Probeer het later nog eens. Neem contact op met uw systeembeheerder als het probleem aanhoudt.",
        "INFO": "Over:",
        "SEND_WELCOME_EMAIL": "Zend welkomstmail",
        "SEND_WELCOME_EMAIL_DIGI": "MM digital welkomstmail",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "MM digital welkomstmail zonder WW-knop",
        "SEND_WELCOME_EMAIL_MMP": "MMP digital welkomstmail",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "MMP digital welkomstmail zonder WW-knop",
        "SEND_WELCOME_EMAIL_EXTRANET": "SP welkomstmail",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "SP welkomstmail zonder WW-knop",
        "SAVING_USER_SPINNER": "Gebruiker opslaan... Wachten",
        "DUPLICATE_USER": "Gebruiker bestaat reeds",
        "GENERATING_EMAIL": "Genererer e-mail ....",
        "ERROR_EMAIL_GENERATE": "Fout bij het genereren van e-mail ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Gebruiker niet gevonden",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Genererer Velkommen e-mail ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Gebruiker is geactiveerd",
        "USER_WAS_DEACTIVATED": "Gebruiker is gedeactiveerd",
        "ERROR_USER_ACTIVATION": "Fout bij activeren van gebruiker",
        "ERROR_USER_DEACTIVATION": "Fout bij deactiveren van gebruiker",
        "EMAIL_WAS_SENT": "E--mail met succes verzonden",
        "EMAIL_NOT_SENT_USER_ACTIVE": "E-mail is niet verzonden. De gebruiker is al actief. Gebruik in plaats daarvan de functie 'Zend e-mail WW vergeten\"",
        "ERROR_EMAIL_SEND": "Fout bij het zenden van de e-mail",
        "EMAIL_NOT_SENT_USER_INACTIVE": "E-mail is niet verzonden. De gebruiker is inactief. Gebruik de functie 'Zend registratie-e-mail MM digital'",
        "PASSWORD_RESET_TOO_OFTEN": "De functie wachtwoord opnieuw instellen is te vaak gebruikt, probeer het later nog eens",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

/* harmony default export */ __webpack_exports__["a"] = (loc_nl_strings);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loc_pl_strings = {
    "Login": {
        "HEADING": "Zaloguj się na platformę MM-ID",
        "LOGIN": "Zaloguj się",
        "USER": "Użytkownik",
        "PASSWORD": "Hasło",
        "LOGIN_FAIL": "Logowanie nieudane",
        "LOGIN_FIELD_REQUIRED": "Pole „nazwa użytkownika” jest wymagane",
        "PASSWORD_FIELD_REQUIRED": "Pole „hasło” jest wymagane",
        "FORGOT_PASSWORD": "Zapomniane hasło?",
        "DIFFERENT_ACCOUNT": "Zaloguj się na inne konto",
        "NO_ACCOUNT": "Nie posiadasz konta? ",
        "REGISTER": "Zarejestruj się w MM digital",
        "CHANGE_DENIED_TEXT": "Skorzystaj np. z OWA do zmiany hasła AD lub skontaktuj się z działem obsługi."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Panel użytkownika",
        "ACTION_TEXT": "Akcje",
        "CHANGE_PASSWORD_TEXT": "Zmień hasło",
        "MY_APPLICATIONS_TEXT": "Moje aplikacje MM",
        "APPLICATIONS_TEXT": "Aplikacje MM",
        "USERS_LIST_TEXT": "Zarządzanie użytkownikami"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Panel użytkownika",
        "MY_APPLICATIONS_TEXT": "Moje aplikacje MM",
        "APPLICATIONS_TEXT": "Aplikacje MM"
    },
    "Header": {
        "USER_MENU_TEXT": "Menu użytkownika",
        "ACTION_TEXT": "Akcje",
        "CHANGE_PASSWORD_TEXT": "Zmień hasło",
        "USERS_LIST_TEXT": "Zarządzanie użytkownikami",
        "USER_GROUPS": "Role"
    },
    "Credentials": {
        "OLD_PASSWORD": "Stare hasło",
        "NEW_PASSWORD": "Nowe hasło",
        "CONFIRM_PASSWORD": "Potwierdź hasło",
        "PASS_DO_NOT_MATCH": " Hasła nie są zgodne",
        "PASSWORD_FIELD_REQUIRED": "Pole „hasło” jest wymagane",
        "OLD_PASSWORD_FIELD_REQUIRED": "Pole „stare hasło” jest wymagane",
        "SUCCESS_TEXT": "Hasło zostało zmienione",
        "HEADING": "Zmień dane MM-ID",
        "HELP": "Potrzebujesz pomocy?",
        "SAVE": "Zmień",
        "CANCEL": "Anuluj",
        "PASSWORD_CHANGE_ERROR": "Nie można było zapisać danych. Spróbuj ponownie później",
        "PASSWORD_STREIGHT_ERROR": "Hasło powinno zawierać minimum 10 znaków, w tym małe i wielkie litery, znaki specjalne i cyfry",
        "PASSWORD_REQUIREMENTS_TEXT": "Hasło musi spełniać następujące wymagania i zawierać:",
        "LOWERCASE_LETTER_TEXT": "Co najmniej jedną literę ",
        "UPPERCASE_LETTER_TEXT": "Co najmniej jedną wielką literę",
        "NUMBER_TEXT": "Co najmniej jedną cyfrę",
        "SPECIAL_SYMBOL_TEXT": "Co najmniej jeden znak specjalny",
        "PASSWORD_LENGTH_TEXT": "Co najmniej 10 znaków",
        "PASSWORD_RESTRICTION_TEXT": "Imię, nazwisko lub nazwa użytkownika nie mogą występować w haśle",
        "CHANGE_PASSWORD_TEXT": "Zmień hasło",
        "ACTION_TEXT": "Działania",
        "CHANGE_DENIED_TEXT": "Skorzystaj np. z OWA do zmiany hasła AD lub skontaktuj się z działem obsługi."
    },
    "CreatePassword": {
        "PASSWORD": "Utwórz hasło",
        "CONFIRM_PASSWORD": "Potwierdź hasło",
        "PASS_DO_NOT_MATCH": "Hasła nie są zgodne",
        "PASSWORD_FIELD_REQUIRED": "Pole „hasło” jest wymagane",
        "SUCCESS_TEXT": "Dane zostały zapisane",
        "HEADING": "Utwórz hasło",
        "HELP": "Potrzebujesz pomocy?",
        "SAVE": "Zmień",
        "CANCEL": "Anuluj",
        "PASSWORD_CHANGE_ERROR": "Nie można było zapisać danych. Spróbuj ponownie później",
        "PASSWORD_STREIGHT_ERROR": "Hasło powinno zawierać minimum 10 znaków, w tym małe i wielkie litery, znaki specjalne i cyfry",
        "PASSWORD_REQUIREMENTS_TEXT": "Hasło musi spełniać następujące wymagania i zawierać:",
        "LOWERCASE_LETTER_TEXT": "Co najmniej jedną literę",
        "UPPERCASE_LETTER_TEXT": "Co najmniej jedną wielką literę",
        "NUMBER_TEXT": "Co najmniej jedną cyfrę",
        "SPECIAL_SYMBOL_TEXT": "Co najmniej jeden znak specjalny",
        "PASSWORD_LENGTH_TEXT": "Co najmniej 10 znaków",
        "PASSWORD_RESTRICTION_TEXT": "Imię, nazwisko lub nazwa użytkownika nie mogą występować w haśle",
        "PASSWORD_WAS_SET": "Odnośnik został już wykorzystany do ustanowienia hasła. Jeśli nie pamiętasz hasła, skorzystaj z funkcji resetowania hasła.",
        "OLD_PASSWORD_REQUIRED": "Pole „stare hasło” jest wymagane",
        "MMID_CHANGE_PASSWORD": "Zmień hasło",
        "OLD_PASSWORD": "Stare hasło",
        "INVALID_OLD_PASSWORD": "Nieprawidłowe stare hasło",
        "USER_NOT_FOUND_OR_INACTIVE": "Użytkownik nie został znaleziony lub nie jest aktywny",
        "UNKNOWN_ERROR": "Coś poszło nie tak przy zmianie hasła."
    },
    "ForgotPassword": {
        "USER": "E-mail",
        "LOGIN_FAIL": "Wprowadź prawidłowy adres e-mail",
        "LOGIN_FIELD_REQUIRED": "Pole „adres e-mail” jest wymagane",
        "HEADING": "Zapomniane hasło",
        "HELP": "Potrzebujesz pomocy?",
        "SAVE": "Wyślij wiadomość e-mail do zresetowania hasła",
        "CANCEL": "Anuluj",
        "SUCCESS_TEXT": "Sprawdź, czy wiadomość e-mail dotarła do Twojej skrzynki.",
        "CHANGE_DENIED_TEXT": "Skorzystaj np. z OWA do zmiany hasła AD lub skontaktuj się z działem obsługi.",
        "PASSWORD_RESET_TOO_OFTEN": "Zbyt wiele prób użycia funkcji resetowania hasła. Spróbuj ponownie później",
        "RESET_FAILED": "Logowanie nieudane",
        "LINK_EXPIRED": "Twój link do logowania wygasł. Wpisz swój adres e-mail, aby uzyskać nowy link do logowania.",
        "HEADING_EXPIRED": "Twój link do logowania wygasł",
        "SAVE_EXPIRED": "Uzyskaj nowy link do logowania"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Zarządzanie użytkownikami",
        "ACTIVE": "Aktywne",
        "INACTIVE": "Nieaktywne",
        "MMID": "Identyfikator MM",
        "EXTRANET": "Użytkownicy zewnętrzni",
        "OU": "Jednostka organizacyjna",
        "ORGANIZATION_UNIT": "Jednostka organizacyjna",
        "LANGUAGE": "Język",
        "OPEN_FILTER": "Otwórz filtr",
        "CLOSE_FILTER": "Zamknij filtr",
        "RESET": "Zresetuj",
        "RESET_ALL_FILTERS": "Zresetuj wszystkie filtry",
        "SEARCH": "Szukaj",
        "STATUS": "Status",
        "GROUPS": "Grupy",
        "SHOW_ALL_DETAILS": "Wyświetl wszystkie szczegóły",
        "SHOW_LESS": "Wyświetl mniej",
        "ASCENDING": "Rosnąco",
        "DESCENDING": "Malejąco",
        "LIST_END": "Koniec listy",
        "SORT_BY_LASTNAME": "Sortuj wg nazwiska",
        "SORT_BY_FIRSTNAME": "Sortuj wg imienia",
        "SORT_BY_EMAIL": "Sortuj wg adresu e-mail",
        "SORT_BY_LANGUAGE": "Sortuj wg preferowanego języka",
        "SORT_BY_STATUS": "Sortuj wg statusu",
        "SORT_BY_OU": "Sortuj wg jedn. org.",
        "EDIT": "Edytuj",
        "CREATE": "Nowy użytkownik",
        "DIGICREATE": "Nowy użytkownik MM digital",
        "EXTRANETCREATE": "Nowy użytkownik ekstranetu MM SharePoint",
        "ACTIVATE": "Aktywuj",
        "DEACTIVATE": "Dezaktywuj",
        "USER_WAS_ACTIVATED": "Użytkownik został aktywowany",
        "USER_WAS_DEACTIVATED": "Użytkownik został zdezaktywowany",
        "ERROR_USER_ACTIVATION": "Błąd podczas aktywacji użytkownika",
        "ERROR_USER_DEACTIVATION": "Błąd podczas dezaktywacji użytkownika",
        "SEND_FORGOT_PW_EMAIL": "Wyślij wiadomość e-mail z przypomnieniem hasła",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Ogólna wiadomość e-mail z przypomnieniem hasła",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Wiadomość e-mail z przypomnieniem hasła MM digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Wiadomość e-mail z przypomnieniem hasła SP",
        "COMPANY": "Firma",
        "SEND_WELCOME_EMAIL": "Wyślij powitalną wiadomość e-mail",
        "SEND_WELCOME_EMAIL_DIGI": "Powitalna wiadomość e-mail MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Powitalna wiadomość e-mail MM digital bez przycisku hasła",
        "SEND_WELCOME_EMAIL_EXTRANET": "Powitalna wiadomość e-mail SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Powitalna wiadomość e-mail SP bez przycisku hasła",
        "APPLY_FILTER_FOR_USERS": "Użyj filtrów lub funkcji wyszukiwania, aby wyświetlić wyniki",
        "GENERATING_EMAIL": "Generowanie wiadomości e-mail....",
        "ERROR_EMAIL_GENERATE": "Błąd generowania wiadomości e-mail....",
        "SORT_BY_ACCOUNT_NAME": "Sortuj wg nazwy logowania",
        "LOCKED": "Zablokowane",
        "UNLOCK": "Odblokuj",
        "SET_PASSWORD": "Ustaw hasło",
        "PHYSICAL_LOCATION": "Lokalizacja",
        "REQUIRED": "Wymagane",
        "MMPCREATE": "Nowy użytkownik MMP digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "Wiadomość e-mail z przypomnieniem hasła MMP digital",
        "SEND_WELCOME_EMAIL_MMP": "Powitalna wiadomość e-mail MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Powitalna wiadomość e-mail MMP digital bez przycisku hasła",
        "USER_TYPE": "Typ użytkownika",
        "CANONICAL_NAME": "Nazwa kanoniczna"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Zarządzanie użytkownikami",
        "USER_WAS_ACTIVATED": "Użytkownik został aktywowany",
        "USER_WAS_DEACTIVATED": "Użytkownik został zdezaktywowany",
        "ERROR_USER_ACTIVATION": "Błąd podczas aktywacji użytkownika",
        "ERROR_USER_DEACTIVATION": "Błąd podczas dezaktywacji użytkownika",
        "LOADING_USER_ERROR": "Błąd wczytywania użytkownika",
        "FIRSTNAME": "Imię",
        "LASTNAME": "Nazwisko",
        "EMAIL": "E-mail",
        "ACCOUNT_NAME": "Nazwa logowania użytkownika (przed Windows 2000)",
        "LANGUAGE": "Język",
        "PRINCIPAL_NAME": "Główna nazwa użytkownika",
        "OU": "Jednostka organizacyjna",
        "CLASS_DISPLAY_NAME": "Nazwa wyświetlana",
        "PHONE": "Nr telefonu",
        "WEBSITE": "Strona Internetowa",
        "COUNTRY": "Kraj",
        "STATE": "Województwo",
        "LOCATION": "Miasto",
        "STREET": "Ulica",
        "POSTAL_CODE": "Kod pocztowy",
        "COMPANY": "Firma",
        "DEPARTMENT": "Dział",
        "PERSONAL_TITLE": "Tytuł",
        "MANAGER": "Menedżer",
        "DESCRIPTION": "Opis",
        "GROUPS": "Grupy",
        "SAVE": "Zapisz",
        "CANCEL": "Anuluj",
        "USER_STATUS": "Status użytkownika",
        "ACTIVE": "Aktywne",
        "INACTIVE": "Nieaktywne",
        "ACTIVATE": "Aktywuj",
        "DEACTIVATE": "Dezaktywuj",
        "USER_WAS_SAVED": "Użytkownik został zapisany. Zaktualizowanie informacji na serwerze może zająć do 60 sekund.<br/> Jeśli dane nie zostaną zaktualizowane, spróbuj odświeżyć stronę w 30 sekundowych odstępach.",
        "UNKNOWN_ERROR": "Podczas zapisywania użytkownika wystąpił nieznany błąd",
        "PROXY_ADDRESSES": "Adresy proxy",
        "BROWSE": "Przeglądaj",
        "REMOVE": "Usuń",
        "ONLY_JPG": "Dozwolone są wyłącznie obrazy w formacie JPG!",
        "FILE_SIZE": "Rozmiar pliku nie może przekraczać 100 KB!",
        "DIMENSIONS": "Maksymalne wymiary obrazu wynoszą 96x96 pikseli!",
        "SEND_FORGOT_PW_EMAIL": "Wyślij wiadomość e-mail z przypomnieniem hasła",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Ogólna wiadomość e-mail z przypomnieniem hasła",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Wiadomość e-mail z przypomnieniem hasła MM digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Wiadomość e-mail z przypomnieniem hasła SP",
        "VIRUS_FOUND": "Nie udało się zapisać użytkownika. W załączniku wykryto złośliwe oprogramowanie. Plik nie zostanie przesłany. Skontaktuj się z administratorem systemu.",
        "VIRUS_SCANNER_NOT_AVL": "Nie udało się przeskanować pliku na obecność złośliwego oprogramowania. Spróbuj ponownie później. Jeżeli problem nie ustąpi, skontaktuj się z administratorem systemu.",
        "INFO": "Informacja:",
        "SEND_WELCOME_EMAIL": "Wyślij powitalną wiadomość e-mail",
        "SEND_WELCOME_EMAIL_DIGI": "Powitalna wiadomość e-mail MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Powitalna wiadomość e-mail MM digital bez przycisku hasła",
        "SEND_WELCOME_EMAIL_EXTRANET": "Powitalna wiadomość e-mail SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Powitalna wiadomość e-mail SP bez przycisku hasła",
        "SAVING_USER_SPINNER": "Proszę czekać, trwa zapisywanie użytkownika...",
        "DUPLICATE_USER": "Użytkownik już istnieje",
        "GENERATING_EMAIL": "Generowanie wiadomości e-mail....",
        "ERROR_EMAIL_GENERATE": "Błąd generowania wiadomości e-mail....",
        "UNLOCK": "Odblokuj",
        "SET_PASSWORD": "Ustaw hasło",
        "COST_CENTER": "Centrum kosztów",
        "JOB_TITLE": "Tytuł zawodowy",
        "GENDER": "Płeć",
        "SEND_FORGOT_PW_EMAIL_MMP": "Wiadomość e-mail z przypomnieniem hasła MMP digital",
        "SEND_WELCOME_EMAIL_MMP": "Powitalna wiadomość e-mail MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Powitalna wiadomość e-mail MMP digital bez przycisku hasła",
        "USER_NOT_FOUND": "Nie znaleziono użytkownika",
        "USER_TYPE": "Typ użytkownika",
        "CANONICAL_NAME": "Nazwa kanoniczna"
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Użytkownik został aktywowany",
        "USER_WAS_DEACTIVATED": "Użytkownik został zdezaktywowany",
        "ERROR_USER_ACTIVATION": "Błąd podczas aktywacji użytkownika",
        "ERROR_USER_DEACTIVATION": "Błąd podczas dezaktywacji użytkownika",
        "EMAIL_WAS_SENT": "Wiadomość e-mail została wysłana.",
        "EMAIL_NOT_SENT_USER_ACTIVE": "Wiadomość e-mail nie została wysłana. Użytkownik jest już aktywny. Użyj funkcji wysyłania wiadomości e-mail z przypomnieniem hasła",
        "ERROR_EMAIL_SEND": "Wystąpił błąd przy próbie wysłania wiadomości e-mail",
        "EMAIL_NOT_SENT_USER_INACTIVE": "Wiadomość e-mail nie została wysłana. Użytkownik jest nieaktywny. Użyj funkcji wysyłania zaproszenia do rejestracji w MM digital.",
        "PASSWORD_RESET_TOO_OFTEN": "Zbyt wiele prób użycia funkcji resetowania hasła. Spróbuj ponownie później",
        "USER_WAS_UNLOCKED": "Użytkownik został odblokowany",
        "ERROR_UNLOCK_USER": "Błąd odblokowywania użytkownika"
    },
    "Backend": {
        "FieldRequired": "To pole jest wymagane.",
        "FirstName": "Imię",
        "InvalidEmail": "Wprowadź prawidłowy adres e-mail",
        "InvalidPhone": "Nieprawidłowy numer telefonu.",
        "LastName": "Nazwisko",
        "StringLength": "Pole musi mieć formę wiersza o minimalnej długości {2} i maksymalnej długości {1} znaków."
    },
    "Emails": {
        "Header": "Twoje konto {{var-app-name}}",
        "Welcome": "Witaj w {{var-app-name}}",
        "HelloLine": "Szanowny(-a) {{var-salutation}} {{var-first-name}} {{var-last-name}},",
        "AccountCreatedLine": "Twoje konto w {{var-app-name}} zostało utworzone. Aby ukończyć proces aktywacji konta, prosimy o zweryfikowanie adresu e-mail poprzez kliknięcie przycisku poniżej:",
        "Login": "Zaloguj się",
        "SingInLink": "W przyszłości możesz logować się przy pomocy tego linku:",
        "AccountDetails": "Dane Twojego konta:",
        "Email": "E-mail",
        "FristName": "Imię",
        "LastName": "Nazwisko",
        "SupportAssist": "W przypadku pytań, nasz <b><a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-app-name}} Dział obsługi klienta</a></b> z przyjemnością udzieli Ci pomocy.",
        "BestRegards": "Z pozdrowieniami,<br/> Zespół {{var-app-name-2}}",
        "ContactSupport": "Kontakt z działem obsługi",
        "ForgotPassword": "Zapomniane hasło",
        "PleaseResetPassword": "Zresetuj swoje hasło w {{var-app-name}}",
        "ResetPasswordLine": "Możesz zresetować hasło do swojego konta {{var-app-name}} w ciągu najbliższych 24 godzin, klikając przycisk poniżej:",
        "ResetPassword": "Zresetuj hasło",
        "IgnoreEmailLine": "Jeśli nie chcesz resetować hasła, zwyczajnie zignoruj tę wiadomość.",
        "ResendWelcome1": "Ten link do logowania pozostanie ważny przez 5 dni:",
        "ResendWelcome2": "Uzyskaj ponownie link do logowania",
        "ContactSupportMMK": "Skontaktuj się z działem obsługi MM digital",
        "AccountCreatedLine_NoButton": "Twoje konto {{var-app-name}} zostało utworzone.",
        "ContactSupportMMP": "Skontaktuj się z działem obsługi MMP digital",
        "CreateUserSubject": "Witaj w {{var-app-name}}",
        "ForgotPasswordSubject": "{{var-app-name}}: resetowanie hasła",
        "SupportAssistMMP": "W przypadku pytań skontaktuj się bezpośrednio z lokalnym partnerem sprzedaży. W razie napotkania problemów technicznych, możesz skontaktować się {{var-app-name}} z działem obsługi pod adresem <a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-support-email}}</a>",
        "SupportAssistMMK": "W przypadku pytań, nasz <b><a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-app-name}} Dział obsługi klienta</a></b> z przyjemnością udzieli Ci pomocy.",
        "SupportAssistSharepoint": "W przypadku pytań, nasz <b><a href=\"mailto:{{var-support-email}}\" style=\"color: #369AD6;\">{{var-app-name}} Dział obsługi klienta</a></b> z przyjemnością udzieli Ci pomocy."
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Generowanie powitalnej wiadomości e-mail...."
    }
};

/* harmony default export */ __webpack_exports__["a"] = (loc_pl_strings);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loc_ru_strings = {
    "Login": {
        "HEADING": "Войти на MM-ID",
        "LOGIN": "Войти",
        "USER": "Пользователь",
        "PASSWORD": "Пароль",
        "LOGIN_FAIL": "Войти не удалось",
        "LOGIN_FIELD_REQUIRED": "Обязательно введите имя пользователя",
        "PASSWORD_FIELD_REQUIRED": "Обязательно введите пароль",
        "FORGOT_PASSWORD": "Забыли пароль?",
        "DIFFERENT_ACCOUNT": "Войти в другой аккаунт",
        "NO_ACCOUNT": "Нет аккаунта?",
        "REGISTER": "Зарегистрироваться на MMK",
        "CHANGE_DENIED_TEXT": "Вы можете сменить ваш пароль AD на Outlook Web Access или свяжитесь со службой поддержки."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Панель управления",
        "ACTION_TEXT": "Действия",
        "CHANGE_PASSWORD_TEXT": "Сменить пароль",
        "MY_APPLICATIONS_TEXT": "Мои приложения MM",
        "APPLICATIONS_TEXT": "Приложения MM",
        "USERS_LIST_TEXT": "Управление пользователями"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Панель управления",
        "MY_APPLICATIONS_TEXT": "Мои приложения MM",
        "APPLICATIONS_TEXT": "Приложения MM"
    },
    "Header": {
        "USER_MENU_TEXT": "Меню пользователя",
        "ACTION_TEXT": "Действия",
        "CHANGE_PASSWORD_TEXT": "Сменить пароль",
        "USERS_LIST_TEXT": "Управление пользователями",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Старый пароль",
        "NEW_PASSWORD": "Новый пароль",
        "CONFIRM_PASSWORD": "Подтвердите пароль",
        "PASS_DO_NOT_MATCH": "Пароли не совпадают",
        "PASSWORD_FIELD_REQUIRED": "Поле \"Пароль\" обязательно для заполнения",
        "OLD_PASSWORD_FIELD_REQUIRED": "Поле \"Старый пароль\" обязательно для заполнения",
        "SUCCESS_TEXT": "Пароль был успешно изменен",
        "HEADING": "Сменить данные MM-ID",
        "HELP": "Нужна помощь?",
        "SAVE": "Изменить",
        "CANCEL": "Отменить",
        "PASSWORD_CHANGE_ERROR": "Не удалось сохранить данные. Повторите попытку позже",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Пароль должен содержать не менее 10 символов (симв. нижнего и верхнего регистров, спец.символы и цифры)",
        "PASSWORD_REQUIREMENTS_TEXT": "Пароль должен соответствовать следующим требованиям:",
        "LOWERCASE_LETTER_TEXT": "Минимум одна буква",
        "UPPERCASE_LETTER_TEXT": "Минимум одна буква верхнего регистра",
        "NUMBER_TEXT": "Минимум одна цифра",
        "SPECIAL_SYMBOL_TEXT": "Минимум один специальный символ",
        "PASSWORD_LENGTH_TEXT": "Содержать не менее 10 символов",
        "PASSWORD_RESTRICTION_TEXT": "Имя, фамилия и имя пользователя не должны быть частью пароля",
        "CHANGE_PASSWORD_TEXT": "Сменить пароль",
        "ACTION_TEXT": "Действия",
        "CHANGE_DENIED_TEXT": "Вы можете сменить ваш пароль AD на Outlook Web Access или свяжитесь со службой поддержки."
    },
    "CreatePassword": {
        "PASSWORD": "Создайте пароль",
        "CONFIRM_PASSWORD": "Подтвердите пароль",
        "PASS_DO_NOT_MATCH": "Пароли не совпадают",
        "PASSWORD_FIELD_REQUIRED": "Поле \"Пароль\" обязательно для заполнения",
        "SUCCESS_TEXT": "Данные были успешно изменены",
        "HEADING": "Создайте пароль",
        "HELP": "Нужна помощь?",
        "SAVE": "Изменить",
        "CANCEL": "Отменить",
        "PASSWORD_CHANGE_ERROR": "Не удалось сохранить данные. Повторите попытку позже",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Пароль должен содержать не менее 10 символов (симв. нижнего и верхнего регистров, спец.символы и цифры)",
        "PASSWORD_REQUIREMENTS_TEXT": "Пароль должен соответствовать следующим требованиям:",
        "LOWERCASE_LETTER_TEXT": "Минимум одна буква",
        "UPPERCASE_LETTER_TEXT": "Минимум одна буква верхнего регистра",
        "NUMBER_TEXT": "Минимум одна цифра",
        "SPECIAL_SYMBOL_TEXT": "Минимум один специальный символ",
        "PASSWORD_LENGTH_TEXT": "Содержать не менее 10 символов",
        "PASSWORD_RESTRICTION_TEXT": "Имя, фамилия и имя пользователя не должны быть частью пароля",
        "PASSWORD_WAS_SET": "Ссылка уже использовалась для создания пароля. Если вы не помните пароль, воспользуйтесь функцией смены пароля.",
        "OLD_PASSWORD_REQUIRED": "Поле \"Старый пароль\" обязательно для заполнения",
        "MMID_CHANGE_PASSWORD": "Сменить пароль",
        "OLD_PASSWORD": "Старый пароль",
        "INVALID_OLD_PASSWORD": "Старый пароль неправильный",
        "USER_NOT_FOUND_OR_INACTIVE": "Пользователь не найден или он неактивен",
        "UNKNOWN_ERROR": "Произошла ошибка при смене пароля"
    },
    "ForgotPassword": {
        "USER": "Адрес эл.почты",
        "LOGIN_FAIL": "Введите правильный адрес эл.почты",
        "LOGIN_FIELD_REQUIRED": "Поле \"Адрес эл.почты\" обязательно для заполнения",
        "HEADING": "Не помню пароль",
        "HELP": "Нужна помощь?",
        "SAVE": "Отправить инструкции по смене пароля",
        "CANCEL": "Отменить",
        "SUCCESS_TEXT": "Проверьте почту, вы должны были получить наше письмо.",
        "CHANGE_DENIED_TEXT": "Вы можете сменить ваш пароль AD на Outlook Web Access или свяжитесь со службой поддержки.",
        "PASSWORD_RESET_TOO_OFTEN": "Функция смены пароля использовалась слишком часто. Повторите попытку позже",
        "RESET_FAILED": "Не удалось войти",
        "LINK_EXPIRED": "Срок действия вашей ссылки для входа в систему истек. Введите ваш адрес электронной почты для повторного получения ссылки для входа в систему.",
        "HEADING_EXPIRED": "Срок действия вашей ссылки для входа в систему истек",
        "SAVE_EXPIRED": "Направить запрос на получение ссылки для входа в систему"
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Управление пользователями",
        "ACTIVE": "Активен",
        "INACTIVE": "Неактивен",
        "MMID": "MMID",
        "EXTRANET": "Внешние пользователи",
        "OU": "Организационная единица",
        "ORGANIZATION_UNIT": "Организационная единица",
        "LANGUAGE": "Язык",
        "OPEN_FILTER": "Открыть фильтр",
        "CLOSE_FILTER": "Закрыть фильтр",
        "RESET": "сбросить",
        "RESET_ALL_FILTERS": "Сбросить все фильтры",
        "SEARCH": "Поиск",
        "STATUS": "Состояние",
        "GROUPS": "Группы",
        "SHOW_ALL_DETAILS": "Показать все детали",
        "SHOW_LESS": "Скрыть",
        "ASCENDING": "По возрастанию",
        "DESCENDING": "По убыванию",
        "LIST_END": "Конец списка",
        "SORT_BY_LASTNAME": "Сортировать по фамилии",
        "SORT_BY_FIRSTNAME": "Сортировать по имени",
        "SORT_BY_EMAIL": "Сортировать по адресу эл.почты",
        "SORT_BY_LANGUAGE": "Сортировать по языку",
        "SORT_BY_STATUS": "Сортировать по статусу",
        "SORT_BY_OU": "Сортировать по ОЕ",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Изменить",
        "CREATE": "Новый пользователь",
        "DIGICREATE": "Новый пользователь MM digital",
        "EXTRANETCREATE": "Новый пользователь MM SharePoint Extranet",
        "MMPCREATE": "Новый пользователь MMP digital",
        "ACTIVATE": "Активировать",
        "DEACTIVATE": "Деактивировать",
        "USER_WAS_ACTIVATED": "Пользователь активирован",
        "USER_WAS_DEACTIVATED": "Пользователь деактивирован",
        "ERROR_USER_ACTIVATION": "При активации произошла ошибка",
        "ERROR_USER_DEACTIVATION": "При деактивации произошла ошибка",
        "SEND_FORGOT_PW_EMAIL": "Отправить инструкции по смене пароля",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Стандартные инструкции по смене пароля",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Инструкции по смене пароля MM digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "Инструкции по смене пароля MMP digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Инструкции по смене пароля SP",
        "COMPANY": "Компания",
        "SEND_WELCOME_EMAIL": "Отправлять приветственное письмо",
        "SEND_WELCOME_EMAIL_DIGI": "Приветственное письмо MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Приветственное письмо MM digital без кнопки пароля",
        "SEND_WELCOME_EMAIL_MMP": "Приветственное письмо MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Приветственное письмо MMP digital без кнопки пароля",
        "SEND_WELCOME_EMAIL_EXTRANET": "Приветственное письмо SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Приветственное письмо SP без кнопки пароля",
        "APPLY_FILTER_FOR_USERS": "Воспользуйтесь фильтрами или функцией поиска для вывода результатов",
        "GENERATING_EMAIL": "Создание электронной почты ....",
        "ERROR_EMAIL_GENERATE": "Ошибка при генерации электронной почты ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Управление пользователями",
        "USER_WAS_ACTIVATED": "Пользователь активирован",
        "USER_WAS_DEACTIVATED": "Пользователь деактивирован",
        "ERROR_USER_ACTIVATION": "При активации произошла ошибка",
        "ERROR_USER_DEACTIVATION": "При деактивации произошла ошибка",
        "LOADING_USER_ERROR": "Загрузка ошибки пользователя",
        "FIRSTNAME": "Имя",
        "LASTNAME": "Фамилия",
        "EMAIL": "Адрес эл.почты",
        "ACCOUNT_NAME": "Логин пользователя (до Windows 2000)",
        "LANGUAGE": "Язык",
        "PRINCIPAL_NAME": "Имя участника-пользователя",
        "OU": "Организационная единица",
        "CLASS_DISPLAY_NAME": "Отображаемое имя",
        "PHONE": "Телефон",
        "WEBSITE": "Веб-сайт",
        "COUNTRY": "Страна",
        "STATE": "Штат/область",
        "LOCATION": "Город",
        "STREET": "Улица",
        "POSTAL_CODE": "Почтовый индекс",
        "COMPANY": "Компания",
        "DEPARTMENT": "Отдел",
        "PERSONAL_TITLE": "Должность",
        "MANAGER": "Управляющий",
        "DESCRIPTION": "Описание",
        "GROUPS": "Группы",
        "SAVE": "Сохранить",
        "CANCEL": "Отменить",
        "USER_STATUS": "Статус пользователя",
        "ACTIVE": "Активен",
        "INACTIVE": "Неактивен",
        "ACTIVATE": "Активировать",
        "DEACTIVATE": "Деактивировать",
        "USER_WAS_SAVED": "Пользователь сохранен",
        "UNKNOWN_ERROR": "При сохранении пользователя произошла неизвестная ошибка",
        "PROXY_ADDRESSES": "Прокси-адреса",
        "BROWSE": "Обзор",
        "REMOVE": "Удалить",
        "ONLY_JPG": "Поддерживаются только изображения в формате jpg!",
        "FILE_SIZE": "Размер файла не должен превышать 100 Кб!",
        "DIMENSIONS": "Максимально допустимые масштабы изображения: 96х96 пикселей",
        "SEND_FORGOT_PW_EMAIL": "Отправить инструкции по смене пароля",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Стандартные инструкции по смене пароля",
        "SEND_FORGOT_PW_EMAIL_DIGI": "Инструкции по смене пароля MM digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "Инструкции по смене пароля MMP digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "Инструкции по смене пароля SP",
        "VIRUS_FOUND": "Сохранить пользователя не удалось. В прикрепленном файле найдена вредоносная программа. Файл не будет загружен. Свяжитесь с системным администратором.",
        "VIRUS_SCANNER_NOT_AVL": "Не удалось проверить файл на наличие вредоносных программ. Повторите попытку позже. Свяжитесь с системным администратором, если проблема не решится.",
        "INFO": "Сведения:",
        "SEND_WELCOME_EMAIL": "Отправлять приветственное письмо",
        "SEND_WELCOME_EMAIL_DIGI": "Приветственное письмо MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "Приветственное письмо MM digital без кнопки пароля",
        "SEND_WELCOME_EMAIL_MMP": "Приветственное письмо MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "Приветственное письмо MMP digital без кнопки пароля",
        "SEND_WELCOME_EMAIL_EXTRANET": "Приветственное письмо SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "Приветственное письмо SP без кнопки пароля",
        "SAVING_USER_SPINNER": "Сохраняем данные пользователя, подождите",
        "DUPLICATE_USER": "Такой пользователь уже есть",
        "GENERATING_EMAIL": "Создание электронной почты ....",
        "ERROR_EMAIL_GENERATE": "Ошибка при генерации электронной почты ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Пользователь не найден",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Создание приветственного сообщения электронной почты ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Пользователь активирован",
        "USER_WAS_DEACTIVATED": "Пользователь деактивирован",
        "ERROR_USER_ACTIVATION": "При активации произошла ошибка",
        "ERROR_USER_DEACTIVATION": "При деактивации произошла ошибка",
        "EMAIL_WAS_SENT": "Письмо было успешно отправлено",
        "EMAIL_NOT_SENT_USER_ACTIVE": "Письмо не было отправлено. Пользователь уже активирован. Воспользуйтесь функцией отправки инструкций по смене пароля",
        "ERROR_EMAIL_SEND": "Ошибка при отправке письма",
        "EMAIL_NOT_SENT_USER_INACTIVE": "Письмо не было отправлено. Пользователь неактивен. Воспользуйтесь функцией отправки письма для регистрации на MM digital",
        "PASSWORD_RESET_TOO_OFTEN": "Функция смены пароля использовалась слишком часто. Повторите попытку позже",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

/* harmony default export */ __webpack_exports__["a"] = (loc_ru_strings);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loc_sl_strings = {
    "Login": {
        "HEADING": "Prijava v platformo MM-ID",
        "LOGIN": "Prijava",
        "USER": "Uporabniško ime",
        "PASSWORD": "Geslo",
        "LOGIN_FAIL": "Prijava ni uspela",
        "LOGIN_FIELD_REQUIRED": "Polje \"Uporabniško ime\" je obvezno",
        "PASSWORD_FIELD_REQUIRED": "Polje \"Geslo\" je obvezno",
        "FORGOT_PASSWORD": "Ali si pozabil geslo?",
        "DIFFERENT_ACCOUNT": "Prijavi se z drugim računom",
        "NO_ACCOUNT": "Nimaš računa?␣",
        "REGISTER": "Registriraj se z MM digital",
        "CHANGE_DENIED_TEXT": "Uporabi npr. OWA za spremembo AD-gesla ali kontaktiraj svojo podporo."
    },
    "Dashboard": {
        "DASHBOARD_TEXT": "Nadzorna plošča",
        "ACTION_TEXT": "Dejanja",
        "CHANGE_PASSWORD_TEXT": "Spremeni geslo",
        "MY_APPLICATIONS_TEXT": "Moje aplikacije MM",
        "APPLICATIONS_TEXT": "Aplikacije MM",
        "USERS_LIST_TEXT": "Upravljanje uporabnikov"
    },
    "DashboardHome": {
        "ACTION_TEXT": "Nadzorna plošča",
        "MY_APPLICATIONS_TEXT": "Moje aplikacije MM",
        "APPLICATIONS_TEXT": "Aplikacije MM"
    },
    "Header": {
        "USER_MENU_TEXT": "Uporabniški meni",
        "ACTION_TEXT": "Dejanja",
        "CHANGE_PASSWORD_TEXT": "Spremeni geslo",
        "USERS_LIST_TEXT": "Upravljanje uporabnikov",
        "USER_GROUPS": "Roles"
    },
    "Credentials": {
        "OLD_PASSWORD": "Staro geslo",
        "NEW_PASSWORD": "Novo geslo",
        "CONFIRM_PASSWORD": "Potrdi geslo",
        "PASS_DO_NOT_MATCH": "␣Gesli se ne ujemata",
        "PASSWORD_FIELD_REQUIRED": "Polje \"Geslo\" je obvezno",
        "OLD_PASSWORD_FIELD_REQUIRED": "Polje \"Staro geslo\" je obvezno",
        "SUCCESS_TEXT": "Geslo je bilo uspešno spremenjeno",
        "HEADING": "Spremeni poverilnice MM-ID",
        "HELP": "Potrebuješ pomoč?",
        "SAVE": "Spremeni",
        "CANCEL": "Prekliči",
        "PASSWORD_CHANGE_ERROR": "Podatkov ni mogoče shraniti. Poskusi kasneje.",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Geslo mora vsebovati vsaj 10 znakov, malo, veliko črko, poseben znak, števko",
        "PASSWORD_REQUIREMENTS_TEXT": "Geslo mora izpolnjevati naslednje zahteve:",
        "LOWERCASE_LETTER_TEXT": "Vsaj ena črka␣ ",
        "UPPERCASE_LETTER_TEXT": "Vsaj ena velika črka",
        "NUMBER_TEXT": "Vsaj ena številka",
        "SPECIAL_SYMBOL_TEXT": "Vsaj en poseben simbol",
        "PASSWORD_LENGTH_TEXT": "Imeti mora vsaj 10 znakov",
        "PASSWORD_RESTRICTION_TEXT": "Ime, priimek in uporabniško ime ne smejo biti del gesla",
        "CHANGE_PASSWORD_TEXT": "Spremeni geslo",
        "ACTION_TEXT": "Dejanja",
        "CHANGE_DENIED_TEXT": "Uporabi npr. OWA za spremembo AD-gesla ali kontaktiraj podporno službo."
    },
    "CreatePassword": {
        "PASSWORD": "Ustvari geslo",
        "CONFIRM_PASSWORD": "Potrdi svoje geslo",
        "PASS_DO_NOT_MATCH": "Gesli se ne ujemata",
        "PASSWORD_FIELD_REQUIRED": "Polje \"Geslo\" je obvezno",
        "SUCCESS_TEXT": "Geslo je bilo uspešno shranjeno",
        "HEADING": "Ustvari geslo",
        "HELP": "Potrebuješ pomoč?",
        "SAVE": "Spremeni",
        "CANCEL": "Prekliči",
        "PASSWORD_CHANGE_ERROR": "Podatkov ni mogoče shraniti. Poskusi kasneje",
        "PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
        "PASSWORD_STREIGHT_ERROR": "Geslo mora vsebovati vsaj 10 simbolov, malo, veliko črko, poseben znak, števko",
        "PASSWORD_REQUIREMENTS_TEXT": "Geslo mora izpolnjevati naslednje zahteve:",
        "LOWERCASE_LETTER_TEXT": "Vsaj ena črka",
        "UPPERCASE_LETTER_TEXT": "Vsaj ena velika črka",
        "NUMBER_TEXT": "Vsaj ena številka",
        "SPECIAL_SYMBOL_TEXT": "Vsaj en poseben simbol",
        "PASSWORD_LENGTH_TEXT": "Imeti mora vsaj 10 znakov",
        "PASSWORD_RESTRICTION_TEXT": "Ime, priimek in uporabniško ime ne smejo biti del gesla",
        "PASSWORD_WAS_SET": "Povezava je že bila uporabljena za nastavitev gesla, če se ne spomnite gesla, uporabite funkcijo gesla za ponastavitev.",
        "OLD_PASSWORD_REQUIRED": "Polje \"Staro geslo\" je obvezno",
        "MMID_CHANGE_PASSWORD": "Spremeni geslo",
        "OLD_PASSWORD": "Staro geslo",
        "INVALID_OLD_PASSWORD": "Neveljavno staro geslo",
        "USER_NOT_FOUND_OR_INACTIVE": "Uporabnik ne obstaja ali je neaktiven ",
        "UNKNOWN_ERROR": "Med spreminjanjem gesla je prišlo do napake"
    },
    "ForgotPassword": {
        "USER": "E-pošta",
        "LOGIN_FAIL": "Vnesi pravilni E-pošta",
        "LOGIN_FIELD_REQUIRED": "Polje \"E-pošta\" je obvezno",
        "HEADING": "Si pozabil geslo?",
        "HELP": "Potrebuješ pomoč?",
        "SAVE": "Pošlji e-sporočilo za ponastavitev gesla",
        "CANCEL": "Prekliči",
        "SUCCESS_TEXT": "V nabiralniku preveri, če si prejel e-sporočilo.",
        "CHANGE_DENIED_TEXT": "Uporabi npr. OWA za spremembo AD-gesla ali kontaktiraj podporno službo.",
        "PASSWORD_RESET_TOO_OFTEN": "Funkcija ponastavitve gesla je bila prevečkrat uporabljena. Poskusi kasneje. ",
        "RESET_FAILED": "Prijava ni uspela",
        "LINK_EXPIRED": "Povezava za prijavo je potekla. Ponovno vnesite svoj elektronski naslov in prosite za novo povezavo.",
        "HEADING_EXPIRED": "Povezava za prijavo je potekla.",
        "SAVE_EXPIRED": "Zahtevaj povezavo za prijavo."
    },
    "UsersList": {
        "USERS_LIST_TEXT": "Upravljanje uporabnikov",
        "ACTIVE": "Aktiven",
        "INACTIVE": "Neaktiven",
        "MMID": "MMID",
        "EXTRANET": "Zunanji uporabniki",
        "OU": "Organizacijska enota",
        "ORGANIZATION_UNIT": "Organizacijska enota",
        "LANGUAGE": "Jezik",
        "OPEN_FILTER": "Odpri filter",
        "CLOSE_FILTER": "Zapri filter",
        "RESET": "ponastavi",
        "RESET_ALL_FILTERS": "Ponastavi vse filtre",
        "SEARCH": "Išči",
        "STATUS": "Status",
        "GROUPS": "Skupine",
        "SHOW_ALL_DETAILS": "Prikaži vse podrobnosti",
        "SHOW_LESS": "Prikaži manj",
        "ASCENDING": "Naraščajoče",
        "DESCENDING": "Padajoče",
        "LIST_END": "Konec seznama",
        "SORT_BY_LASTNAME": "Razvrsti po priimku",
        "SORT_BY_FIRSTNAME": "Razvrsti po imenu",
        "SORT_BY_EMAIL": "Razvrsti po e-naslovu",
        "SORT_BY_LANGUAGE": "Razvrsti po želenem jeziku",
        "SORT_BY_STATUS": "Razvrsti po statusu",
        "SORT_BY_OU": "Razvrsti po OU",
        "SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
        "EDIT": "Uredi",
        "CREATE": "Nov uporabnik",
        "DIGICREATE": "Novi uporabnik MM digital",
        "EXTRANETCREATE": "Novi uporabnik MM SharePoint Extranet",
        "MMPCREATE": "Novi uporabnik MMP digital",
        "ACTIVATE": "Aktiviraj",
        "DEACTIVATE": "Deaktiviraj",
        "USER_WAS_ACTIVATED": "Uporabnik je bil aktiviran",
        "USER_WAS_DEACTIVATED": "Uporabnik je bil deaktiviran",
        "ERROR_USER_ACTIVATION": "Napaka med aktivacijo uporabnika",
        "ERROR_USER_DEACTIVATION": "Napaka med deaktivacijo uporabnika",
        "SEND_FORGOT_PW_EMAIL": "Pošlji e-sporočilo o pozabljenem geslu",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Splošno e-sporočilo o pozabljenem geslu",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-sporočilo o pozabljenem geslu MM digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "E-sporočilo o pozabljenem geslu MMP digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "E-sporočilo o pozabljenem geslu SP",
        "COMPANY": "Podjetje",
        "SEND_WELCOME_EMAIL": "Pošlji e-sporočilo za dobrodošlico",
        "SEND_WELCOME_EMAIL_DIGI": "E-sporočilo za dobrodošlico MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo MM digital",
        "SEND_WELCOME_EMAIL_MMP": "E-sporočilo za dobrodošlico MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo MMP digital",
        "SEND_WELCOME_EMAIL_EXTRANET": "E-sporočilo za dobrodošlico SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo SP",
        "APPLY_FILTER_FOR_USERS": "Uporabi filtre ali iskanje za prikaz rezultatov",
        "GENERATING_EMAIL": "Ustvarjanje e-pošte ....",
        "ERROR_EMAIL_GENERATE": "Napaka pri ustvarjanju e-pošte ....",
        "LOCKED": "Locked",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "PHYSICAL_LOCATION": "Location",
        "REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "EditUser": {
        "USERS_LIST_TEXT": "Upravljanje uporabnikov",
        "USER_WAS_ACTIVATED": "Uporabnik je bil aktiviran",
        "USER_WAS_DEACTIVATED": "Uporabnik je bil deaktiviran",
        "ERROR_USER_ACTIVATION": "Napaka med aktivacijo uporabnika",
        "ERROR_USER_DEACTIVATION": "Napaka med deaktivacijo uporabnika",
        "LOADING_USER_ERROR": "Napaka pri nalaganju uporabnika",
        "FIRSTNAME": "Ime",
        "LASTNAME": "Priimek",
        "EMAIL": "E-pošta",
        "ACCOUNT_NAME": "Uporabniško ime za prijavo (predhodniki OS Windows 2000) ",
        "LANGUAGE": "Jezik",
        "PRINCIPAL_NAME": "Glavno uporabniško ime",
        "OU": "Organizacijska enota",
        "CLASS_DISPLAY_NAME": "Prikaži ime",
        "PHONE": "Telefon",
        "WEBSITE": "Spletna stran",
        "COUNTRY": "Država",
        "STATE": "Država",
        "LOCATION": "Mesto",
        "STREET": "Ulica",
        "POSTAL_CODE": "Poštna številka",
        "COMPANY": "Podjetje",
        "DEPARTMENT": "Oddelek",
        "PERSONAL_TITLE": "Osebni naziv",
        "MANAGER": "Vodja",
        "DESCRIPTION": "Opis",
        "GROUPS": "Skupine",
        "SAVE": "Shrani",
        "CANCEL": "Prekliči",
        "USER_STATUS": "Status uporabnika",
        "ACTIVE": "Aktiven",
        "INACTIVE": "Neaktiven",
        "ACTIVATE": "Aktiviraj",
        "DEACTIVATE": "Deaktiviraj",
        "USER_WAS_SAVED": "Uporabnik je bil shranjen",
        "UNKNOWN_ERROR": "Pri shranjevanju uporabnika je prišlo do neznane napake",
        "PROXY_ADDRESSES": "Naslovi posredniških strežnikov",
        "BROWSE": "Prebrskaj",
        "REMOVE": "Odstrani",
        "ONLY_JPG": "Dovoljene so le slike s končnico .jpg!",
        "FILE_SIZE": "Velikost datoteke mora biti manjša od 100KB!",
        "DIMENSIONS": "Največja dimenzija slike je 96x96 pikslov!",
        "SEND_FORGOT_PW_EMAIL": "Pošlji e-sporočilo o pozabljenem geslu",
        "SEND_FORGOT_PW_EMAIL_GENERIC": "Splošno e-sporočilo o pozabljenem geslu",
        "SEND_FORGOT_PW_EMAIL_DIGI": "E-sporočilo o pozabljenem geslu MM digital",
        "SEND_FORGOT_PW_EMAIL_MMP": "E-sporočilo o pozabljenem geslu MMP digital",
        "SEND_FORGOT_PW_EMAIL_EXTRANET": "E-sporočilo o pozabljenem geslu SP",
        "VIRUS_FOUND": "Uporabnika ni bilo mogoče shraniti. V priponki je bila najdena zlonamerna programska oprema. Datoteka ne bo naložena. Kontaktiraj svojega sistemskega skrbnika.",
        "VIRUS_SCANNER_NOT_AVL": "Ni bilo možno preveriti prisotnosti zlonamerne programske opreme v datoteki. Poskusi ponovno kasneje. Če težava ni odpravljena, kontaktiraj svojega sistemskega skrbnika. ",
        "INFO": "Vizitka:",
        "SEND_WELCOME_EMAIL": "Pošlji e-sporočilo za dobrodošlico",
        "SEND_WELCOME_EMAIL_DIGI": "E-sporočilo za dobrodošlico MM digital",
        "SEND_WELCOME_EMAIL_DIGI_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo MM digital",
        "SEND_WELCOME_EMAIL_MMP": "E-sporočilo za dobrodošlico MMP digital",
        "SEND_WELCOME_EMAIL_MMP_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo MMP digital",
        "SEND_WELCOME_EMAIL_EXTRANET": "E-sporočilo za dobrodošlico SP",
        "SEND_WELCOME_EMAIL_EXTRANET_NO_PASS": "E-sporočilo za dobrodošlico brez gumba za geslo SP",
        "SAVING_USER_SPINNER": "Shranjevanje uporabnika... Prosim, počakaj",
        "DUPLICATE_USER": "Uporabnik že obstaja",
        "GENERATING_EMAIL": "Ustvarjanje e-pošte ....",
        "ERROR_EMAIL_GENERATE": "Napaka pri ustvarjanju e-pošte ....",
        "UNLOCK": "Unlock",
        "SET_PASSWORD": "Set password",
        "COST_CENTER": "Cost center",
        "JOB_TITLE": "Job title",
        "GENDER": "Gender",
        "USER_NOT_FOUND": "Uporabnik ne obstaja",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
    },
    "ResendWelcome": {
        "GENERATING_EMAIL": "Ustvarjanje dobrodošlice E-pošta ...."
    },
    "Shared": {
        "USER_WAS_ACTIVATED": "Uporabnik je bil aktiviran",
        "USER_WAS_DEACTIVATED": "Uporabnik je bil deaktiviran",
        "ERROR_USER_ACTIVATION": "Napaka med aktivacijo uporabnika",
        "ERROR_USER_DEACTIVATION": "Napaka med deaktivacijo uporabnika",
        "EMAIL_WAS_SENT": "E-sporočilo je bilo uspešno poslano",
        "EMAIL_NOT_SENT_USER_ACTIVE": "E-sporočilo ni bilo poslano. Uporabnik je že aktiviran. Namesto tega uporabi funkcijo 'pošlji e-sporočilo za pozabljeno geslo'.",
        "ERROR_EMAIL_SEND": "Napaka pri poskusu pošiljanja e-sporočila",
        "EMAIL_NOT_SENT_USER_INACTIVE": "E-sporočilo ni bilo poslano. Uporabi funkcijo 'pošlji e-sporočilo za registracijo MM digital'.",
        "PASSWORD_RESET_TOO_OFTEN": "Funkcija ponastavitve gesla je bila prepogosto uporabljena. Poskusi ponovno kasneje.",
        "USER_WAS_UNLOCKED": "User was unlocked",
        "ERROR_UNLOCK_USER": "Error unlocking user"
    }
};

/* harmony default export */ __webpack_exports__["a"] = (loc_sl_strings);

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = [["AF","AFG","004","ISO 3166-2:AF"],["AX","ALA","248","ISO 3166-2:AX"],["AL","ALB","008","ISO 3166-2:AL"],["DZ","DZA","012","ISO 3166-2:DZ"],["AS","ASM","016","ISO 3166-2:AS"],["AD","AND","020","ISO 3166-2:AD"],["AO","AGO","024","ISO 3166-2:AO"],["AI","AIA","660","ISO 3166-2:AI"],["AQ","ATA","010","ISO 3166-2:AQ"],["AG","ATG","028","ISO 3166-2:AG"],["AR","ARG","032","ISO 3166-2:AR"],["AM","ARM","051","ISO 3166-2:AM"],["AW","ABW","533","ISO 3166-2:AW"],["AU","AUS","036","ISO 3166-2:AU"],["AT","AUT","040","ISO 3166-2:AT"],["AZ","AZE","031","ISO 3166-2:AZ"],["BS","BHS","044","ISO 3166-2:BS"],["BH","BHR","048","ISO 3166-2:BH"],["BD","BGD","050","ISO 3166-2:BD"],["BB","BRB","052","ISO 3166-2:BB"],["BY","BLR","112","ISO 3166-2:BY"],["BE","BEL","056","ISO 3166-2:BE"],["BZ","BLZ","084","ISO 3166-2:BZ"],["BJ","BEN","204","ISO 3166-2:BJ"],["BM","BMU","060","ISO 3166-2:BM"],["BT","BTN","064","ISO 3166-2:BT"],["BO","BOL","068","ISO 3166-2:BO"],["BQ","BES","535","ISO 3166-2:BQ"],["BA","BIH","070","ISO 3166-2:BA"],["BW","BWA","072","ISO 3166-2:BW"],["BV","BVT","074","ISO 3166-2:BV"],["BR","BRA","076","ISO 3166-2:BR"],["IO","IOT","086","ISO 3166-2:IO"],["BN","BRN","096","ISO 3166-2:BN"],["BG","BGR","100","ISO 3166-2:BG"],["BF","BFA","854","ISO 3166-2:BF"],["BI","BDI","108","ISO 3166-2:BI"],["KH","KHM","116","ISO 3166-2:KH"],["CM","CMR","120","ISO 3166-2:CM"],["CA","CAN","124","ISO 3166-2:CA"],["CV","CPV","132","ISO 3166-2:CV"],["KY","CYM","136","ISO 3166-2:KY"],["CF","CAF","140","ISO 3166-2:CF"],["TD","TCD","148","ISO 3166-2:TD"],["CL","CHL","152","ISO 3166-2:CL"],["CN","CHN","156","ISO 3166-2:CN"],["CX","CXR","162","ISO 3166-2:CX"],["CC","CCK","166","ISO 3166-2:CC"],["CO","COL","170","ISO 3166-2:CO"],["KM","COM","174","ISO 3166-2:KM"],["CG","COG","178","ISO 3166-2:CG"],["CD","COD","180","ISO 3166-2:CD"],["CK","COK","184","ISO 3166-2:CK"],["CR","CRI","188","ISO 3166-2:CR"],["CI","CIV","384","ISO 3166-2:CI"],["HR","HRV","191","ISO 3166-2:HR"],["CU","CUB","192","ISO 3166-2:CU"],["CW","CUW","531","ISO 3166-2:CW"],["CY","CYP","196","ISO 3166-2:CY"],["CZ","CZE","203","ISO 3166-2:CZ"],["DK","DNK","208","ISO 3166-2:DK"],["DJ","DJI","262","ISO 3166-2:DJ"],["DM","DMA","212","ISO 3166-2:DM"],["DO","DOM","214","ISO 3166-2:DO"],["EC","ECU","218","ISO 3166-2:EC"],["EG","EGY","818","ISO 3166-2:EG"],["SV","SLV","222","ISO 3166-2:SV"],["GQ","GNQ","226","ISO 3166-2:GQ"],["ER","ERI","232","ISO 3166-2:ER"],["EE","EST","233","ISO 3166-2:EE"],["ET","ETH","231","ISO 3166-2:ET"],["FK","FLK","238","ISO 3166-2:FK"],["FO","FRO","234","ISO 3166-2:FO"],["FJ","FJI","242","ISO 3166-2:FJ"],["FI","FIN","246","ISO 3166-2:FI"],["FR","FRA","250","ISO 3166-2:FR"],["GF","GUF","254","ISO 3166-2:GF"],["PF","PYF","258","ISO 3166-2:PF"],["TF","ATF","260","ISO 3166-2:TF"],["GA","GAB","266","ISO 3166-2:GA"],["GM","GMB","270","ISO 3166-2:GM"],["GE","GEO","268","ISO 3166-2:GE"],["DE","DEU","276","ISO 3166-2:DE"],["GH","GHA","288","ISO 3166-2:GH"],["GI","GIB","292","ISO 3166-2:GI"],["GR","GRC","300","ISO 3166-2:GR"],["GL","GRL","304","ISO 3166-2:GL"],["GD","GRD","308","ISO 3166-2:GD"],["GP","GLP","312","ISO 3166-2:GP"],["GU","GUM","316","ISO 3166-2:GU"],["GT","GTM","320","ISO 3166-2:GT"],["GG","GGY","831","ISO 3166-2:GG"],["GN","GIN","324","ISO 3166-2:GN"],["GW","GNB","624","ISO 3166-2:GW"],["GY","GUY","328","ISO 3166-2:GY"],["HT","HTI","332","ISO 3166-2:HT"],["HM","HMD","334","ISO 3166-2:HM"],["VA","VAT","336","ISO 3166-2:VA"],["HN","HND","340","ISO 3166-2:HN"],["HK","HKG","344","ISO 3166-2:HK"],["HU","HUN","348","ISO 3166-2:HU"],["IS","ISL","352","ISO 3166-2:IS"],["IN","IND","356","ISO 3166-2:IN"],["ID","IDN","360","ISO 3166-2:ID"],["IR","IRN","364","ISO 3166-2:IR"],["IQ","IRQ","368","ISO 3166-2:IQ"],["IE","IRL","372","ISO 3166-2:IE"],["IM","IMN","833","ISO 3166-2:IM"],["IL","ISR","376","ISO 3166-2:IL"],["IT","ITA","380","ISO 3166-2:IT"],["JM","JAM","388","ISO 3166-2:JM"],["JP","JPN","392","ISO 3166-2:JP"],["JE","JEY","832","ISO 3166-2:JE"],["JO","JOR","400","ISO 3166-2:JO"],["KZ","KAZ","398","ISO 3166-2:KZ"],["KE","KEN","404","ISO 3166-2:KE"],["KI","KIR","296","ISO 3166-2:KI"],["KP","PRK","408","ISO 3166-2:KP"],["KR","KOR","410","ISO 3166-2:KR"],["KW","KWT","414","ISO 3166-2:KW"],["KG","KGZ","417","ISO 3166-2:KG"],["LA","LAO","418","ISO 3166-2:LA"],["LV","LVA","428","ISO 3166-2:LV"],["LB","LBN","422","ISO 3166-2:LB"],["LS","LSO","426","ISO 3166-2:LS"],["LR","LBR","430","ISO 3166-2:LR"],["LY","LBY","434","ISO 3166-2:LY"],["LI","LIE","438","ISO 3166-2:LI"],["LT","LTU","440","ISO 3166-2:LT"],["LU","LUX","442","ISO 3166-2:LU"],["MO","MAC","446","ISO 3166-2:MO"],["MK","MKD","807","ISO 3166-2:MK"],["MG","MDG","450","ISO 3166-2:MG"],["MW","MWI","454","ISO 3166-2:MW"],["MY","MYS","458","ISO 3166-2:MY"],["MV","MDV","462","ISO 3166-2:MV"],["ML","MLI","466","ISO 3166-2:ML"],["MT","MLT","470","ISO 3166-2:MT"],["MH","MHL","584","ISO 3166-2:MH"],["MQ","MTQ","474","ISO 3166-2:MQ"],["MR","MRT","478","ISO 3166-2:MR"],["MU","MUS","480","ISO 3166-2:MU"],["YT","MYT","175","ISO 3166-2:YT"],["MX","MEX","484","ISO 3166-2:MX"],["FM","FSM","583","ISO 3166-2:FM"],["MD","MDA","498","ISO 3166-2:MD"],["MC","MCO","492","ISO 3166-2:MC"],["MN","MNG","496","ISO 3166-2:MN"],["ME","MNE","499","ISO 3166-2:ME"],["MS","MSR","500","ISO 3166-2:MS"],["MA","MAR","504","ISO 3166-2:MA"],["MZ","MOZ","508","ISO 3166-2:MZ"],["MM","MMR","104","ISO 3166-2:MM"],["NA","NAM","516","ISO 3166-2:NA"],["NR","NRU","520","ISO 3166-2:NR"],["NP","NPL","524","ISO 3166-2:NP"],["NL","NLD","528","ISO 3166-2:NL"],["NC","NCL","540","ISO 3166-2:NC"],["NZ","NZL","554","ISO 3166-2:NZ"],["NI","NIC","558","ISO 3166-2:NI"],["NE","NER","562","ISO 3166-2:NE"],["NG","NGA","566","ISO 3166-2:NG"],["NU","NIU","570","ISO 3166-2:NU"],["NF","NFK","574","ISO 3166-2:NF"],["MP","MNP","580","ISO 3166-2:MP"],["NO","NOR","578","ISO 3166-2:NO"],["OM","OMN","512","ISO 3166-2:OM"],["PK","PAK","586","ISO 3166-2:PK"],["PW","PLW","585","ISO 3166-2:PW"],["PS","PSE","275","ISO 3166-2:PS"],["PA","PAN","591","ISO 3166-2:PA"],["PG","PNG","598","ISO 3166-2:PG"],["PY","PRY","600","ISO 3166-2:PY"],["PE","PER","604","ISO 3166-2:PE"],["PH","PHL","608","ISO 3166-2:PH"],["PN","PCN","612","ISO 3166-2:PN"],["PL","POL","616","ISO 3166-2:PL"],["PT","PRT","620","ISO 3166-2:PT"],["PR","PRI","630","ISO 3166-2:PR"],["QA","QAT","634","ISO 3166-2:QA"],["RE","REU","638","ISO 3166-2:RE"],["RO","ROU","642","ISO 3166-2:RO"],["RU","RUS","643","ISO 3166-2:RU"],["RW","RWA","646","ISO 3166-2:RW"],["BL","BLM","652","ISO 3166-2:BL"],["SH","SHN","654","ISO 3166-2:SH"],["KN","KNA","659","ISO 3166-2:KN"],["LC","LCA","662","ISO 3166-2:LC"],["MF","MAF","663","ISO 3166-2:MF"],["PM","SPM","666","ISO 3166-2:PM"],["VC","VCT","670","ISO 3166-2:VC"],["WS","WSM","882","ISO 3166-2:WS"],["SM","SMR","674","ISO 3166-2:SM"],["ST","STP","678","ISO 3166-2:ST"],["SA","SAU","682","ISO 3166-2:SA"],["SN","SEN","686","ISO 3166-2:SN"],["RS","SRB","688","ISO 3166-2:RS"],["SC","SYC","690","ISO 3166-2:SC"],["SL","SLE","694","ISO 3166-2:SL"],["SG","SGP","702","ISO 3166-2:SG"],["SX","SXM","534","ISO 3166-2:SX"],["SK","SVK","703","ISO 3166-2:SK"],["SI","SVN","705","ISO 3166-2:SI"],["SB","SLB","090","ISO 3166-2:SB"],["SO","SOM","706","ISO 3166-2:SO"],["ZA","ZAF","710","ISO 3166-2:ZA"],["GS","SGS","239","ISO 3166-2:GS"],["SS","SSD","728","ISO 3166-2:SS"],["ES","ESP","724","ISO 3166-2:ES"],["LK","LKA","144","ISO 3166-2:LK"],["SD","SDN","729","ISO 3166-2:SD"],["SR","SUR","740","ISO 3166-2:SR"],["SJ","SJM","744","ISO 3166-2:SJ"],["SZ","SWZ","748","ISO 3166-2:SZ"],["SE","SWE","752","ISO 3166-2:SE"],["CH","CHE","756","ISO 3166-2:CH"],["SY","SYR","760","ISO 3166-2:SY"],["TW","TWN","158","ISO 3166-2:TW"],["TJ","TJK","762","ISO 3166-2:TJ"],["TZ","TZA","834","ISO 3166-2:TZ"],["TH","THA","764","ISO 3166-2:TH"],["TL","TLS","626","ISO 3166-2:TL"],["TG","TGO","768","ISO 3166-2:TG"],["TK","TKL","772","ISO 3166-2:TK"],["TO","TON","776","ISO 3166-2:TO"],["TT","TTO","780","ISO 3166-2:TT"],["TN","TUN","788","ISO 3166-2:TN"],["TR","TUR","792","ISO 3166-2:TR"],["TM","TKM","795","ISO 3166-2:TM"],["TC","TCA","796","ISO 3166-2:TC"],["TV","TUV","798","ISO 3166-2:TV"],["UG","UGA","800","ISO 3166-2:UG"],["UA","UKR","804","ISO 3166-2:UA"],["AE","ARE","784","ISO 3166-2:AE"],["GB","GBR","826","ISO 3166-2:GB"],["US","USA","840","ISO 3166-2:US"],["UM","UMI","581","ISO 3166-2:UM"],["UY","URY","858","ISO 3166-2:UY"],["UZ","UZB","860","ISO 3166-2:UZ"],["VU","VUT","548","ISO 3166-2:VU"],["VE","VEN","862","ISO 3166-2:VE"],["VN","VNM","704","ISO 3166-2:VN"],["VG","VGB","092","ISO 3166-2:VG"],["VI","VIR","850","ISO 3166-2:VI"],["WF","WLF","876","ISO 3166-2:WF"],["EH","ESH","732","ISO 3166-2:EH"],["YE","YEM","887","ISO 3166-2:YE"],["ZM","ZMB","894","ISO 3166-2:ZM"],["ZW","ZWE","716","ISO 3166-2:ZW"],["XK","XKX","","ISO 3166-2:XK"]]

/***/ }),
/* 164 */,
/* 165 */
/***/ (function(module, exports) {

module.exports = {"locale":"de","countries":{"AF":"Afghanistan","EG":"Ägypten","AX":"Åland","AL":"Albanien","DZ":"Algerien","AS":"Amerikanisch-Samoa","VI":"Amerikanische Jungferninseln","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarktika","AG":"Antigua und Barbuda","GQ":"Äquatorialguinea","AR":"Argentinien","AM":"Armenien","AW":"Aruba","AZ":"Aserbaidschan","ET":"Äthiopien","AU":"Australien","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesch","BB":"Barbados","BY":"Weißrussland","BE":"Belgien","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivien","BQ":"Bonaire","BA":"Bosnien und Herzegowina","BW":"Botswana","BV":"Bouvetinsel","BR":"Brasilien","VG":"Britische Jungferninseln","IO":"Britisches Territorium im Indischen Ozean","BN":"Brunei Darussalam","BG":"Bulgarien","BF":"Burkina Faso","BI":"Burundi","CL":"Chile","CN":"China","CK":"Cookinseln","CR":"Costa Rica","CI":"Elfenbeinküste","CW":"Curaçao","DK":"Dänemark","DE":"Deutschland","DM":"Dominica","DO":"Dominikanische Republik","DJ":"Dschibuti","EC":"Ecuador","SV":"El Salvador","ER":"Eritrea","EE":"Estland","FK":"Falklandinseln","FO":"Färöer","FJ":"Fidschi","FI":"Finnland","FR":"Frankreich","GF":"Französisch-Guayana","PF":"Französisch-Polynesien","TF":"Französische Süd- und Antarktisgebiete","GA":"Gabun","GM":"Gambia","GE":"Georgien","GH":"Ghana","GI":"Gibraltar","GD":"Grenada","GR":"Griechenland","GL":"Grönland","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard und McDonaldinseln","HN":"Honduras","HK":"Hongkong","IN":"Indien","ID":"Indonesien","IM":"Insel Man","IQ":"Irak","IR":"Iran","IE":"Irland","IS":"Island","IL":"Israel","IT":"Italien","JM":"Jamaika","JP":"Japan","YE":"Jemen","JE":"Jersey","JO":"Jordanien","KY":"Kaimaninseln","KH":"Kambodscha","CM":"Kamerun","CA":"Kanada","CV":"Kap Verde","KZ":"Kasachstan","QA":"Katar","KE":"Kenia","KG":"Kirgisistan","KI":"Kiribati","CC":"Kokosinseln","CO":"Kolumbien","KM":"Komoren","CD":"Kongo","KP":"Nordkorea","KR":"Südkorea","HR":"Kroatien","CU":"Kuba","KW":"Kuwait","LA":"Laos","LS":"Lesotho","LV":"Lettland","LB":"Libanon","LR":"Liberia","LY":"Libyen","LI":"Liechtenstein","LT":"Litauen","LU":"Luxemburg","MO":"Macao","MG":"Madagaskar","MW":"Malawi","MY":"Malaysia","MV":"Malediven","ML":"Mali","MT":"Malta","MA":"Marokko","MH":"Marshallinseln","MQ":"Martinique","MR":"Mauretanien","MU":"Mauritius","YT":"Mayotte","MK":"Mazedonien","MX":"Mexiko","FM":"Mikronesien","MD":"Moldawien","MC":"Monaco","MN":"Mongolei","ME":"Montenegro","MS":"Montserrat","MZ":"Mosambik","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NC":"Neukaledonien","NZ":"Neuseeland","NI":"Nicaragua","NL":"Niederlande","NE":"Niger","NG":"Nigeria","NU":"Niue","MP":"Nördliche Marianen","NF":"Norfolkinsel","NO":"Norwegen","OM":"Oman","AT":"Österreich","TL":"Osttimor","PK":"Pakistan","PS":"Staat Palästina","PW":"Palau","PA":"Panama","PG":"Papua-Neuguinea","PY":"Paraguay","PE":"Peru","PH":"Philippinen","PN":"Pitcairninseln","PL":"Polen","PT":"Portugal","PR":"Puerto Rico","TW":"Taiwan","CG":"Republik Kongo","RE":"Réunion","RW":"Ruanda","RO":"Rumänien","RU":"Russische Föderation","BL":"Saint-Barthélemy","MF":"Saint-Martin","SB":"Salomonen","ZM":"Sambia","WS":"Samoa","SM":"San Marino","ST":"São Tomé und Príncipe","SA":"Saudi-Arabien","SE":"Schweden","CH":"Schweiz","SN":"Senegal","RS":"Serbien","SC":"Seychellen","SL":"Sierra Leone","ZW":"Simbabwe","SG":"Singapur","SX":"Sint Maarten","SK":"Slowakei","SI":"Slowenien","SO":"Somalia","ES":"Spanien","LK":"Sri Lanka","SH":"St. Helena","KN":"St. Kitts und Nevis","LC":"St. Lucia","PM":"Saint-Pierre und Miquelon","VC":"St. Vincent und die Grenadinen","ZA":"Südafrika","SD":"Sudan","GS":"Südgeorgien und die Südlichen Sandwichinseln","SS":"Südsudan","SR":"Suriname","SJ":"Svalbard und Jan Mayen","SZ":"Swasiland","SY":"Syrien, Arabische Republik","TJ":"Tadschikistan","TZ":"Tansania, Vereinigte Republik","TH":"Thailand","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad und Tobago","TD":"Tschad","CZ":"Tschechische Republik","TN":"Tunesien","TR":"Türkei","TM":"Turkmenistan","TC":"Turks- und Caicosinseln","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","HU":"Ungarn","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Usbekistan","VU":"Vanuatu","VA":"Vatikanstadt","VE":"Venezuela","AE":"Vereinigte Arabische Emirate","US":"Vereinigte Staaten von Amerika","GB":"Vereinigtes Königreich Großbritannien und Nordirland","VN":"Vietnam","WF":"Wallis und Futuna","CX":"Weihnachtsinsel","EH":"Westsahara","CF":"Zentralafrikanische Republik","CY":"Zypern","XK":"Kosovo"}}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = {"locale":"en","countries":{"AF":"Afghanistan","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo","CD":"Congo, the Democratic Republic of the","CK":"Cook Islands","CR":"Costa Rica","CI":"Cote D'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and Mcdonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic of","IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"North Korea","KR":"South Korea","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People's Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libyan Arab Jamahiriya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, the Former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestinian Territory, Occupied","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States of America","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Viet Nam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe","AX":"Åland Islands","BQ":"Bonaire, Sint Eustatius and Saba","CW":"Curaçao","GG":"Guernsey","IM":"Isle of Man","JE":"Jersey","ME":"Montenegro","BL":"Saint Barthélemy","MF":"Saint Martin (French part)","RS":"Serbia","SX":"Sint Maarten (Dutch part)","SS":"South Sudan","XK":"Kosovo"}}

/***/ }),
/* 167 */,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(154)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(180),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3379ba60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(185),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e5238e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(153)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2736e9ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(186),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8fa0b030",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(189),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d14eb2ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(188),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(156)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(182),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c741600",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(184),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77fd09d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(187),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(155)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(181),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-390e068e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-default mb-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('p'), (_vm.formSubmitted && (!_vm.formValid || _vm.changePasswordError || !_vm.passwordIsStrong)) ? _c('div', {
    staticClass: "card",
    attrs: {
      "id": "feedbackPanel"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [(!_vm.passwordFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.OLD_PASSWORD_FIELD_REQUIRED) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.passwordIsStrong) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_STREIGHT_ERROR) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.newPasswordFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_FIELD_REQUIRED) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.passwordConfirmValid) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASS_DO_NOT_MATCH) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.changeAvailable) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.CHANGE_DENIED_TEXT) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.changePasswordError) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_CHANGE_ERROR) + "\n                    ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(!!this.id ? this.id : this.$session.get('user').Name))]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "id1",
      "method": "post",
      "name": "CredentialsForm",
      "action": ""
    }
  }, [_vm._m(1), _vm._v(" "), (this.id == null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "j_oldPassword"
    }
  }, [_vm._v(_vm._s(_vm.labels.OLD_PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.Password),
      expression: "credentials.Password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "login",
      "type": "password",
      "value": "",
      "name": "oldPassword",
      "maxlength": "300"
    },
    domProps: {
      "value": (_vm.credentials.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.Password = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.labels.NEW_PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.NewPassword),
      expression: "credentials.NewPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "size": "15",
      "value": "",
      "name": "password",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.credentials.NewPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.NewPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password-hint"
  }, [_c('h4', [_vm._v(_vm._s(_vm.labels.PASSWORD_REQUIREMENTS_TEXT))]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isLowercase, 'invalid': _vm.startPasswordCheck && !_vm.isLowercase
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.LOWERCASE_LETTER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isUppercase, 'invalid': _vm.startPasswordCheck && !_vm.isUppercase
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.UPPERCASE_LETTER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isNumber, 'invalid': _vm.startPasswordCheck && !_vm.isNumber
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.NUMBER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isSpecial, 'invalid': _vm.startPasswordCheck && !_vm.isSpecial
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.SPECIAL_SYMBOL_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isLong, 'invalid': _vm.startPasswordCheck && !_vm.isLong
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_LENGTH_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isRestricted, 'invalid': _vm.startPasswordCheck && !_vm.isRestricted
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_RESTRICTION_TEXT) + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.labels.CONFIRM_PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PasswordConfirm),
      expression: "PasswordConfirm"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "newPassword",
      "type": "password",
      "size": "15",
      "value": "",
      "name": "newPassword",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.PasswordConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PasswordConfirm = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group button-start"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "saveButton"
    },
    on: {
      "click": _vm.proceed
    }
  }, [_vm._v(_vm._s(_vm.labels.SAVE))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "cancelButton"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.labels.CANCEL))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-4"
  }, [_c('a', {
    attrs: {
      "href": "mailto:web.helpdesk@mm.group"
    }
  }, [_vm._v(_vm._s(_vm.labels.HELP))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center text-gray-light my-4"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-72 mmk-icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "position": "absolute",
      "left": "-100px",
      "top": "-100px",
      "overflow": "hidden"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "id1_hf_0",
      "id": "id1_hf_0"
    }
  })])
}]}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "card card-indent mt-2"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row bg-primary-light"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "text-weight-normal mb-2"
  }, [_vm._v(_vm._s(_vm.labels.MMID_CHANGE_PASSWORD))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('p'), (_vm.formSubmitted && (!_vm.formValid || _vm.changePasswordError || _vm.errorAfterRequest)) ? _c('div', {
    staticClass: "feedback",
    attrs: {
      "id": "feedbackPanel"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [(!_vm.oldPasswordFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.OLD_PASSWORD_REQUIRED) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.passwordFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_FIELD_REQUIRED) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.passwordIsStrong) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_STREIGHT_ERROR) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.passwordConfirmValid) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASS_DO_NOT_MATCH) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.changePasswordError) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_CHANGE_ERROR) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.errorAfterRequest) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.errorAfterRequest) + "\n                    ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: " alert alert-success alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.labels.SUCCESS_TEXT) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.credentials.UserName))]), _vm._v(" "), (!_vm.success) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels.OLD_PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.OldPassword),
      expression: "credentials.OldPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "size": "15",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.credentials.OldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.OldPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels.PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.Password),
      expression: "credentials.Password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "maxlength": "300"
    },
    domProps: {
      "value": (_vm.credentials.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.Password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password-hint"
  }, [_c('h4', [_vm._v(_vm._s(_vm.labels.PASSWORD_REQUIREMENTS_TEXT))]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isLowercase, 'invalid': _vm.startPasswordCheck && !_vm.isLowercase
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.LOWERCASE_LETTER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isUppercase, 'invalid': _vm.startPasswordCheck && !_vm.isUppercase
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.UPPERCASE_LETTER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isNumber, 'invalid': _vm.startPasswordCheck && !_vm.isNumber
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.NUMBER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isSpecial, 'invalid': _vm.startPasswordCheck && !_vm.isSpecial
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.SPECIAL_SYMBOL_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isLong, 'invalid': _vm.startPasswordCheck && !_vm.isLong
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_LENGTH_TEXT) + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels.CONFIRM_PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PasswordConfirm),
      expression: "PasswordConfirm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "size": "15",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.PasswordConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PasswordConfirm = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group button-start"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "saveButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePassword($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SAVE))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "cancelButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.CANCEL))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-4"
  }, [_c('a', {
    attrs: {
      "href": "mailto:web.helpdesk@mm.group"
    }
  }, [_vm._v(_vm._s(_vm.labels.HELP))])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center text-gray-light my-4"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-72 mmk-icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('center', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "loading": _vm.showEmailSpinner,
      "color": "#aab0b3"
    }
  }), _vm._v(" "), (_vm.showEmailSpinner) ? _c('p', [_vm._v(_vm._s(_vm.labels.GENERATING_EMAIL))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-header"
  }, [_c('button', {
    staticClass: "filter-toggler btn btn-transparent btn-size-32 active",
    attrs: {
      "title": _vm.isFiltersActive ? _vm.labels.CLOSE_FILTER : _vm.labels.OPEN_FILTER,
      "type": "button"
    },
    on: {
      "click": _vm.toogleFilters
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-filter-o"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-link btn-reset pull-right",
    attrs: {
      "title": _vm.labels.RESET_ALL_FILTERS,
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetFilters($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.RESET))]), _vm._v(" "), _c('span', {
    staticClass: "filter-search-icon mmk-icon mmk-icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quickSearchText),
      expression: "quickSearchText"
    }],
    staticClass: "search pull-left noCommitOnEnter",
    attrs: {
      "placeholder": _vm.labels.SEARCH,
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.quickSearchText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.makeSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quickSearchText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasQuickSearch) ? _c('button', {
    staticClass: "btn btn-transparent btn-size-16 btn-clear",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetQuickSearch
    }
  }, [_vm._v("x")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "filter-body small"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "filter-category"
  }, [_c('div', {
    staticClass: "panel-collapse collapse in"
  }, [_c('div', {
    staticClass: "filter-category-body small"
  }, [_c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.languageOptions,
      "label": "code",
      "placeholder": _vm.labels.LANGUAGE
    },
    model: {
      value: (_vm.languageFilterValue),
      callback: function($$v) {
        _vm.languageFilterValue = $$v
      },
      expression: "languageFilterValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.userStatusOptions,
      "placeholder": _vm.labels.STATUS
    },
    model: {
      value: (_vm.userStatusValue),
      callback: function($$v) {
        _vm.userStatusValue = $$v
      },
      expression: "userStatusValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.groupsFilterOptions,
      "placeholder": _vm.labels.GROUPS
    },
    model: {
      value: (_vm.groupsFilterValue),
      callback: function($$v) {
        _vm.groupsFilterValue = $$v
      },
      expression: "groupsFilterValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper",
    staticStyle: {
      "margin-bottom": "4px"
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.userImplementOptions,
      "placeholder": _vm.labels.OU
    },
    model: {
      value: (_vm.userImplementationValue),
      callback: function($$v) {
        _vm.userImplementationValue = $$v
      },
      expression: "userImplementationValue"
    }
  })], 1), _vm._v(" "), (_vm.userImplementationValue.length == 0) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.labels.REQUIRED))]) : _vm._e()]), _vm._v(" "), (_vm.isCurrentUserMMPWM) ? _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.mmpwmLocations,
      "placeholder": _vm.labels.PHYSICAL_LOCATION,
      "disabled": _vm.userImplementationValue.length == 0 || _vm.userImplementationValue[0].value != 'mmpwm'
    },
    model: {
      value: (_vm.physicalLocation),
      callback: function($$v) {
        _vm.physicalLocation = $$v
      },
      expression: "physicalLocation"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserMMPWM_Admin && _vm.userImplementationValue.length > 0 && _vm.userImplementationValue[0].value == 'mmpwm') ? _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.userTypes,
      "placeholder": _vm.labels.USER_TYPE
    },
    model: {
      value: (_vm.userType),
      callback: function($$v) {
        _vm.userType = $$v
      },
      expression: "userType"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('a', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "href": "#",
      "disabled": _vm.userImplementationValue.length == 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.makeSearch($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEARCH))])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "records",
    attrs: {
      "infinite-scroll-disabled": "loadMoreBusy",
      "infinite-scroll-distance": "10"
    }
  }, [_c('div', {
    staticClass: "sticky-box"
  }, [_c('div', {
    staticClass: "records-header"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-transparent btn-size-24 btn-circle mr-1",
    attrs: {
      "title": _vm.fullView ? _vm.labels.SHOW_LESS : _vm.labels.SHOW_ALL_DETAILS,
      "type": "button"
    },
    on: {
      "click": _vm.toggleUserView
    }
  }, [_c('i', {
    staticClass: "mmk-icon",
    class: {
      'mmk-icon-unfold-less': _vm.fullView, 'mmk-icon-unfold-more': !_vm.fullView
    }
  })]), _vm._v(" "), (_vm.isCurrentUserAdmin) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('a', {
    staticClass: "btn min-width-96 btn-primary",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.labels.CREATE))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createDigiUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.DIGICREATE))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createSharePointUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.EXTRANETCREATE))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createMMPDigiUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.MMPCREATE))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_c('span', [_c('strong', {
    staticClass: "text-info"
  }, [_vm._v(_vm._s(_vm.filteredUsersCount))]), _vm._v(" of " + _vm._s(_vm.totalUsersCount) + " "), (_vm.userImplementationValue.length == 1) ? _c('span', [_vm._v("(" + _vm._s(_vm.userImplementationValue[0].label) + ")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortBy),
      expression: "sortBy"
    }],
    staticClass: "form-control input-sm",
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sortBy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "LastName"
    }
  }, [_vm._v(_vm._s(_vm.labels.SORT_BY_LASTNAME))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FirstName"
    }
  }, [_vm._v(_vm._s(_vm.labels.SORT_BY_FIRSTNAME))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Email"
    }
  }, [_vm._v(_vm._s(_vm.labels.SORT_BY_EMAIL))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Enabled"
    }
  }, [_vm._v(_vm._s(_vm.labels.SORT_BY_STATUS))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AccountName"
    }
  }, [_vm._v(_vm._s(_vm.labels.SORT_BY_ACCOUNT_NAME))])]), _vm._v(" "), _c('a', {
    staticClass: "mmk-icon ml-1",
    class: {
      'mmk-icon-sort-asc': _vm.sortOrder, 'mmk-icon-sort-desc': !_vm.sortOrder
    },
    attrs: {
      "title": _vm.sortOrder ? _vm.labels.ASCENDING : _vm.labels.DESCENDING,
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toogleSortOrder($event)
      }
    }
  })])])])]), _vm._v(" "), (_vm.loadFlags.settings && _vm.loadFlags.users) ? _c('div', {
    staticClass: "records-body"
  }, _vm._l((_vm.users), function(user, index) {
    return _c('div', {
      staticClass: "record-item card card-compressed"
    }, [_c('span', [_c('div', {
      staticClass: "card-body"
    }, [(user.IsActive) ? _c('div', {
      staticClass: "card-label card-label-success"
    }, [_vm._v(_vm._s(_vm.labels.ACTIVE))]) : _vm._e(), _vm._v(" "), (!user.IsActive) ? _c('div', {
      staticClass: "card-label card-label-default"
    }, [_vm._v(_vm._s(_vm.labels.INACTIVE))]) : _vm._e(), _vm._v(" "), (user.Locked) ? _c('div', {
      staticClass: "card-label card-label-warning"
    }, [_vm._v(_vm._s(_vm.labels.LOCKED))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "record-actions pull-left"
    }, [_c('button', {
      staticClass: "btn btn-transparent btn-size-24 btn-circle",
      class: {
        'collapsed': !user.viewModel.fullView
      },
      attrs: {
        "title": user.viewModel.fullView ? _vm.labels.SHOW_LESS : _vm.labels.SHOW_ALL_DETAILS,
        "type": "button"
      },
      on: {
        "click": function($event) {
          user.viewModel.fullView = !user.viewModel.fullView
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-chevron-bottom"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "record-content"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2 break-all"
    }, [_c('b', [_c('span', [_vm._v(_vm._s(user.LastName))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 break-all"
    }, [_c('b', [_c('span', [_vm._v(_vm._s(user.FirstName))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 break-all"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + user.Email
      }
    }, [_vm._v(_vm._s(user.Email))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 break-all"
    }, [_c('span', [_vm._v(_vm._s(user.Domain) + "\\" + _vm._s(user.AccountName))])]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 text-right"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('a', {
      staticClass: "btn min-width-96 btn-primary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editUser(user)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.EDIT))]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu"
    }, [(_vm.isCurrentUserMMPWM && user.Locked && user.ExtensionAttribute6 === '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.unlockUser(user)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.UNLOCK))])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserMMPWM && user.ExtensionAttribute6 === '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setPassword(user)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SET_PASSWORD))])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && !user.IsActive && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.activateUser(user, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.ACTIVATE))])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.IsActive && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deactivateUser(user, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.DEACTIVATE))])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'MMID')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_DIGI))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'MMID')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'MMID', true)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_DIGI_NO_PASS))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'MMID', true)
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasMMPDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'MMPDigi')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_MMP))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'MMPDigi')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasMMPDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'MMPDigi', true)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_MMP_NO_PASS))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'MMPDigi', true)
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasSharePointGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'Sharepoint')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_EXTRANET))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'Sharepoint')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasSharePointGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'Sharepoint', true)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_EXTRANET_NO_PASS))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'Sharepoint', true)
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.IsActive && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendForgotPasswordEmail(user, 'None')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_GENERIC))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getForgotPasswordEmailPreview(user, 'None')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.IsActive && user.HasDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendForgotPasswordEmail(user, 'MMID')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_DIGI))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getForgotPasswordEmailPreview(user, 'MMID')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.IsActive && user.HasMMPDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendForgotPasswordEmail(user, 'MMPDigi')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_MMP))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getForgotPasswordEmailPreview(user, 'MMPDigi')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.IsActive && user.HasSharePointGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendForgotPasswordEmail(user, 'Sharepoint')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_EXTRANET))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getForgotPasswordEmailPreview(user, 'Sharepoint')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()])])])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fadeHeight"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.viewModel.fullView),
        expression: "user.viewModel.fullView"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "user-details col-md-12"
    }, [_c('div', {
      staticClass: "row headers"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_vm._v(_vm._s(_vm.labels.ORGANIZATION_UNIT))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_vm._v(_vm._s(_vm.labels.GROUPS))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_vm._v(_vm._s(_vm.labels.COMPANY))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3 cell"
    }, [_vm._v(_vm._s(user.OrganizationUnit))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 cell"
    }, _vm._l((user.Groups), function(item) {
      return _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])
    })), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 cell"
    }, [_vm._v(_vm._s(user.Company))])]), _vm._v(" "), _c('div', {
      staticClass: "row headers",
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_vm._v(_vm._s(_vm.labels.USER_TYPE))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9"
    }, [_vm._v(_vm._s(_vm.labels.CANONICAL_NAME))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_vm._v(_vm._s(user.ExtensionAttribute6))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9",
      staticStyle: {
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(user.CanonicalName))])])])])])], 1)])])])
  })) : _vm._e(), _vm._v(" "), _c('center', [_c('pulse-loader', {
    attrs: {
      "loading": _vm.showSpinner,
      "color": "#aab0b3"
    }
  })], 1), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "400",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.searchUsed) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.labels.LIST_END))]) : _vm._e(), _vm._v(" "), (!_vm.searchUsed) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.labels.APPLY_FILTER_FOR_USERS))]) : _vm._e()], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "height": "auto",
      "scrollable": true,
      "width": "650px"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-chevron-bottom",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "orange"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-chevron-bottom",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  })])
}]}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "card card-indent mt-2"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row bg-primary-light"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "text-weight-normal mb-2"
  }, [_vm._v(_vm._s(_vm.isExpired ? _vm.labels.HEADING_EXPIRED : _vm.labels.HEADING))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('p'), (_vm.formSubmitted && (!_vm.formValid)) ? _c('div', {
    staticClass: "feedback",
    attrs: {
      "id": "feedbackPanel"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [(!_vm.loginFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.LOGIN_FIELD_REQUIRED) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.loginValid) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.CHANGE_DENIED_TEXT) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.isEmail) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.LOGIN_FAIL) + "\n                    ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: " alert alert-success alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.labels.SUCCESS_TEXT) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.forbidden) ? _c('div', {
    staticClass: " alert alert-danger alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.labels.PASSWORD_RESET_TOO_OFTEN) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.failed) ? _c('div', {
    staticClass: " alert alert-danger alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.labels.RESET_FAILED) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isExpired && !_vm.success) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.labels.LINK_EXPIRED) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.success) ? _c('form', {
    attrs: {
      "id": "id1",
      "method": "post",
      "name": "CredentialsForm",
      "action": ""
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "j_username"
    }
  }, [_vm._v(_vm._s(_vm.labels.USER))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.UserName),
      expression: "credentials.UserName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "login",
      "type": "text",
      "value": "",
      "name": "user",
      "maxlength": "300"
    },
    domProps: {
      "value": (_vm.credentials.UserName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.UserName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group button-start"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "saveButton"
    },
    on: {
      "click": _vm.proceed
    }
  }, [_vm._v(_vm._s(_vm.isExpired ? _vm.labels.SAVE_EXPIRED : _vm.labels.SAVE))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "cancelButton"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.labels.CANCEL))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-4"
  }, [_c('a', {
    attrs: {
      "href": "mailto:web.helpdesk@mm.group"
    }
  }, [_vm._v(_vm._s(_vm.labels.HELP))])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center text-gray-light my-4"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-72 mmk-icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "position": "absolute",
      "left": "-100px",
      "top": "-100px",
      "overflow": "hidden"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "id1_hf_0",
      "id": "id1_hf_0"
    }
  })])
}]}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-pulse v-pulse1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-pulse v-pulse2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-pulse v-pulse3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  })])
},staticRenderFns: []}

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "card card-indent mt-2"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row bg-primary-light"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "text-weight-normal mb-2"
  }, [_vm._v(_vm._s(_vm.labels.HEADING))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('p'), (_vm.formSubmitted && (!_vm.formValid || _vm.loginFailed || _vm.user601)) ? _c('div', {
    staticClass: "feedback",
    attrs: {
      "id": "feedbackPanel"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [(!_vm.loginFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("                        \n                        " + _vm._s(_vm.labels.LOGIN_FIELD_REQUIRED) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (!_vm.passwordFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                        " + _vm._s(_vm.labels.PASSWORD_FIELD_REQUIRED) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.loginFailed) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                        " + _vm._s(_vm.labels.LOGIN_FAIL) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (!_vm.loginValid || _vm.user601) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                        " + _vm._s(_vm.labels.CHANGE_DENIED_TEXT) + "\n                      ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "id": "id1",
      "method": "post",
      "name": "CredentialsForm",
      "action": ""
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "j_username"
    }
  }, [_vm._v(_vm._s(_vm.labels.USER))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.UserName),
      expression: "credentials.UserName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "login",
      "type": "text",
      "value": "",
      "name": "login",
      "maxlength": "300"
    },
    domProps: {
      "value": (_vm.credentials.UserName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.UserName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.labels.PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.Password),
      expression: "credentials.Password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "size": "15",
      "value": "",
      "name": "password",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.credentials.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.Password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('center', [_c('pulse-loader', {
    attrs: {
      "loading": _vm.showSpinner,
      "color": "#aab0b3"
    }
  })], 1), _vm._v(" "), (!_vm.showSpinner) ? _c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "loginButton",
      "id": "id2"
    },
    on: {
      "click": _vm.proceed
    }
  }, [_vm._v(_vm._s(_vm.labels.LOGIN))]) : _vm._e()], 1), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "not-implemented",
    attrs: {
      "href": "#",
      "title": "Forgot Password"
    },
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v(_vm._s(_vm.labels.FORGOT_PASSWORD))])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "not-implemented",
    attrs: {
      "href": "#",
      "title": "Sign in with a different account"
    }
  }, [_vm._v(_vm._s(_vm.labels.DIFFERENT_ACCOUNT))])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center text-gray-light my-4"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-72 mmk-icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "position": "absolute",
      "left": "-100px",
      "top": "-100px",
      "overflow": "hidden"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "id1_hf_0",
      "id": "id1_hf_0"
    }
  })])
}]}

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "card card-indent mt-2"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row bg-primary-light"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "text-weight-normal mb-2"
  }, [_vm._v(_vm._s(_vm.labels.HEADING))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "my-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('p'), (_vm.formSubmitted && (!_vm.formValid || _vm.changePasswordError)) ? _c('div', {
    staticClass: "feedback",
    attrs: {
      "id": "feedbackPanel"
    }
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [(!_vm.passwordFilled) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_FIELD_REQUIRED) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.passwordIsStrong) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_STREIGHT_ERROR) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (!_vm.passwordConfirmValid) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASS_DO_NOT_MATCH) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.changePasswordError && !_vm.linkExpired) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_CHANGE_ERROR) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.linkExpired) ? _c('li', [_c('div', {
    staticClass: "errorlevel alert alert-danger alert-dismissible"
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_CHANGE_LINK_EXPIRED) + "\n                    ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: " alert alert-success alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.labels.SUCCESS_TEXT) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), (!_vm.isChangePasswordAllowed) ? _c('p') : _vm._e(), (!_vm.isChangePasswordAllowed) ? _c('div', {
    staticClass: " alert alert-danger alert-dismissible"
  }, [_vm._v("\n                " + _vm._s(_vm.labels.PASSWORD_WAS_SET) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.success && _vm.isChangePasswordAllowed) ? _c('form', {
    attrs: {
      "id": "id1",
      "method": "post",
      "name": "CredentialsForm",
      "action": ""
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "j_oldPassword"
    }
  }, [_vm._v(_vm._s(_vm.labels.PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.Password),
      expression: "credentials.Password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "value": "",
      "name": "pasword",
      "maxlength": "300"
    },
    domProps: {
      "value": (_vm.credentials.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credentials.Password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "password-hint"
  }, [_c('h4', [_vm._v(_vm._s(_vm.labels.PASSWORD_REQUIREMENTS_TEXT))]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isLowercase, 'invalid': _vm.startPasswordCheck && !_vm.isLowercase
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.LOWERCASE_LETTER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isUppercase, 'invalid': _vm.startPasswordCheck && !_vm.isUppercase
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.UPPERCASE_LETTER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isNumber, 'invalid': _vm.startPasswordCheck && !_vm.isNumber
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.NUMBER_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isSpecial, 'invalid': _vm.startPasswordCheck && !_vm.isSpecial
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.SPECIAL_SYMBOL_TEXT) + "\n                    ")]), _vm._v(" "), _c('li', {
    staticClass: "neutral",
    class: {
      'valid': _vm.startPasswordCheck && _vm.isLong, 'invalid': _vm.startPasswordCheck && !_vm.isLong
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.labels.PASSWORD_LENGTH_TEXT) + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.labels.CONFIRM_PASSWORD))]), _vm._v(" "), _c('div', {
    staticClass: "select2-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PasswordConfirm),
      expression: "PasswordConfirm"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "passwordConfirm",
      "type": "password",
      "size": "15",
      "value": "",
      "name": "passwordConfirm",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.PasswordConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PasswordConfirm = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group button-start"
  }, [(!_vm.linkExpired) ? _c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "saveButton"
    },
    on: {
      "click": _vm.createPassword
    }
  }, [_vm._v(_vm._s(_vm.labels.SAVE))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "name": "cancelButton"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.labels.CANCEL))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-4"
  }, [_c('a', {
    attrs: {
      "href": "mailto:web.helpdesk@mm.group"
    }
  }, [_vm._v(_vm._s(_vm.labels.HELP))])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center text-gray-light my-4"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-72 mmk-icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "position": "absolute",
      "left": "-100px",
      "top": "-100px",
      "overflow": "hidden"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "id1_hf_0",
      "id": "id1_hf_0"
    }
  })])
}]}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "categoryOverview"
    }
  }, [_c('div', {
    staticClass: "card card-default mb-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h2', {
    staticClass: "mt-0 strong"
  }, [_vm._v(_vm._s(_vm.labels.MY_APPLICATION_TEXT))]), _vm._v(" "), _c('div', {
    staticClass: "product-categories stretch-boxes"
  }, [_c('div', {
    staticClass: "flex-row"
  }, [(_vm.isCurrentUserAdmin || _vm.isCurrentUserMMPWM || _vm.userHasDigi()) ? _c('div', {
    staticClass: "flex-col"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "background-image": "url(./././static/img/mmk_karton_bg.png)",
      "background-position": "top left",
      "background-size": "contain"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body small"
  }, [_vm._v("\n                        MM Digital platform\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "margin-bottom4"
  }, [_vm._v("Links:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline"
  }, _vm._l((_vm.dashBoardDigiLinks), function(link) {
    return (_vm.isCurrentUserAdmin || _vm.isCurrentUserMMPWM || _vm.userInGroup(link.Group)) ? _c('li', [_c('a', {
      staticClass: "underlined",
      attrs: {
        "href": link.Url
      }
    }, [_c('span', [_vm._v(_vm._s(link.Title))])])]) : _vm._e()
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin || _vm.isCurrentUserMMPWM || _vm.userHasMMPDigi()) ? _c('div', {
    staticClass: "flex-col"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "background-image": "url(./././static/img/mmk_karton_bg.png)",
      "background-position": "top left",
      "background-size": "contain"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body small"
  }, [_vm._v("\n                        MMP Digital platform\n                     ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "margin-bottom4"
  }, [_vm._v("Links:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline"
  }, _vm._l((_vm.dashBoardMMPLinks), function(link) {
    return (_vm.isCurrentUserAdmin || _vm.isCurrentUserMMPWM || _vm.userInGroup(link.Group)) ? _c('li', [_c('a', {
      staticClass: "underlined",
      attrs: {
        "href": link.Url
      }
    }, [_c('span', [_vm._v(_vm._s(link.Title))])])]) : _vm._e()
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin || _vm.isCurrentUserMMPWM || _vm.userHasSharePoint()) ? _c('div', {
    staticClass: "flex-col"
  }, [_vm._m(2)]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header small"
  }, [_c('div', {
    staticClass: "cat-header"
  }, [_c('div', [_c('small', {
    staticClass: "strong text-uppercase"
  }, [_vm._v("MM Digital platform")])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-uppercase"
  }, [_c('div', {
    staticClass: "text-uppercase"
  }, [_c('span', {
    staticClass: "cat-wlc"
  }, [_vm._v("MM Digital platform")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header small"
  }, [_c('div', {
    staticClass: "cat-header"
  }, [_c('div', [_c('small', {
    staticClass: "strong text-uppercase"
  }, [_vm._v("MMP Digital platform")])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-uppercase"
  }, [_c('div', {
    staticClass: "text-uppercase"
  }, [_c('span', {
    staticClass: "cat-wlc"
  }, [_vm._v("MMP Digital platform")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header small"
  }, [_c('div', {
    staticClass: "cat-header"
  }, [_c('div', [_c('small', {
    staticClass: "strong text-uppercase"
  }, [_vm._v("MM SharePoint Extranet")])])]), _vm._v(" "), _c('h2', {
    staticClass: "text-uppercase"
  }, [_c('div', {
    staticClass: "text-uppercase"
  }, [_c('span', {
    staticClass: "cat-wlc"
  }, [_vm._v("MM SharePoint Extranet")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body small"
  }, [_vm._v("\n                    MM SharePoint Extranet\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('p', {
    staticClass: "margin-bottom4"
  }, [_vm._v("Links:")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline"
  }, [_c('li', [_c('a', {
    staticClass: "underlined",
    attrs: {
      "href": "https://extranet.mayr-melnhof.com"
    }
  }, [_c('span', [_vm._v("MM SharePoint Extranet")])])])])])])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('center', {
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "loading": _vm.showEmailSpinner,
      "color": "#aab0b3"
    }
  }), _vm._v(" "), (_vm.showEmailSpinner) ? _c('p', [_vm._v(_vm._s(_vm.labels.GENERATING_EMAIL))]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('center', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "loading": _vm.showSpinner,
      "color": "#aab0b3"
    }
  }), _vm._v(" "), (_vm.showSpinner) ? _c('p', [_vm._v(_vm._s(_vm.labels.SAVING_USER_SPINNER))]) : _vm._e(), _vm._v(" "), _c('pulse-loader', {
    attrs: {
      "loading": _vm.showEmailSpinner,
      "color": "#aab0b3"
    }
  }), _vm._v(" "), (_vm.showEmailSpinner) ? _c('p', [_vm._v(_vm._s(_vm.labels.GENERATING_EMAIL))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userLoadingError),
      expression: "userLoadingError"
    }],
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.labels.LOADING_USER_ERROR) + "\n    ")]), _vm._v(" "), (_vm.userLoaded) ? _c('div', [_c('div', {
    staticClass: "content col-lg-12 col-md-12"
  }, [_c('div', {
    staticClass: "card card-indent"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row py-1"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('FirstName')
    }
  }, [_vm._v(_vm._s(_vm.labels.FIRSTNAME) + " *")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.FirstName))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.FirstName),
      expression: "user.FirstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.FirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.FirstName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('FirstName'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('LastName')
    }
  }, [_vm._v(_vm._s(_vm.labels.LASTNAME) + " *")]), _vm._v(" "), (!_vm.editMode) ? _c('a', {
    staticClass: "record-check btn btn-transparent btn-size-24 btn-circle pull-right",
    attrs: {
      "href": "#",
      "title": "Profile Edit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toEditMode($event)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-edit"
  })]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.LastName))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.LastName),
      expression: "user.LastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.LastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.LastName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('LastName'))
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.isSabaUser) ? _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('FirstNameUnicode')
    }
  }, [_vm._v(_vm._s(_vm.labels.FIRSTNAME) + " (Unicode)")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.FirstNameUnicode))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.FirstNameUnicode),
      expression: "user.FirstNameUnicode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.FirstNameUnicode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.FirstNameUnicode = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('FirstNameUnicode'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('LastNameUnicode')
    }
  }, [_vm._v(_vm._s(_vm.labels.LASTNAME) + " (Unicode)")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.LastNameUnicode))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.LastNameUnicode),
      expression: "user.LastNameUnicode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.LastNameUnicode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.LastNameUnicode = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('LastNameUnicode'))
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.isSabaUser) ? _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Gender')
    }
  }, [_vm._v(_vm._s(_vm.labels.GENDER) + " *")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.Gender))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Gender),
      expression: "user.Gender"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.Gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("F")]), _vm._v(" "), _c('option', [_vm._v("M")])]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Gender'))
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Email')
    }
  }, [_vm._v(_vm._s(_vm.labels.EMAIL) + " *")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isNew) ? _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.user.Email
    }
  }, [_vm._v(_vm._s(_vm.user.Email))]) : _vm._e(), _vm._v(" "), (_vm.isNew & _vm.editMode) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Email),
      expression: "user.Email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Email = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode & _vm.isNew) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Email'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.ACCOUNT_NAME))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.Domain) + "\\" + _vm._s(_vm.user.SAMAccountName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Language')
    }
  }, [_vm._v(_vm._s(_vm.labels.LANGUAGE) + " *")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.getCountryCode(_vm.user.Language)))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Language),
      expression: "user.Language"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.Language = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languages), function(lang) {
    return _c('option', {
      key: lang.code,
      domProps: {
        "value": lang.code
      }
    }, [_vm._v(_vm._s(lang.countryCode))])
  })) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Language'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.PRINCIPAL_NAME))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.PrincipalName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.OU))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.OU))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('DisplayName')
    }
  }, [_vm._v(_vm._s(_vm.labels.CLASS_DISPLAY_NAME))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.DisplayName))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.DisplayName),
      expression: "user.DisplayName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.DisplayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.DisplayName = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('DisplayName'))
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Phone')
    }
  }, [_vm._v(_vm._s(_vm.labels.PHONE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Phone))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Phone),
      expression: "user.Phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Phone = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Phone'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Company')
    }
  }, [_vm._v(_vm._s(_vm.labels.COMPANY) + " "), (_vm.isNewSharePoint) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Company))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Company),
      expression: "user.Company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Company = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Company'))
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Country')
    }
  }, [_vm._v(_vm._s(_vm.labels.COUNTRY))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.country))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.CountryCode),
      expression: "user.CountryCode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.CountryCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.countryCodes), function(option) {
    return _c('option', {
      domProps: {
        "value": option.Value
      }
    }, [_vm._v("\n                          " + _vm._s(option.Text) + "\n                        ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Country'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Website')
    }
  }, [_vm._v(_vm._s(_vm.labels.WEBSITE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Website))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Website),
      expression: "user.Website"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Website = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Website'))
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Location')
    }
  }, [_vm._v(_vm._s(_vm.labels.LOCATION))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Location))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Location),
      expression: "user.Location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Location = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Location'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('State')
    }
  }, [_vm._v(_vm._s(_vm.labels.STATE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.State))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.State),
      expression: "user.State"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.State)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.State = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('State'))
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('PostalCode')
    }
  }, [_vm._v(_vm._s(_vm.labels.POSTAL_CODE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.PostalCode))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.PostalCode),
      expression: "user.PostalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.PostalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.PostalCode = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('PostalCode'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Street')
    }
  }, [_vm._v(_vm._s(_vm.labels.STREET))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Street))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Street),
      expression: "user.Street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Street = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Street'))
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('PersonalTitle')
    }
  }, [_vm._v(_vm._s(_vm.labels.PERSONAL_TITLE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.PersonalTitle))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.PersonalTitle),
      expression: "user.PersonalTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.PersonalTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.PersonalTitle = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('PersonalTitle'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Department')
    }
  }, [_vm._v(_vm._s(_vm.labels.DEPARTMENT))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.Department))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Department),
      expression: "user.Department"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.Department)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Department = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.isSabaUser) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Department),
      expression: "user.Department"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "90%",
      "display": "inline-block"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.Department = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sabaDepartments), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                            " + _vm._s(option) + "\n                          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Department'))
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.isSabaUser) ? _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('CostCenter')
    }
  }, [_vm._v(_vm._s(_vm.labels.COST_CENTER))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.CostCenter))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.CostCenter),
      expression: "user.CostCenter"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "90%",
      "display": "inline-block"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.CostCenter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sabaCostCenters), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                            " + _vm._s(option) + "\n                          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('CostCenter'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('JobTitle')
    }
  }, [_vm._v(_vm._s(_vm.labels.JOB_TITLE))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.user.JobTitle))]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.JobTitle),
      expression: "user.JobTitle"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "90%",
      "display": "inline-block"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.user.JobTitle = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sabaJobTitles), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                            " + _vm._s(option) + "\n                          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('JobTitle'))
    }
  }) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Description')
    }
  }, [_vm._v(_vm._s(_vm.labels.DESCRIPTION))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.editMode || _vm.isSabaUser) ? _c('span', [_vm._v(_vm._s(_vm.user.Description))]) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.Description),
      expression: "user.Description"
    }],
    staticClass: "form-control stop-resize",
    domProps: {
      "value": (_vm.user.Description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.Description = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Description'))
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.INFO))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.Info))])])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-bottom border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.USER_TYPE))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.ExtensionAttribute6))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.CANONICAL_NAME))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.user.CanonicalName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-gray-lightest border-bottom"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('ProxyAddresses')
    }
  }, [_vm._v(_vm._s(_vm.labels.PROXY_ADDRESSES))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.user.ProxyAddresses), function(proxyAddress, index) {
    return _c('div', {
      staticClass: "group-record"
    }, [_vm._v("\n                        " + _vm._s(proxyAddress) + "\n\n                        "), (_vm.editMode && _vm.isProxyAddressEditable(proxyAddress) && !_vm.isSabaUser) ? _c('a', {
      staticClass: "record-check btn btn-transparent btn-size-24 btn-circle pull-right",
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeProxyAddress(proxyAddress, index)
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-close"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedProxyAddressPrefix),
      expression: "selectedProxyAddressPrefix"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "20%",
      "display": "inline-block"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedProxyAddressPrefix = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.proxyAddressesPrefix), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                            " + _vm._s(option) + "\n                          ")])
  })), _vm._v(" "), _c('label', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proxyAddressValue),
      expression: "proxyAddressValue"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "70%",
      "display": "inline-block"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.proxyAddressValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.proxyAddressValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "record-check btn btn-transparent btn-size-24 btn-circle pull-right",
    staticStyle: {
      "color": "green",
      "top": "7px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addProxyAddress($event)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-plus"
  })])]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('ProxyAddresses'))
    }
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "fields-row border-gray-lightest",
    class: {
      'border-bottom': _vm.editMode && !_vm.isSabaUser
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "text-uppercase text-gray-lighter small",
    class: {
      'error': !_vm.isValid('Groups')
    }
  }, [_vm._v(_vm._s(_vm.labels.GROUPS))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.user.Groups), function(group, index) {
    return _c('div', {
      staticClass: "group-record"
    }, [_vm._v("\n                        " + _vm._s(group) + "\n\n                        "), (_vm.editMode && !_vm.isSabaUser && _vm.isGroupEditable(group)) ? _c('a', {
      staticClass: "record-check btn btn-transparent btn-size-24 btn-circle pull-right",
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeGroup(group, index)
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-close"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), _vm._v(" "), _c('div', [(_vm.editMode && !_vm.isSabaUser) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedGroup),
      expression: "selectedGroup"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "90%",
      "display": "inline-block"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedGroup = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableGroups), function(option) {
    return _c('option', {
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                            " + _vm._s(option) + "\n                          ")])
  })) : _vm._e(), _vm._v(" "), (_vm.editMode && !_vm.isSabaUser) ? _c('a', {
    staticClass: "record-check btn btn-transparent btn-size-24 btn-circle pull-right",
    staticStyle: {
      "color": "green",
      "top": "7px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addGroup($event)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-plus"
  })]) : _vm._e()]), _vm._v(" "), (_vm.editMode) ? _c('span', {
    staticClass: "smaller alert-danger",
    domProps: {
      "textContent": _vm._s(_vm.propertyError('Groups'))
    }
  }) : _vm._e()], 2)])]), _vm._v(" "), (_vm.editMode && _vm.summaryErrors && _vm.summaryErrors.length > 0) ? _c('div', {
    staticClass: "fields-row border-gray-lightest border-bottom"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.summaryErrors), function(item) {
    return _c('div', {
      staticClass: "smaller alert-danger"
    }, [_vm._v("\n                        " + _vm._s(item) + "\n                      ")])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('div', {
    staticClass: "pt-1 pb-1 border-gray-lightest"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveUser
    }
  }, [_vm._v(_vm._s(_vm.labels.SAVE))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.cancelEditMode
    }
  }, [_vm._v(_vm._s(_vm.labels.CANCEL))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('center', [_c('div', [_c('div', {
    staticClass: "photo-container",
    class: {
      'white-border': !_vm.editMode || _vm.isSabaUser
    },
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "96px",
      "max-height": "96px",
      "position": "absolute",
      "margin": "auto",
      "top": "0",
      "left": "0",
      "right": "0",
      "bottom": "0"
    },
    attrs: {
      "src": _vm.photoSrc
    }
  }), _vm._v(" "), (_vm.editMode) ? _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/jpeg"
    },
    on: {
      "change": _vm.onPhotoInputChange
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(_vm.editMode) ? _c('a', {
    staticClass: "btn min-width-96 btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.browseImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.BROWSE))]) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.user.ThumbnailPhoto) ? _c('a', {
    staticClass: "btn min-width-96 btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeImage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.REMOVE))]) : _vm._e()])])])], 1)])])]), _vm._v(" "), (!_vm.isNew) ? _c('div', {
    staticClass: "card card-default card-indent"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row py-1"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('strong', {
    staticClass: "text-uppercase text-gray-lighter small"
  }, [_vm._v(_vm._s(_vm.labels.USER_STATUS) + ": " + _vm._s(_vm.user.IsActive ? _vm.labels.ACTIVE : _vm.labels.INACTIVE))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isSabaUser && !_vm.user.IsActive) ? _c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activateUser($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.ACTIVATE))]) : _vm._e(), _vm._v(" "), (!_vm.isSabaUser && _vm.user.IsActive) ? _c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deactivateUser($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.DEACTIVATE))]) : _vm._e(), _vm._v(" "), (_vm.isSabaUser && _vm.user.Locked) ? _c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.unlockUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.UNLOCK))]) : _vm._e(), _vm._v(" "), (_vm.isSabaUser) ? _c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SET_PASSWORD))]) : _vm._e(), _vm._v(" "), (!_vm.isSabaUser) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.hasDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('MMID')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_DIGI))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('MMID')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('MMID', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_DIGI_NO_PASS))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('MMID', true)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasMMPDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('MMPDigi')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_MMP))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('MMPDigi')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasMMPDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('MMPDigi', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_MMP_NO_PASS))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('MMPDigi', true)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasSharePointGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('Sharepoint')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_EXTRANET))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('Sharepoint')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasSharePointGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendWelcomeEmail('Sharepoint', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_EXTRANET_NO_PASS))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getWelcomeEmailPreview('Sharepoint', true)
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isSabaUser && _vm.user.IsActive) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('a', {
    staticClass: "btn min-width-96 btn-warning",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendForgotPasswordEmail('None')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_GENERIC))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getForgotPasswordEmailPreview('None')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.hasDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendForgotPasswordEmail('MMID')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_DIGI))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getForgotPasswordEmailPreview('MMID')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasMMPDigiGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendForgotPasswordEmail('MMPDigi')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_MMP))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getForgotPasswordEmailPreview('MMPDigi')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasSharePointGroups) ? _c('li', {
    staticClass: "item-with-info"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendForgotPasswordEmail('Sharepoint')
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_EXTRANET))]), _vm._v(" "), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getForgotPasswordEmailPreview('Sharepoint')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()])]) : _vm._e()])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "height": "auto",
      "scrollable": true,
      "width": "650px"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-chevron-bottom",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-chevron-bottom",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
}]}

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.activeClass
  }, [_c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('button', {
    staticClass: "sidebar-toggler",
    on: {
      "click": _vm.showSideBar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-nav",
    attrs: {
      "data-mcs-theme": "light"
    }
  }, [_c('ul', {
    staticClass: "nav-main",
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', [_c('a', {
    class: {
      active: _vm.isDashboard
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showDashboard($event)
      }
    }
  }, [_vm._m(0), _vm._v(" " + _vm._s(_vm.labels.DASHBOARD_TEXT) + "\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "collapse-icon collapse",
    attrs: {
      "data-toggle": "collapse"
    },
    on: {
      "click": function($event) {
        _vm.collapseElement($event, 'navMainProducts')
      }
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-chevron-bottom pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v("\n            " + _vm._s(_vm.actionText) + "\n          ")]), _vm._v(" "), _c('ul', {
    ref: "navMainProducts",
    staticClass: "collapse in",
    attrs: {
      "id": "navMainProducts"
    }
  }, [(!_vm.isCurrentUserAdmin && !_vm.isCurrentUserMMPWM) ? _c('li', [_c('a', {
    class: {
      active: _vm.isChangePassword
    },
    on: {
      "click": function($event) {
        _vm.showChangePassword($event, _vm.actionText, _vm.changePasswordText)
      }
    }
  }, [_vm._v(_vm._s(_vm.changePasswordText))])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin || _vm.isCurrentUserMMPWM) ? _c('li', [_c('a', {
    class: {
      active: _vm.isUsersList
    },
    on: {
      "click": function($event) {
        _vm.showUsersList($event, _vm.actionText, _vm.usersListText)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.usersListText))])]) : _vm._e()])]), _vm._v(" "), _c('li')])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('i', {
    staticClass: "mmk-icon mmk-icon-32 mmk-icon-book-image",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.openedPoint))])])]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.openedSubPoint))])])]), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nav-icon btn btn-size-32"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-home",
    attrs: {
      "aria-hidden": "false"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nav-icon btn btn-size-32"
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-book-image",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[1]);


// WEBPACK FOOTER //
// static/js/app.ff8da7674d8847f9b115.js